import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import add from "../../../images/add.svg";
import minus from "../../../images/minus.svg";
import info from "../../../images/info.svg";
import buyicon from "../../../images/buy-icon.svg";
import sellicon from "../../../images/sell-icon.svg";
import dashrighticon01 from "../../../images/dash-right-icon01.svg";
import dashrighticon06 from "../../../images/dash-right-icon06.svg";
import dashrighticon08 from "../../../images/dash-right-icon08.svg";
import dashrighticon07 from "../../../images/dash-right-icon07.svg";
import telegram2line from "../../../images/telegram-2-line.svg";
import up from "../../../images/up.svg";
import Down from "../../../images/selliconred.svg";
import Payout from "../../../images/Payout.svg";
import Profit from "../../../images/Profit.svg";
import Forecast from "../../../images/Forecast.svg";
import tradegraph from "../../../images/trade-graph.svg";
import rankingstaricon02 from "../../../images/ranking-star-icon02.svg";
import ninjacoin from "../../../images/ninja-coin.svg";
import rankingstaricon01 from "../../../images/ranking-star-icon01.svg";
import rankingstaricon03 from "../../../images/ranking-star-icon03.svg";
import hotkeys from "../../../images/Keyboardhotkey.png";
import { v4 as uuidv4 } from "uuid";
import user from "../../../images/user.png";
import { Link } from "react-router-dom";
import {
  handleToggleCollapse,
  useHoverEffect,
  useModal,
} from "../../common/Collapsfunction";
import { useSelector } from "react-redux";
import { authcallApi, authcallApipost, callApi } from "../../common/API/Api";
import { Container, Dropdown } from "react-bootstrap";
import {
  showErrorToast,
  showProcessToast,
  updateToastMessage,
} from "../../common/Tostify";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../common/Notification";
import { getServerTime } from "./commonmodal/Getservertime";
import {
  formatPrice,
  formatPricewithdesimal,
  unformatPrice,
} from "../../common/formatPrice";
import Bitcoin from "../../../images/bitcoin-icon.svg";
import DatePicker from "react-date-picker";
import CommonSpinner from "../../common/CommonSpinner";
import { WebSocketContext } from "../../common/API/WebSocketProvider";
import { convertLocalToUTCFormatted } from "./commonmodal/Formatedtime";
import { formatName } from "../../common/nameFormatter";
import { getBaseUrl } from "../../common/BaseUrl";
const Dashboardrightsidemenus = (props) => {
  const { showNotification } = useNotification();
  const { message } = useContext(WebSocketContext);
  const MIN_CLOSE_TIME_SECONDS = 5;
  const MAX_CLOSE_TIME_SECONDS = 4 * 60 * 60; // 4 hours = 14400 sec
  const { t } = useTranslation();
  const [history, setHistory] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isClicked, setIsClicked] = useState({
    timer: false,
    plus: false,
    minus: false,
    asset_name: false,
  });
  const inputRef = useRef(null);
  const [visibleItems, setVisibleItems] = useState([]);
  const [timeerror, setTimeError] = useState("");
  const [copybuttion, setCopybuttion] = useState(false);
  const [watchmecount, setWatchmecount] = useState(0);
  const [openIndex, setOpenIndex] = useState(null);
  const [checkleaderboaed, setCheckleaderboard] = useState({
    hide_leaderboaed: false,
    rank: false,
  });
  const amountbuttionref = useRef(false);
  const [openindexCollapseKey, setIndexOpenCollapseKey] = useState(null);
  const [copyhistorylist, setCopyhistorylist] = useState([]);
  const [searchfilter, setSearchfilter] = useState("");
  const collapseRef = useRef(null);
  const nextGetTimeRef = useRef(null);
  const [closetradetime, setClosetradetime] = useState(null);
  const collapseleaderboardRef = useRef(null);
  const [allCopyZero, setAllCopyZero] = useState();
  const amountcollapseRef = useRef(null);
  const [openCollapseKey, setOpenCollapseKey] = useState(null);
  const [closeCollapseKey, setCloseCollapseKey] = useState(null);
  const [searchfilterdata, setSearchfilterdata] = useState([]);
  const [blockcopylist, setBlockcopylist] = useState([]);
  const [blocklistcount, setBlocklistcount] = useState(0);
  const [swetchtimer, setSwetchtimer] = useState(1);
  const [checkclosetime, setCheckclosetime] = useState(null);
  const [checktimeOffset, setChecktimeOffset] = useState(true);
  const [GetclosetimeTime, setGetclosetimeTime] = useState({
    hour: "",
    minute: "",
    second: "",
  });

  const [modelloading, setModelloading] = useState(false);
  const [showcopydeleteicon, setShowcopydeleteicon] = useState(false);
  const [checkcurrcenttime, setCheckcurrcenttime] = useState(false);
  const [socialTradingSettings, setSocialTradingSettings] = useState();
  const settingLabels = {
    // displaySocialTrades: "Display social trades",
    watchingCopiedTrades: t("Watching copied trades"),
    hideCopyingStatistics: t("Hide copying and statistics of my profile"),
    hideWatchingTrading: t("Hide watching of my trading"),
    showOnlyWatchedTraders: t("Show only watched traders"),
  };
  const socialdroplist = [
    {
      key: "recommended",
      icon: "fa-solid fa-award",
      label: "Top recommended traders",
    },
    { key: "rank", icon: "fa-regular fa-star", label: "Leaderboard" },
    { key: "search", icon: "fa-solid fa-magnifying-glass", label: "Search" },
    {
      key: "copied_me",
      icon: "fa-regular fa-copy",
      label: "List of copied traders",
    },
    {
      key: "i_am_copied",
      icon: "fa-solid fa-share",
      label: "Trader who copy me",
    },
    {
      key: "i_am_watching",
      icon: "fa-solid fa-eye",
      label: "List of watched traders",
    },
    {
      key: "watching_me",
      icon: "fa-solid fa-rss",
      label: "Trader who watch me",
    },
    { key: "settings", icon: "fa-solid fa-gear", label: "Settings" },
  ];
  const [calculateamount, setCalculateamount] = useState(2);
  const [socialfilter, setSocialfilter] = useState({
    key: "recommended",
    icon: "fa-solid fa-award",
    label: "Top recommended traders",
  });
  const [loadingsocial, setLoadingSocial] = useState(false);
  const [searchloading, setSearchloading] = useState(false);
  let base_url = getBaseUrl();
  const walletdata = useSelector((state) => state.data.value);
  const livewalletdata = useSelector((state) => state.userwallet.info);
  const [selectedOption, setSelectedOption] = useState("today");
  const [isOpen, setIsOpen] = useState(false);
  const [socialtype, setSocialtype] = useState(false);
  const dropdownRef = useRef(null);
  const currenttimecheckRef = useRef(null);
  const {
    handleBuy,
    setDefaultwidth,
    defaultwith,
    seriesRef,
    opentrade,
    checkclosetrade,
    closelimit,
    tradestyle,
    getsocialwatch,
    setWallupdate,
    cryptocurrencieslist,
    chnagetype,
    opentradedata,
    classNameicMode,
    chnagetyperef,
    currencieslist,
    checkliveaccount,
    showgraphsvg,
    valueSeriesref,
    setSearchpopup,
    searchpopup,
    showLineAnimation,
    getFutureTimestamp,
    onHoverType,
    websoketrunning,
    userDetails,
    currenttimecheck,
    updatetimezone,
    peandingtrade,
    callclosetradeapi,
    assetlist,
    setshowtradeasset,
    setChartLoader,
    closetradeapirun,
    setShowcopytrades,
  } = props;
  const watchusersref = useRef([]);
  const { modalRefs, openModal } = useModal();
  const [isOnScroll, setIsOnScroll] = useState(false);
  const [isHovering, setIsHovering] = useState(false); // new state for hover
  const [isBgScroll, setIsBgScroll] = useState(false);
  const [copycount, setCopycount] = useState(0);
  const [sidebaractive, setCollapseshow] = useState({
    tradesSidebarCollapse: false,
    socialTradingCollapse: false,
    pendingTradesCollapse: false,
  });
  const { isHovered, handleMouseEnter, handleMouseLeave } = useHoverEffect();
  const [activekeys, setActivekeys] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sociallist, setSociallist] = useState([]);
  const [leaderboarddata, setLeaderboarddata] = useState([]);
  const [pricetradelist, setpricetradelist] = useState([]);
  const [serverTime, setServerTime] = useState(null);
  const [userdata, setUserdata] = useState();
  const [userfilter, setUserfilter] = useState();
  const [currentuser, setCurrentuser] = useState();
  const [gettopperdata, setTopperdata] = useState([]);
  const [pendingbytime, setPendingbytime] = useState({
    payout: "",
    amount: 1,
    asset: "",
    opentime: new Date().toISOString().split("T")[0],
  });
  const [pendingbyprice, setPendingbyprice] = useState({
    payout: "",
    amount: 1,
    asset: "",
  });
  const [checkcopy, setCheckcopy] = useState(false);
  const [copysetting, setcopysetting] = useState({
    proportion: 100,
    stop_balance: 1,
    max_copy_trade_value: 0,
    min_trade_amount: 1,
    copy_user_id: "",
    min_totel_amount: "",
    checkminamount: false,
    max_totel_amount: "",
    checkmaxamount: false,
    bothamount_error: false,
  });
  const [checkcopytrade, setCheckcopytrade] = useState(false);
  const [showcopyhistory, setShowCopyhistory] = useState(false);
  useEffect(() => {
    const fetchServerTime = async () => {
      const data = await getServerTime();

      if (data?.success) {
        setServerTime(data);
      }
    };
    //  let currenttimmer = setInterval(() => {
    fetchServerTime();
    // }, 1000);
    // return () => clearInterval(currenttimmer);
  }, []);
  const buytheprice = (key, value) => {
    if (key === "asset") {
      setPendingbyprice((state) => ({
        ...state,
        asset: `${value?.sortname}/${value?.csymbol}`,
        trade_type: value?.type,
      }));
    } else {
      setPendingbyprice((state) => ({
        ...state,
        [key]: value,
      }));
    }
  };
  const handleCopy = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      showNotification("Copied to clipboard!", "success");
    });
  };
  const buythetime = (key, value) => {
    if (key === "asset") {
      setPendingbytime((state) => ({
        ...state,
        asset: `${value?.sortname}/${value?.csymbol}`,
        trade_type: value?.type,
        payout: value?.payout,
      }));
    } else {
      setPendingbytime((state) => ({
        ...state,
        [key]: value,
      }));
    }
  };
  useEffect(() => {
    const isAnyTrue = Object.values(sidebaractive).includes(true);
    setDefaultwidth(isAnyTrue);
  }, [sidebaractive]);

  const [amount, setAmount] = useState();
  const [amountInput, setAmountInput] = useState("");
  const [peramount, setPeramount] = useState();
  const [closedata, setClosdata] = useState({});
  const [loadingclosetrade, setCloseloadingtrade] = useState(false);
  const [pendingtrade, setPendingtrade] = useState([]);
  const [time, setTime] = useState();
  const [pendingtime, setPendingtime] = useState({
    hours: "00",
    minutes: "01",
    secound: "00",
  });
  const [pendingpricetime, setPendingpricetime] = useState({
    hours: "00",
    minutes: "01",
    secound: "00",
  });
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const priceupdate = (update) => {
    let intptice = parseInt(amount);
    let step;

    if (intptice < 10) {
      step = 1;
    } else if (intptice < 50) {
      step = 5;
    } else if (intptice < 100) {
      step = 10;
    } else if (intptice < 500) {
      step = 50;
    } else {
      step = 100;
    }

    if (update === "add") {
      setAmount(intptice + step);
      timepriceprefrence(intptice + step);
    } else {
      if (intptice > 1) {
        let newAmount = intptice - step;
        if (newAmount < 1) {
          newAmount = 1;
        }
        setAmount(newAmount);
        timepriceprefrence(newAmount);
      }
    }
  };
  const timeset = (hours, minutes, secound) => {
    if (hours === "00" && minutes === "00" && Number(secound) < 5) {
      return;
    }
    setTime((state) => ({
      ...state,
      hours: hours,
      minutes: minutes,
      secound: secound,
    }));
    timeprefrence({
      hours: hours,
      minutes: minutes,
      secound: secound,
    });
  };
  const pendingtimeset = (hours, minutes, secound) => {
    if (hours === "00" && minutes === "00" && Number(secound) < 5) {
      return;
    }
    setPendingtime((state) => ({
      ...state,
      hours: hours,
      minutes: minutes,
      secound: secound,
    }));
  };
  const pendingtimeprice = (hours, minutes, secound) => {
    if (hours === "00" && minutes === "00" && Number(secound) < 5) {
      return;
    }
    setPendingpricetime((state) => ({
      ...state,
      hours: hours,
      minutes: minutes,
      secound: secound,
    }));
  };
  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    setIsOnScroll(scrollTop > 1);
    // setIsBgScroll(scrollTop > 200);
  };

  const updowntime = (updatetime, timetype, type) => {
    const formatTime = (value) => String(value).padStart(2, "0");

    let inthours;
    let intmin;
    let intsec;

    // Same existing flow
    if (type === "pendingbytime") {
      inthours = parseInt(pendingtime?.hours, 10) || 0;
      intmin = parseInt(pendingtime?.minutes, 10) || 0;
      intsec = parseInt(pendingtime?.secound, 10) || 0;
    } else if (type === "pendingbytimeprice") {
      inthours = parseInt(pendingpricetime?.hours, 10) || 0;
      intmin = parseInt(pendingpricetime?.minutes, 10) || 0;
      intsec = parseInt(pendingpricetime?.secound, 10) || 0;
    } else {
      inthours = parseInt(time?.hours, 10) || 0;
      intmin = parseInt(time?.minutes, 10) || 0;
      intsec = parseInt(time?.secound, 10) || 0;
    }

    let newHours = inthours;
    let newMinutes = intmin;
    let newSeconds = intsec;

    // Same existing flow
    if (timetype === "hours") {
      newHours = updatetime === "add" ? inthours + 1 : inthours - 1;

      if (newHours < 0) {
        newHours = 0;
      }
    } else if (timetype === "minutes") {
      newMinutes = updatetime === "add" ? intmin + 1 : intmin - 1;

      if (newMinutes > 59) {
        newMinutes = 0;
        newHours += 1;
      } else if (newMinutes < 0) {
        newMinutes = 59;
        newHours -= 1;

        if (newHours < 0) {
          newHours = 0;
          newMinutes = 0;
        }
      }
    } else if (timetype === "secound") {
      newSeconds = updatetime === "add" ? intsec + 1 : intsec - 1;

      if (newSeconds > 59) {
        newSeconds = 0;
        newMinutes += 1;

        if (newMinutes > 59) {
          newMinutes = 0;
          newHours += 1;
        }
      } else if (newSeconds < 0) {
        newSeconds = 59;
        newMinutes -= 1;

        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;

          if (newHours < 0) {
            newHours = 0;
            newMinutes = 0;
            newSeconds = 5;
          }
        }
      }
    }

    // ------------------------------------------------
    // FINAL VALIDATION
    // Minimum: 00:00:05
    // Maximum: 04:00:00
    // ------------------------------------------------

    // More than 4 hours -> 04:00:00
    if (newHours > 4) {
      newHours = 4;
      newMinutes = 0;
      newSeconds = 0;
    }

    // Exactly 4 hours -> seconds/minutes cannot be greater
    if (newHours === 4) {
      newMinutes = 0;
      newSeconds = 0;
    }

    // Less than 5 seconds -> 00:00:05
    if (newHours === 0 && newMinutes === 0 && newSeconds < 5) {
      newHours = 0;
      newMinutes = 0;
      newSeconds = 5;
    }

    const updatedTime = {
      hours: formatTime(newHours),
      minutes: formatTime(newMinutes),
      secound: formatTime(newSeconds),
    };

    // Same existing state flow
    if (type === "pendingbytime") {
      setPendingtime((state) => ({
        ...state,
        ...updatedTime,
      }));
    } else if (type === "pendingbytimeprice") {
      setPendingpricetime((state) => ({
        ...state,
        ...updatedTime,
      }));
    } else {
      setTime((state) => ({
        ...state,
        ...updatedTime,
      }));

      timeprefrence(updatedTime);
    }
  };

  // const updowntime = (updatetime, timetype, type) => {
  //   const formatTime = (value) => String(value).padStart(2, "0");
  //   let inthours;
  //   let intmin;
  //   let intsec;
  //   if (type === "pendingbytime") {
  //     inthours = parseInt(pendingtime?.hours);
  //     intmin = parseInt(pendingtime?.minutes);
  //     intsec = parseInt(pendingtime?.secound);
  //   } else if (type === "pendingbytimeprice") {
  //     inthours = parseInt(pendingpricetime?.hours);
  //     intmin = parseInt(pendingpricetime?.minutes);
  //     intsec = parseInt(pendingpricetime?.secound);
  //   } else {
  //     inthours = parseInt(time?.hours);
  //     intmin = parseInt(time?.minutes);
  //     intsec = parseInt(time?.secound);
  //   }

  //   let newHours = inthours;
  //   let newMinutes = intmin;
  //   let newSeconds = intsec;
  //   if (timetype === "hours") {
  //     newHours = updatetime === "add" ? inthours + 1 : inthours - 1;
  //     if (newHours < 0) {
  //       newHours = 0;
  //     }
  //   } else if (timetype === "minutes") {
  //     newMinutes = updatetime === "add" ? intmin + 1 : intmin - 1;

  //     if (newMinutes > 59) {
  //       newMinutes = 0;
  //       newHours += 1;
  //     } else if (newMinutes < 0) {
  //       newMinutes = 59;
  //       newHours -= 1;

  //       if (newHours < 0) {
  //         newHours = 0;
  //         newMinutes = 0;
  //       }
  //     }
  //   } else if (timetype === "secound") {
  //     newSeconds = updatetime === "add" ? intsec + 1 : intsec - 1;
  //     if (newSeconds > 59) {
  //       newSeconds = 0;
  //       newMinutes += 1;
  //     } else if (newSeconds < 0) {
  //       newSeconds = 59;
  //       newMinutes -= 1;
  //       if (newMinutes < 0) {
  //         newMinutes = 59;
  //         newHours -= 1;
  //         if (newHours < 0) {
  //           newHours = 0;
  //           newMinutes = 0;
  //         }
  //       }
  //     }
  //   }
  //   if (type === "pendingbytime") {
  //     if (newHours === 0 && newMinutes === 0 && newSeconds === 0) {
  //       setPendingtime((state) => ({
  //         ...state,
  //         hours: formatTime(4),
  //         minutes: formatTime(0),
  //         secound: formatTime(0),
  //       }));
  //     } else {
  //       setPendingtime((state) => ({
  //         ...state,
  //         hours: formatTime(newHours),
  //         minutes: formatTime(newMinutes),
  //         secound: formatTime(newSeconds),
  //       }));
  //     }
  //   } else if (type === "pendingbytimeprice") {
  //     if (newHours === 0 && newMinutes === 0 && newSeconds === 0) {
  //       setPendingpricetime((state) => ({
  //         ...state,
  //         hours: formatTime(4),
  //         minutes: formatTime(0),
  //         secound: formatTime(0),
  //       }));
  //     } else {
  //       setPendingpricetime((state) => ({
  //         ...state,
  //         hours: formatTime(newHours),
  //         minutes: formatTime(newMinutes),
  //         secound: formatTime(newSeconds),
  //       }));
  //     }
  //   } else {
  //     if (newHours === 0 && newMinutes === 0 && newSeconds === 0) {
  //       setTime((state) => ({
  //         ...state,
  //         hours: formatTime(4),
  //         minutes: formatTime(0),
  //         secound: formatTime(0),
  //       }));
  //       timeprefrence({
  //         hours: formatTime(4),
  //         minutes: formatTime(0),
  //         secound: formatTime(0),
  //       });
  //     } else if (newHours === 0 && newMinutes === 0 && newSeconds < 5) {
  //       setTime((state) => ({
  //         ...state,
  //         hours: formatTime(newHours),
  //         minutes: formatTime(newMinutes),
  //         secound: formatTime(5),
  //       }));
  //       timeprefrence({
  //         hours: formatTime(newHours),
  //         minutes: formatTime(newMinutes),
  //         secound: formatTime(5),
  //       });
  //     } else if (newHours > 4) {
  //       setTime((state) => ({
  //         ...state,
  //         hours: formatTime(4),
  //         minutes: formatTime(0),
  //         secound: formatTime(0),
  //       }));
  //       timeprefrence({
  //         hours: formatTime(4),
  //         minutes: formatTime(0),
  //         secound: formatTime(0),
  //       });
  //     } else {
  //       setTime((state) => ({
  //         ...state,
  //         hours: formatTime(newHours),
  //         minutes: formatTime(newMinutes),
  //         secound: formatTime(newSeconds),
  //       }));
  //       timeprefrence({
  //         hours: formatTime(newHours),
  //         minutes: formatTime(newMinutes),
  //         secound: formatTime(newSeconds),
  //       });
  //     }
  //   }
  // };
  useEffect(() => {
    if (parseInt(pendingpricetime?.minutes) > 59) {
      setPendingpricetime((state) => ({
        ...state,
        hours: pendingpricetime?.hours,
        minutes: "59",
        secound: pendingpricetime?.secound,
      }));
    }
    if (parseInt(pendingpricetime?.secound) > 59) {
      setPendingpricetime((state) => ({
        ...state,
        hours: pendingpricetime?.hours,
        minutes: pendingpricetime?.minutes,
        secound: "59",
      }));
    }
  }, [pendingpricetime]);
  useEffect(() => {
    if (parseInt(pendingtime?.minutes) > 59) {
      setPendingtime((state) => ({
        ...state,
        hours: pendingtime?.hours,
        minutes: "59",
        secound: pendingtime?.secound,
      }));
    }
    if (parseInt(pendingtime?.secound) > 59) {
      setPendingtime((state) => ({
        ...state,
        hours: pendingtime?.hours,
        minutes: pendingtime?.minutes,
        secound: "59",
      }));
    }
  }, [pendingtime]);
  useEffect(() => {
    if (parseInt(time?.minutes) > 59) {
      setTime((state) => ({
        ...state,
        hours: time?.hours,
        minutes: "59",
        secound: time?.secound,
      }));
      timeprefrence({
        hours: time?.hours,
        minutes: "59",
        secound: time?.secound,
      });
    }
    if (parseInt(time?.secound) > 59) {
      setTime((state) => ({
        ...state,
        hours: time?.hours,
        minutes: time?.minutes,
        secound: "59",
      }));
      timeprefrence({
        hours: time?.hours,
        minutes: time?.minutes,
        secound: "59",
      });
    }
  }, [time]);

  useEffect(() => {
    if (walletdata) {
      const intnumber = parseFloat(walletdata.replace(/,/g, ""));
      if (intnumber < 1) {
        setAmount(1);
        timepriceprefrence(1);
        return;
      }
      if (intnumber < amount) {
        setAmount(intnumber);
        timepriceprefrence(intnumber);
        setPeramount((intnumber * parseInt(chnagetype?.payout)) / 100);
      } else if (amount > 20000) {
        setAmount(20000);
        timepriceprefrence(20000);
      } else {
        setPeramount((amount * parseInt(chnagetype?.payout)) / 100);
      }
    } else {
      setPeramount((amount * parseInt(chnagetyperef?.current?.payout)) / 100);
    }
  }, [amount, chnagetype]);
  useEffect(() => {
    if (walletdata) {
      const intnumber = parseFloat(walletdata.replace(/,/g, ""));
      if (intnumber > 1 && amount < 1) {
        setAmount(1);
      }
    }
  }, [walletdata]);
  let lastKey = null;

  const handleKeyDown = (e) => {
    lastKey = e.key;
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/[^0-9.]/g, "");
    const parts = numericValue.split(".");
    if (parts.length > 2) return;
    if (parts[1]?.length > 2) return;
    if (lastKey === "Backspace" && /^\d+\.0$/.test(numericValue)) {
      const intValue = parseInt(numericValue);
      setAmount(intValue.toString());
      timepriceprefrence(intValue.toString());
      return;
    }
    if (lastKey === "Backspace" && numericValue.endsWith(".")) {
      const withoutDot = numericValue.slice(0, -1);
      setAmount(withoutDot);
      timepriceprefrence(withoutDot);
      return;
    }
    if (numericValue === "" || numericValue === "0" || numericValue === "0.") {
      setAmount("0");
      timepriceprefrence("0");
    } else if (
      numericValue.startsWith("0") &&
      !numericValue.startsWith("0.") &&
      numericValue.length > 1
    ) {
      const cleaned = numericValue.replace(/^0+/, "");
      setAmount(cleaned);
      timepriceprefrence(cleaned);
    } else {
      const floatVal = parseFloat(numericValue);
      if (!isNaN(floatVal) && floatVal >= 1) {
        setAmount(numericValue);
        timepriceprefrence(numericValue);
      } else {
        setAmount("1");
        timepriceprefrence("1");
      }
    }
  };
  const handleBlur = () => {
    let convertstring = typeof amount === "string" ? amount : amount.toString();

    if (
      convertstring === "" ||
      convertstring === "0" ||
      convertstring === "0." ||
      Number(convertstring) < 1
    ) {
      setAmount("1");
      timepriceprefrence("1");
    } else if (convertstring.endsWith(".")) {
      const updatedAmount = convertstring.slice(0, -1);
      setAmount(updatedAmount);
      timepriceprefrence(updatedAmount);
    } else if (/^\d+\.0$/.test(convertstring)) {
      const intValue = parseInt(convertstring);
      setAmount(intValue.toString());
      timepriceprefrence(intValue.toString());
    }
  };
  function groupTradesByLocalDate(trades, timezone) {
    const sign = timezone.plus === "+" ? 1 : -1;
    const hourOffset = parseInt(timezone.haur) * sign;
    const minuteOffset = parseInt(timezone.minute) * sign;
    const grouped = {};
    trades.forEach((trade) => {
      let [datePart, timePart] = trade.close_time.split(" ");
      let [year, month, day] = datePart.split("-").map(Number);
      let [hour, minute, second] = timePart.split(":").map(Number);
      hour += hourOffset;
      minute += minuteOffset;
      while (minute < 0) {
        minute += 60;
        hour -= 1;
      }
      while (minute >= 60) {
        minute -= 60;
        hour += 1;
      }
      while (hour < 0) {
        hour += 24;
        day -= 1;
      }
      while (hour >= 24) {
        hour -= 24;
        day += 1;
      }
      const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (day > daysInMonth[month - 1]) {
        day = 1;
        month += 1;
      }
      if (day < 1) {
        month -= 1;
        day = daysInMonth[month - 1];
      }
      if (month > 12) {
        month = 1;
        year += 1;
      }
      if (month < 1) {
        month = 12;
        year -= 1;
      }
      const localDate = `${year.toString().padStart(4, "0")}-${month
        .toString()
        .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

      if (!grouped[localDate]) grouped[localDate] = [];
      grouped[localDate].push(trade);
    });

    return grouped;
  }
  const openclosetrade = async () => {
    try {
      // if (!checkclosetrade?.length && !closetradeapirun?.current) {
      //   setCloseloadingtrade(true);
      // }
      if (!checkclosetrade?.length) {
        setCloseloadingtrade(true);
      }
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/gettrade?status=close&account_type=${
          checkliveaccount ? "demo" : "real"
        }&pending_trades=0&limit=${10}`,
        "GET",
      );
      if (res?.data?.success) {
        const groupedTrades = groupTradesByLocalDate(
          res?.data?.trade,
          updatetimezone,
        );
        const validDatePattern = /^\d{4}-\d{2}-\d{2}$/;

        const filteredGroupedTrades = Object.fromEntries(
          Object.entries(groupedTrades).filter(([date]) =>
            validDatePattern.test(date),
          ),
        );
        if (checkclosetrade?.length) {
          let upadtedclose = mergeByDate(
            filteredGroupedTrades,
            checkclosetrade,
            updatetimezone,
          );
          const validDatePattern = /^\d{4}-\d{2}-\d{2}$/;
          const filteredGroupedTrades = Object.fromEntries(
            Object.entries(upadtedclose).filter(([date]) =>
              validDatePattern.test(date),
            ),
          );
          setClosdata(filteredGroupedTrades);
        } else {
          setClosdata(filteredGroupedTrades);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setCloseloadingtrade(false);
    }
  };
  //  useEffect(() => {
  //   const handleResume = () => {
  //     if (!document.hidden) {
  //       openclosetrade();
  //       console.log("Page resumed or visible again!");
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleResume);
  //   window.addEventListener("focus", handleResume);
  //   window.addEventListener("pageshow", handleResume);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleResume);
  //     window.removeEventListener("focus", handleResume);
  //     window.removeEventListener("pageshow", handleResume);
  //   };
  // }, []);
  const getpendingpricetrade = async () => {
    setWallupdate(false);
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/gettrade?status=pending&account_type=${
          checkliveaccount ? "demo" : "real"
        }&pending_trades=2`,
        "GET",
      );
      if (res?.data?.success) {
        setpricetradelist(res?.data?.trade);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getpendingtrade = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/gettrade?status=pending&account_type=${
          checkliveaccount ? "demo" : "real"
        }&pending_trades=1`,
        "GET",
      );
      if (res?.data?.success) {
        tradetimmer(res?.data?.trade);
        setWallupdate(true);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getpendingpricetrade();
    getpendingtrade();
  }, [peandingtrade]);
  function convertTimestamp(timestamp) {
    const date = new Date(timestamp);
    date.setMinutes(date.getMinutes());
    const formattedDate = date.toISOString().slice(0, 19).replace("T", " ");
    return formattedDate;
  }
  function convertTimestampToLocal(timestamp) {
    const utcDate = new Date(timestamp);
    const localDate = new Date(
      utcDate.getTime() + utcDate.getTimezoneOffset() * -60 * 1000,
    );
    const formattedDate = localDate
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    return formattedDate;
  }
  const timeoutRef = useRef(null);
  const tradeoutRef = useRef(null);
  const pricetrade = (timetrade) => {
    if (tradeoutRef.current) {
      clearTimeout(tradeoutRef.current);
    }
    let updatedtrade = [...timetrade];
    let updtaetrade = () => {
      // let data = seriesRef.current ? seriesRef.current.data() : [];
      let lastdata = valueSeriesref.current
        ? valueSeriesref.current.data.getIndex(
            valueSeriesref.current.data.length - 1,
          )
        : "";
      if (updatedtrade?.length) {
        updatedtrade.map((result, key) => {
          if (result?.price === lastdata) {
          }
        });
      }
      if (updatedtrade.length > 0) {
        tradeoutRef.current = setTimeout(tradeoutRef, 1000);
      }
    };
    updtaetrade();
  };
  function adjustUTCWithDate12(dateStr, timezone) {
    if (!dateStr || !timezone) return null;
    let utcDate;
    if (dateStr.includes("T") && dateStr.endsWith("Z")) {
      utcDate = new Date(dateStr);
    } else {
      const [datePart, timePart] = dateStr.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);
      utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    }
    const { haur, minute: tzMin, plus } = timezone;
    const hourOffset = parseInt(haur, 10) || 0;
    const minuteOffset = parseInt(tzMin, 10) || 0;
    const totalOffsetMinutes = hourOffset * 60 + minuteOffset;
    if (plus === "+") {
      utcDate.setUTCMinutes(utcDate.getUTCMinutes() + totalOffsetMinutes);
    } else {
      utcDate.setUTCMinutes(utcDate.getUTCMinutes() - totalOffsetMinutes);
    }
    return utcDate.getTime();
  }
  function applyTimezoneOffset(timestampSec, timezone) {
    const baseDateMs = timestampSec * 1000;
    const sign = timezone.plus === "+" ? 1 : -1;
    const offsetMs =
      (Number(timezone.haur) * 60 + Number(timezone.minute)) * 60 * 1000 * sign;
    return baseDateMs + offsetMs;
  }

  useEffect(() => {
    currenttimecheckRef.current = currenttimecheck;
    setCheckcurrcenttime(true);
  }, [currenttimecheck]);
  const tradetimmer = (opentrade) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setWallupdate(false);
    let updatedTrades = [...opentrade];
    const updateTime = () => {
      if (opentrade?.length) {
        updatedTrades = opentrade.map((item, key) => {
          const closeTime = adjustUTCWithDate12(
            item?.trade_timestamp,
            updatetimezone,
          );
          let now = applyTimezoneOffset(
            currenttimecheckRef.current.timestamp,
            updatetimezone,
          );
          const timeDiff = Math.max(0, Math.floor((closeTime - now) / 1000));
          if (timeDiff <= 0) {
            opentrade.splice(key, 1);
            return {
              ...item,
              timeleft: "00:00:00",
              progress: 100,
              isProcessed: false,
            };
          }

          const newHours = String(Math.floor(timeDiff / 3600)).padStart(2, "0");
          const newMinutes = String(
            Math.floor((timeDiff % 3600) / 60),
          ).padStart(2, "0");
          const newSeconds = String(timeDiff % 60).padStart(2, "0");
          const newTimeLeft = `${newHours}:${newMinutes}:${newSeconds}`;
          let intime = applyTimezoneOffset(
            currenttimecheck.timestamp,
            updatetimezone,
          );
          const initialTime =
            item.initialTime || Math.floor((closeTime - intime) / 1000);
          const elapsedTime = initialTime - timeDiff;
          const newProgress = Math.min((elapsedTime / initialTime) * 100, 100);
          return {
            ...item,
            timeleft: newTimeLeft,
            progress: newProgress,
            isProcessed: true,
          };
        });
        setPendingtrade(updatedTrades);
        if (updatedTrades.length > 0) {
          timeoutRef.current = setTimeout(updateTime, 1000);
        }
      } else {
        setPendingtrade([]);
      }
      if (updatedTrades?.length) {
        for (let i = 0; i < updatedTrades.length; i++) {
          let item = updatedTrades[i];
          if (item.timeleft === "00:00:00" && item.isProcessed === false) {
            if (!websoketrunning) return;
            setTimeout(() => {
              handleBuy(
                item.amount,
                item.duration,
                (item.amount * parseInt(chnagetype?.payout)) / 100,
                item.type,
                true,
              );
              item.isProcessed = true;
            }, 1000);
            item.isProcessed = true;
            updatedTrades.splice(i, 1);
            return;
          }
        }
      }
    };

    updateTime();
  };

  const convertToTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };
  const toTimestamp = (iso) => {
    if (!iso) return 0;
    const parts = iso.match(
      /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?/,
    );
    if (!parts) return 0;
    const [_, y, m, d, h, min, s] = parts.map(Number);
    const isLeap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
    const daysInMonth = (y, m) =>
      [31, isLeap(y) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1];
    let days = 0;
    for (let year = 1970; year < y; year++) days += isLeap(year) ? 366 : 365;
    for (let month = 1; month < m; month++) days += daysInMonth(y, month);
    days += d - 1;
    const totalSeconds =
      days * 86400 + (h || 0) * 3600 + (min || 0) * 60 + (s || 0);
    return totalSeconds * 1000;
  };

  const toDateKeyWithTZ = (iso, updatetimezone) => {
    if (!iso) return null;
    const ts = toTimestamp(iso);
    const sign = updatetimezone?.plus === "-" ? -1 : 1;
    const hours = Number(updatetimezone?.haur || 0);
    const minutes = Number(updatetimezone?.minute || 0);
    const offsetMs = sign * (hours * 60 + minutes) * 60 * 1000;
    const localTs = ts + offsetMs;
    let seconds = Math.floor(localTs / 1000);
    let days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const h = Math.floor(seconds / 3600);
    seconds %= 3600;
    const min = Math.floor(seconds / 60);
    const s = seconds % 60;
    let year = 1970;
    const isLeap = (y) => (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
    const daysInMonth = (y, m) =>
      [31, isLeap(y) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1];
    while (true) {
      const daysInYear = isLeap(year) ? 366 : 365;
      if (days >= daysInYear) {
        days -= daysInYear;
        year++;
      } else break;
    }
    let month = 1;
    while (true) {
      const dim = daysInMonth(year, month);
      if (days >= dim) {
        days -= dim;
        month++;
      } else break;
    }
    const day = days + 1;
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${year}-${pad(month)}-${pad(day)}`;
  };

  const sortTrades = (arr, updatetimezone) =>
    [...arr].sort((a, b) => {
      const ta = toTimestamp(a.updated_at || a.created_at);
      const tb = toTimestamp(b.updated_at || b.created_at);
      return tb - ta;
    });

  const dedupeById = (arr) => {
    const map = new Map();
    for (const t of arr) if (t && t.id != null) map.set(t.id, t);
    return Array.from(map.values());
  };

  // ================================
  // NORMALIZE BY DATE
  // ================================

  const normalizeByCreatedAt = (input, updatetimezone) => {
    const out = {};
    const pushTrade = (t) => {
      if (!t || !t.created_at) return;
      const key = toDateKeyWithTZ(t.created_at, updatetimezone);
      if (!key) return;
      (out[key] ||= []).push(t);
    };
    if (Array.isArray(input)) {
      input.forEach(pushTrade);
    } else if (input && typeof input === "object") {
      for (const [key, val] of Object.entries(input)) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(key) && Array.isArray(val)) {
          (out[key] ||= []).push(...val);
        } else if (val && typeof val === "object" && !Array.isArray(val)) {
          pushTrade(val);
        } else if (Array.isArray(val)) {
          val.forEach(pushTrade);
        }
      }
    }

    for (const k of Object.keys(out)) {
      out[k] = sortTrades(dedupeById(out[k]), updatetimezone);
    }

    return out;
  };

  // ================================
  // MERGE BY DATE
  // ================================

  const mergeByDate = (prev, incoming, updatetimezone) => {
    const normalized = normalizeByCreatedAt(incoming, updatetimezone);
    const merged = { ...prev };
    for (const [date, list] of Object.entries(normalized)) {
      const existing = merged[date] || [];
      merged[date] = sortTrades(
        dedupeById([...existing, ...list]),
        updatetimezone,
      );
    }

    const getTimestampForKey = (key) => {
      const iso = key + "T00:00:00";
      return (
        toTimestamp(iso) +
        (updatetimezone?.plus === "-" ? -1 : 1) *
          ((Number(updatetimezone?.haur) || 0) * 3600 +
            (Number(updatetimezone?.minute) || 0) * 60) *
          1000
      );
    };
    const sortedKeys = Object.keys(merged).sort(
      (a, b) => getTimestampForKey(b) - getTimestampForKey(a),
    );
    const sortedMerged = {};
    for (const key of sortedKeys) {
      sortedMerged[key] = merged[key];
    }
    return sortedMerged;
  };

  useEffect(() => {
    if (checkclosetrade?.length) {
      let upadtedclose = mergeByDate(
        closedata,
        checkclosetrade,
        updatetimezone,
      );
      const validDatePattern = /^\d{4}-\d{2}-\d{2}$/;
      const filteredGroupedTrades = Object.fromEntries(
        Object.entries(upadtedclose).filter(([date]) =>
          validDatePattern.test(date),
        ),
      );
      setClosdata(filteredGroupedTrades);
    }
  }, [checkclosetrade, checkliveaccount]);
  useEffect(() => {
    if (updatetimezone) {
      openclosetrade();
    }
  }, [
    checkliveaccount,
    updatetimezone,
    callclosetradeapi === true,
    // closetradeapirun?.current === true,
  ]);
  const getStartAndCloseTime = (time, duration) => {
    const formatTime = (date) =>
      date.toLocaleTimeString("en-US", { hour12: false });
    const startDate = new Date(time);
    const formattedStartTime = formatTime(startDate);
    const [h, m, s] = duration?.split(":").map(Number);
    const closeDate = new Date(
      startDate.getTime() + h * 3600 * 1000 + m * 60 * 1000 + s * 1000,
    );
    const formattedCloseTime = formatTime(closeDate);
    const formatDuration = (h, m, s) => {
      let result = "";
      if (h > 0) result += `${h}H`;
      if (m > 0) result += `${m}M`;
      if (s > 0) result += `${s}S`;
      return result || "0S";
    };
    const formattedDuration = formatDuration(h, m, s);
    return {
      startTime: formattedStartTime,
      closeTime: formattedCloseTime,
      duration: formattedDuration,
      startTimestamp: Math.floor(startDate.getTime() / 1000),
      closeTimestamp: Math.floor(closeDate.getTime() / 1000),
    };
  };
  const handleClearData = () => {
    // if (seriesRef?.current) {
    //   seriesRef.current.setData([]); // Clear the data in the chart series
    // }
  };

  function applyDynamicTimezone(serverTimeMs, timezone) {
    const sign = timezone.plus === "+" ? 1 : -1;
    const offsetMs =
      (Number(timezone.haur) * 60 + Number(timezone.minute)) * 60 * 1000 * sign;
    return serverTimeMs + offsetMs;
  }
  useEffect(() => {
    if (!serverTime?.server_time || !updatetimezone) return;
    let adjustedMs = applyDynamicTimezone(
      serverTime.server_time,
      updatetimezone,
    );
    adjustedMs += 2 * 60 * 1000;
    const totalSeconds = Math.floor(adjustedMs / 1000) % (24 * 3600);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0",
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    setPendingbytime((state) => ({
      ...state,
      time: formattedTime,
    }));
  }, [serverTime, updatetimezone]);

  const handleTimeChange = (e) => {
    let input = e.target.value.replace(/[^0-9:]/g, "");
    if (input.length === 2 || input.length === 5) {
      if (!input.endsWith(":")) input += ":";
    }
    if (input.length > 8) input = input.slice(0, 8);
    const [hours, minutes, seconds] = input.split(":");
    if (
      (hours && parseInt(hours) > 23) ||
      (minutes && parseInt(minutes) > 59) ||
      (seconds && parseInt(seconds) > 59)
    ) {
      return;
    }
    const tzDate = applyDynamicTimezone(serverTime.server_time, updatetimezone);
    const currentTime = tzDate.toISOString().substr(11, 8);
    if (input < currentTime) {
      setTimeError("Past time is not allowed.");
    } else {
      setTimeError("");
    }
    setPendingbytime((state) => ({
      ...state,
      time: input,
    }));
  };

  const result = {
    trade_timestamp: "2024-11-19T12:00:00Z",
    duration: "01:25:50",
  };
  const splitString = (input) => {
    return input.split(/[-/]/);
  };

  const handleShortcut = useCallback(
    (event) => {
      if (event.shiftKey && event.key.toLowerCase() === "w") {
        event.preventDefault();
        if (!websoketrunning) return;
        if (swetchtimer === 0) {
          handleBuy(amount, time, peramount, "buy", false, [], closetradetime);
        } else {
          handleBuy(amount, time, peramount, "buy", false, []);
        }
      }
      if (event.shiftKey && event.key.toLowerCase() === "s") {
        if (!websoketrunning) return;
        event.preventDefault();
        if (swetchtimer === 0) {
          handleBuy(amount, time, peramount, "sell", false, [], closetradetime);
        } else {
          handleBuy(amount, time, peramount, "sell", false, []);
        }
      }
      if (event.shiftKey && event.key.toLowerCase() === "a") {
        event.preventDefault();
        priceupdate("minus");
      }
      if (event.shiftKey && event.key.toLowerCase() === "d") {
        event.preventDefault();
        priceupdate("add");
      }
    },
    [amount, time, peramount, handleBuy, priceupdate],
  );
  const hotkeysset = async (value) => {
    try {
      let postdata = {
        key: "hotkey",
        value: value,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/setpreference`, "POST");
      if (res?.data?.success) {
        gethotkeys();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gethotkeys = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/preference?key=hotkey`, "GET");
      if (res?.data?.success) {
        setActivekeys(parseInt(res?.data?.value));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gethotkeys();
  }, []);
  useEffect(() => {
    if (activekeys) {
      window.addEventListener("keydown", handleShortcut);
      return () => {
        window.removeEventListener("keydown", handleShortcut);
      };
    }
  }, [handleShortcut, activekeys]);
  const getleaderboard = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/leaderboard?limit=20`, "GET");
      if (res?.data?.success) {
        setCurrentuser(res?.data?.current_user);
        setLeaderboarddata(res?.data?.trade);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getleaderdata = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/leaderboard?limit=3`, "GET");
      if (res?.data?.success) {
        let arr = [...res?.data?.trade];
        if (arr?.length) {
          let rank1Index = -1;
          let rank2Index = -1;
          arr.forEach((result, index) => {
            if (result?.rank === 1) {
              rank1Index = index;
            }
            if (result?.rank === 2) {
              rank2Index = index;
            }
          });
          if (rank1Index !== -1 && rank2Index !== -1) {
            [arr[rank1Index], arr[rank2Index]] = [
              arr[rank2Index],
              arr[rank1Index],
            ];
          }
        }
        setTopperdata(arr);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getleaderboard();
    getleaderdata();
  }, []);
  const userdetailsfromid = async (id, rank, filter, inmodal, type) => {
    try {
      if (!id) return;
      if (type) {
        setSocialtype(true);
      } else {
        setSocialtype(false);
      }
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/leaderboarddetail?${
          filter ? `filter=${filter}` : ""
        }${type ? `&type=${type}` : ""}&userid=${id}&time=${updatetimezone?.time}`,
        "GET",
      );
      if (res?.data?.success) {
        watchcount(true);
        if (res?.data?.trade?.havecopy) {
          setShowcopydeleteicon(true);
        } else {
          setShowcopydeleteicon(false);
        }
        setModelloading(false);
        setcopysetting((state) => ({
          ...state,
          copy_user_id: res?.data?.trade?.user_id,
        }));
        copytradestatus(res?.data?.trade?.user_id);
        if (filter) {
          if (inmodal) {
            setUserfilter(res?.data?.trade);
          } else {
            setUserfilter(res?.data?.trade);
            let obj = {
              ...res?.data?.trade,
              rank: rank,
              cancopy: res?.data?.cancopy,
            };
            setUserdata(obj);
          }
        } else {
          if (rank) {
            let obj = {
              ...res?.data?.trade,
              rank: rank,
              cancopy: res?.data?.cancopy,
            };
            setUserdata(obj);
          } else {
            setUserdata({ ...res?.data?.trade, cancopy: res?.data?.cancopy });
          }
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    const key = Object.keys(isHovered || {})[0];
    const isTrue = key && isHovered[key] === true;
    const objectKey = isHovered ? Object.keys(isHovered)[0] : "";
    if (objectKey && isTrue) {
      userdetailsfromid(objectKey, "", "today");
    }
  }, [isHovered]);
  const generateUniqueId = () => {
    const id = uuidv4();
    return id;
  };
  function convertToUTC(localTime, tzInfo) {
    const [datePart, timePart] = localTime.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    const offsetMinutes = Number(tzInfo.haur) * 60 + Number(tzInfo.minute);
    const signedOffsetMinutes =
      tzInfo.plus === "-" ? -offsetMinutes : offsetMinutes;
    const utcTimestamp = Date.UTC(
      year,
      month - 1,
      day,
      hour - signedOffsetMinutes / 60,
      minute,
      second,
    );
    const utcDate = new Date(utcTimestamp);
    const utcYear = utcDate.getUTCFullYear();
    const utcMonth = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
    const utcDay = String(utcDate.getUTCDate()).padStart(2, "0");
    const utcHours = String(utcDate.getUTCHours()).padStart(2, "0");
    const utcMinutes = String(utcDate.getUTCMinutes()).padStart(2, "0");
    const utcSeconds = String(utcDate.getUTCSeconds()).padStart(2, "0");
    return `${utcYear}-${utcMonth}-${utcDay} ${utcHours}:${utcMinutes}:${utcSeconds}`;
  }
  const pendingtradsbytime = async (type) => {
    if (timeerror) {
      return;
    }
    let uniqueid = generateUniqueId();
    const localTime = pendingbytime?.opentime + " " + pendingbytime?.time;
    const utcTime = await convertToUTC(localTime, updatetimezone);
    const splitData = pendingbytime?.asset.split("/");
    try {
      let postdata = { ...pendingbytime };
      let obj2 = { ...pendingtime };
      postdata.account_type = checkliveaccount ? "demo" : "real";
      postdata.start_price = 0;
      postdata.duration = `${obj2?.hours}:${obj2?.minutes}:${obj2?.secound}`;
      postdata.type = type;
      postdata.status = "pending";
      postdata.currentTime = utcTime;
      postdata.exit_price = 0;
      postdata.profit_loss =
        (postdata?.amount * parseInt(chnagetype?.payout)) / 100;
      postdata.reference_id = uniqueid;
      postdata.id = "";
      postdata.pair_from = splitData[0] ? splitData[0] : chnagetype?.sortname;
      postdata.pair_to = splitData[1] ? splitData[1] : chnagetype?.csymbol;
      postdata.close_time = "";
      postdata.pendingtrade = 1;
      postdata.asset = postdata.asset
        ? postdata.asset
        : `${chnagetype?.sortname}/${chnagetype?.csymbol}`;
      postdata.payout = postdata.payout ? postdata.payout : chnagetype?.payout;
      postdata.ticker = postdata.ticker ? postdata.ticker : chnagetype?.ticker;
      postdata.trade_type = postdata.trade_type
        ? postdata.trade_type
        : `${chnagetype?.type}`;
      delete postdata.opentime;
      delete postdata.time;
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/trade`, "POST");
      if (res?.data?.success) {
        // getpendingtrade();
        setWallupdate(true);
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const formatTime = (date) => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const pendingtradsbyprice = async (type) => {
    let uniqueid = generateUniqueId();
    const splitData = pendingbyprice?.asset.split("/");
    const now = new Date();
    try {
      let postdata = { ...pendingbyprice };
      let obj2 = { ...pendingpricetime };
      postdata.account_type = checkliveaccount ? "demo" : "real";
      postdata.start_price = pendingbyprice?.openprice;
      postdata.duration = `${obj2?.hours}:${obj2?.minutes}:${obj2?.secound}`;
      postdata.type = type;
      postdata.status = "pending";
      postdata.currentTime = formatTime(now);
      postdata.exit_price = 0;
      postdata.profit_loss =
        (postdata?.amount * parseInt(chnagetype?.payout)) / 100;
      postdata.reference_id = uniqueid;
      postdata.id = "";
      postdata.pair_from = splitData[0] ? splitData[0] : chnagetype?.sortname;
      postdata.pair_to = splitData[1] ? splitData[1] : chnagetype?.csymbol;
      postdata.payout = postdata.payout ? postdata.payout : chnagetype?.payout;
      postdata.close_time = "";
      postdata.pendingtrade = 2;
      delete postdata.opentime;
      delete postdata.time;
      delete postdata.openprice;
      postdata.trade_type = postdata.trade_type
        ? postdata.trade_type
        : `${chnagetype?.type}`;
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/trade`, "POST");
      if (res?.data?.success) {
        getpendingpricetrade();
        setWallupdate(true);
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const requestIdRef = useRef(0);

  const getsocialtrade = async (filter) => {
    if (filter === "Search") {
      return;
    }
    const requestId = ++requestIdRef.current;
    setLoadingSocial(true);

    let filters = "recommended";

    if (filter === "Leaderboard") {
      filters = "rank";
    } else if (filter === "Top recommended traders") {
      filters = "recommended";
    } else if (filter === "List of watched traders") {
      filters = "i_am_watching";
    } else if (filter === "Trader who watch me") {
      filters = "watching_me";
    } else if (filter === "Trader who copy me") {
      filters = "copied_me";
    } else if (filter === "List of copied traders") {
      filters = "i_am_copied";
    }

    try {
      const res = await authcallApi(
        {},
        `api/show-social-trading?filter=${filters}`,
        "GET",
      );

      // Ignore old response
      if (requestId !== requestIdRef.current) return;

      if (res?.data?.success) {
        setSociallist(res.data.data);
        setSearchfilterdata([]);
        setSearchfilter("");
        
      } else {
        setSociallist([]);
      }
    } catch (err) {
      if (requestId !== requestIdRef.current) return;
      console.log(err);
    } finally {
      if (requestId !== requestIdRef.current) return;

      setTimeout(() => {
        setLoadingSocial(false);
      }, 1000);
    }
  };
  useEffect(() => {
    getsocialtrade();
  }, []);
  const deletependingtrade = async (id, type) => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/trade/${id}`, "DELETE");
      if (res?.data?.success) {
        setWallupdate(true);
        getwatchlount();
        if (type === "time") {
          getpendingtrade();
        } else {
          getpendingpricetrade();
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const watchsocialtrade = async (id, updatedids, firsttime) => {
    try {
      let ids = id ? [...watchusersref.current, id] : updatedids;
      const userid = ids?.length
        ? ids.reduce((acc, currId, index) => {
            acc[index] = currId.toString();
            return acc;
          }, {})
        : {};

      let postdata = {
        userid,
        account_type: checkliveaccount ? "demo" : "real",
      };

      let res = await authcallApipost(
        postdata,
        `api/get-social-trades`,
        "POST",
      );

      if (res?.data?.success) {
        if (!firsttime) {
          userdetailsfromid(id, "", selectedOption, false);
          watchcount(res?.data?.trade);
        }
        // getsocialwatch(res?.data?.trade);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const watchcount = async (firsttime) => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/watchcount`, "GET");
      if (res?.data?.success) {
        watchusersref.current = [];
        watchusersref.current = res?.data?.watchlist;
        getwatchlount();
        if (firsttime) {
          watchsocialtrade("", res?.data?.watchlist, firsttime);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    watchcount(true);
  }, []);
  const getwatchlount = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/getwatchcount`, "GET");
      if (res?.data?.success) {
        setWatchmecount(res?.data?.watchlist);
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  useEffect(() => {
    getwatchlount();
  }, []);
  const deletewatchlist = async (id) => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/socialwatch/${id}`, "DELETE");
      if (res?.data?.success) {
        // const updatedData = watchusersref.current.filter((item) => item !== id);
        if (socialfilter?.label == "List of watched traders") {
          getsocialtrade("List of watched traders");
        }
        userdetailsfromid(id, "", selectedOption, false);
        // // Update the ref with the filtered array
        // watchusersref.current = updatedData;

        // watchsocialtrade("",updatedData)
        watchcount(true);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const handlecopychange = (key, value) => {
    if (key === "stop_balance") {
      const intnumber = parseFloat(walletdata.replace(/,/g, "")) || 0;
      let inputNumber = parseFloat(value);
      if (inputNumber > intnumber) {
        setcopysetting((state) => ({
          ...state,
          [key]: intnumber,
        }));
      } else {
        setcopysetting((state) => ({
          ...state,
          [key]: value,
        }));
      }
    } else {
      setcopysetting((state) => ({
        ...state,
        [key]: value,
      }));
    }
  };
  const handleChange = (e) => {
    let inputValue = e.target.value.replace(/\D/g, "");
    let numValue = Number(inputValue);
    if (numValue < 1) {
      // numValue = 1;
    } else if (numValue > 200) {
      numValue = 200;
    }
    handlecopychange("proportion", numValue);
  };
  const copytrade = async (data) => {
    try {
      if (copysetting?.bothamount_error) {
        return;
      }
      setLoading(true);
      let postdata = {
        proportion: data?.proportion ? unformatPrice(data?.proportion) : 1,
        stop_balance: data?.stop_balance
          ? unformatPrice(data?.stop_balance)
          : 1,
        max_copy_trade_value: data?.max_copy_trade_value
          ? unformatPrice(data?.max_copy_trade_value)
          : 0,
        min_trade_amount: data?.min_trade_amount
          ? unformatPrice(data?.min_trade_amount)
          : 1,
        copy_user_id: data?.copy_user_id,
        min_amount: data?.min_totel_amount
          ? unformatPrice(data?.min_totel_amount)
          : 1,
        max_amount: data?.max_totel_amount
          ? unformatPrice(data?.max_totel_amount)
          : 0,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(postdata, `api/copytrade`, "POST");
      if (res?.data?.success) {
        setCopybuttion(true);
        showNotification(res?.data?.message, "success");
        if (socialfilter?.label === "List of copied traders") {
          getsocialtrade(socialfilter?.label);
        }
        setSocialtype(false);
        setShowCopyhistory(false);
        setShowcopydeleteicon(false);
        copytradestatus(data?.copy_user_id);
        userdetailsfromid(userdata?.user_id, "", "today", false);
        setCheckcopy(false);
        // window.copytrade = setInterval(() => {
        //   copytradesall();
        // }, 1000);
        // return () => clearInterval(window.copytrade);
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!checkcopy) {
      setCopybuttion(false);
    }
  }, [checkcopy]);
  const copytradestatus = async (id) => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/copytradestatus?copy_user_id=${id}`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.status === "active") {
          setCheckcopytrade(true);
          copytradesall();
          let upadtedobj = {
            proportion: formatPrice(res?.data?.detail?.proportion || 1),
            stop_balance: formatPrice(res?.data?.detail?.stop_balance) || 1,
            max_copy_trade_value:
              Number(res?.data?.detail?.max_copy_trade_value) > 0
                ? formatPrice(res?.data?.detail?.max_copy_trade_value || "")
                : 0,
            min_trade_amount: formatPrice(
              res?.data?.detail?.min_trade_amount || 0,
            ),
            copy_user_id: res?.data?.detail?.copy_user_id || 0,
            min_totel_amount: formatPrice(res?.data?.detail?.min_amount || 0),
            checkminamount: false,
            max_totel_amount:
              Number(res?.data?.detail?.max_amount) > 0
                ? formatPrice(res?.data?.detail?.max_amount || "")
                : 0,
            checkmaxamount: false,
            bothamount_error: false,
          };
          console.log(upadtedobj, "upadtedobjupadtedobj");
          setcopysetting(upadtedobj);
        } else {
          setCheckcopytrade(false);
          setcopysetting({
            proportion: 100,
            stop_balance: 1,
            max_copy_trade_value: 0,
            min_trade_amount: 1,
            copy_user_id: id,
            min_totel_amount: "",
            checkminamount: false,
            max_totel_amount: "",
            checkmaxamount: false,
            bothamount_error: false,
          });
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const searchprefrence = async (value) => {
    try {
      setSearchpopup(!searchpopup);
      let postdata = {
        key: "searchpopup",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        // getsearchprefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsearchprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=searchpopup`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setSearchpopup(parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsearchprefrence();
  }, []);
  const stopcopytrade = async (id) => {
    let postdata = { copy_user_id: id };
    const formData = new FormData();
    for (let key in postdata) {
      if (postdata.hasOwnProperty(key)) {
        formData.append(key, postdata[key]);
      }
    }

    let res = await authcallApi(formData, `api/stopcopytrade`, "POST");
    if (res?.data?.success) {
      setCopybuttion(false);
      setShowcopydeleteicon(true);
      setShowCopyhistory(false);
      clearInterval(window.copytrade);
      copytradestatus(id);
      copytradesall();
      if (socialfilter?.label === "List of copied traders") {
        getsocialtrade(socialfilter?.label);
      }
      // getsocialtrade("List of copied traders");
    }
  };
  const copytradesall = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/copytradesall`, "GET");
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          // opentradedata(true);
          setCopycount(res?.data?.data?.length);
        } else {
          setCopycount(0);
        }
      }
    } catch (err) {
      console.log(err, "er");
    }
  };
  useEffect(() => {
    copytradesall();
  }, []);
  const disablecopytrade = async (status) => {
    try {
      let postdata = { status: status ? 0 : 1 };
      let res = await authcallApi(postdata, `api/disbalecopy`, "POST");
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const checkcopystatus = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/checkcopytrade`, `GET`);
      if (res?.data?.success) {
        if (res?.data?.status) {
          if (!checkliveaccount) {
            // window.checkcopy = setInterval(() => {
            //   copytradesall();
            //   getpendingtrade();
            // }, 1000);
            // return () => clearInterval(window.checkcopy);
          } else {
            // clearInterval(window.checkcopy);
          }
        }
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  useEffect(() => {
    checkcopystatus();
  }, [checkliveaccount]);
  const deleteallcoply = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/copy-delete-all`, "POST");
      if (res?.data?.success) {
        copytradesall();
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const setupsocialsetting = (key) => {
    console.log(key, "keykeykey");
    setSocialTradingSettings((prev) => {
      const updatedSettings = {
        ...prev,
        [key]: !prev[key],
      };
      if (key === "hideCopyingStatistics") {
        disablecopytrade(updatedSettings?.hideCopyingStatistics);
        if (!updatedSettings?.hideCopyingStatistics) {
          deleteallcoply();
        }
      }

      socialpreference(updatedSettings);
      setSocialTradingSettings(updatedSettings);
      return updatedSettings;
    });
  };
  useEffect(() => {
    setShowcopytrades(socialTradingSettings?.watchingCopiedTrades);
  }, [socialTradingSettings?.watchingCopiedTrades]);
  const socialpreference = async (value) => {
    try {
      let postdata = {
        key: "SocialTradingSettings",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        // checksocialpreference();
        getwatchlount()
        if (!value?.hideWatchingTrading) {
          stopallwatch();
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const checksocialpreference = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=SocialTradingSettings`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.value) {
          const jsonObject = JSON.parse(res?.data?.value);
          setSocialTradingSettings(jsonObject);

          // console.log(jsonObject, "jsonObject")
        } else {
          setSocialTradingSettings({
            // displaySocialTrades: true,
            watchingCopiedTrades: false,
            hideCopyingStatistics: true,
            hideWatchingTrading: true,
            showOnlyWatchedTraders: true,
          });
        }
      } else {
        setSocialTradingSettings({
          // displaySocialTrades: true,
          watchingCopiedTrades: false,
          hideCopyingStatistics: true,
          hideWatchingTrading: true,
          showOnlyWatchedTraders: true,
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    checksocialpreference();
  }, []);

  const stopallwatch = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/socialwatch/remove-watchers`,
        "DELETE",
      );
      if (res?.data?.success) {
        // getsocialtrade(socialfilter?.label);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const timeprefrence = async (value) => {
    try {
      let postdata = {
        key: "time",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getFutureTimestamp(value);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const timepriceprefrence = async (value) => {
    try {
      let postdata = {
        key: "price",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        // setAmountInput(String(value));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getpriceprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/preference?key=price`, "GET");
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        if (parsedValue < 0 || parsedValue === 0) {
          setAmount(1);
        } else {
          setAmount(parsedValue);
        }

        setAmountInput("");
      } else {
        setAmount(1);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gettimeprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/preference?key=time`, "GET");
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setTime(parsedValue);
        console.log(parsedValue, "setTime 7");
        getFutureTimestamp(parsedValue);
      } else {
        setTime({
          hours: "00",
          minutes: "01",
          secound: "00",
        });
        getFutureTimestamp({
          hours: "00",
          minutes: "01",
          secound: "00",
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getpriceprefrence();
    gettimeprefrence();
  }, []);

  const handleClick = (val) => {
    amountbuttionref.current = true;
    if (val === "." && amountInput.includes(".")) return;
    if (amount === "0" || amount === "" || amountInput === "") {
      if (val === "0") {
        return;
      }
    }
    let updatedInput = amountInput + val;
    if (amount && amountInput === "") {
      if (val === ".") {
        updatedInput = amount + val;
      } else {
        updatedInput = val;
      }
    }
    let updatedsplit = updatedInput.split(".");
    if (updatedsplit?.length > 1) {
      if (val === "0") {
        return;
      }
      console.log(updatedInput, "updatedInput", updatedsplit[1]);
    }
    const [integerPart, decimalPart] = updatedInput.split(".");
    if (decimalPart && decimalPart.length > 2) return;
    const intnumber = parseFloat(walletdata.replace(/,/g, ""));
    if (Number(updatedInput) > intnumber) {
      setAmountInput(intnumber);
      setAmount(intnumber);
      timepriceprefrence(Number(intnumber));
    } else {
      setAmountInput(updatedInput);
      setAmount(updatedInput);
      timepriceprefrence(Number(updatedInput));
    }
    amountbuttionref.current = false;
  };
  const handleBackspace = () => {
    amountbuttionref.current = true;
    let updatedInput = "";
    if (amount && amountInput === "") {
      updatedInput = String(amount).slice(0, -1);
    } else {
      updatedInput = String(amountInput).slice(0, -1);
    }
    if (updatedInput.endsWith(".")) {
      updatedInput = updatedInput.slice(0, -1);
    }
    if (/^\d+\.0$/.test(updatedInput)) {
      updatedInput = parseInt(updatedInput).toString();
    }
    setAmountInput(updatedInput);
    timepriceprefrence(Number(updatedInput));
    setAmount(updatedInput);
    amountbuttionref.current = false;
  };
  const getStep = (amount) => {
    if (amount < 10) return 2;
    if (amount < 50) return 5;
    if (amount < 100) return 10;
    if (amount < 500) return 50;
    return 100;
  };
  const roundToNextMultipleOf5 = (value) => {
    return Math.ceil(value / 5) * 5;
  };
  const getSuggestedAmounts = (baseAmount) => {
    if (!baseAmount) {
      return [1, 1 + 5, 1 + 10];
    }
    const start = roundToNextMultipleOf5(
      parseInt(baseAmount) + getStep(baseAmount),
    );
    return [start, start + 5, start + 10];
  };
  const maxamoumt = () => {
    if (walletdata) {
      const intnumber = parseFloat(walletdata.replace(/,/g, ""));
      if (intnumber < 20000) {
        setAmount(intnumber);
        timepriceprefrence(intnumber);
        setAmountInput(String(intnumber));
      } else if (intnumber > 20000) {
        setAmount(20000);
        timepriceprefrence(20000);
        setAmountInput(String(20000));
      }
    }
  };
  const [graphdata, setGraphdata] = useState({
    labelX: "",
    labelY: "",
    arrowEndX: "",
    arrowEndY: "",
    d: "",
    points: [],
  });
  const Calcamount = (type) => {
    const updatedAmount =
      type === "multi"
        ? (amount * calculateamount).toFixed(2)
        : (amount / calculateamount).toFixed(2);
    setAmount(Math.max(1, updatedAmount));
    // setAmountInput("")
    timepriceprefrence(Math.max(1, updatedAmount));
  };
  let API_KEY = process.env.REACT_APP_API_KEY;
  function timeToUnixTimestamp(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    const now = new Date();
    now.setHours(hours, minutes, seconds, 0);
    return Math.floor(now.getTime() / 1000);
  }
  const width = 300;
  const height = 160;
  const getDurationType = (durationStr) => {
    const [hours, minutes, seconds] = durationStr.split(":").map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    console.log(totalSeconds, "totalSeconds");
    if (totalSeconds >= 1 && totalSeconds <= 60) {
      return { duration: 1, type: "second", format: "S1" };
    } else if (totalSeconds >= 61 && totalSeconds <= 1200) {
      return { duration: 5, type: "second", format: "S5" };
    } else if (totalSeconds >= 1201 && totalSeconds <= 3600) {
      return { duration: 1, type: "minute", format: "M1" };
    } else if (totalSeconds >= 3601 && totalSeconds <= 8200) {
      return { duration: 2, type: "minute", format: "M2" };
    } else {
      return { duration: 5, type: "minute", format: "M5" };
    }
  };
  function updateTradeData(data, apiData, tradeTimestamp, closeTimestamp) {
    const entryPrice = apiData.entry_price;
    const exitPrice = apiData.exit_price;
    // const tradeTimestamp = new Date(apiData.trade_timestamp).getTime();
    // const closeTimestamp = new Date(apiData.close_time).getTime();
    const updatedData = [...data];
    let hasEntry = false;
    let hasExit = false;
    for (let i = 0; i < updatedData.length; i++) {
      if (updatedData[i].time === tradeTimestamp) {
        updatedData[i].value = entryPrice;
        hasEntry = true;
      }
      if (updatedData[i].time === closeTimestamp) {
        updatedData[i].value = exitPrice;
        hasExit = true;
      }
    }
    // if (!hasEntry)
    //   updatedData.push({ time: tradeTimestamp, value: entryPrice });
    // if (!hasExit) updatedData.push({ time: closeTimestamp, value: exitPrice });
    updatedData.sort((a, b) => a.time - b.time);

    return updatedData;
  }

  function generateSVG(graphData, result, width, height) {
    const { points, entryPoint, closePoint } = graphData;
    let d = `M${points[0].x},${points[0].y}`;
    for (let i = 1; i < points.length; i++) {
      d += ` L${points[i].x},${points[i].y}`;
    }

    const arrowColor =
      result.type === "buy"
        ? parseFloat(result.exit_price) > parseFloat(result.entry_price)
          ? "#0FAF59"
          : "#f3382c"
        : parseFloat(result.exit_price) < parseFloat(result.entry_price)
          ? "#0FAF59"
          : "#f3382c";

    return { d, entryPoint, closePoint, arrowColor };
  }

  const polygonapi = async (apidata) => {
    try {
      setGraphdata({
        labelX: "",
        labelY: "",
        arrowEndX: "",
        arrowEndY: "",
        d: "",
        points: [],
      });

      const { startTime, closeTime, duration, startTimestamp, closeTimestamp } =
        getStartAndCloseTime(apidata?.trade_timestamp, apidata?.duration);
      const DurationType = getDurationType(apidata?.duration);
      let updatestarttime = "";
      let updateclosetime = "";
      let response = "";
      let callapi;
      if (apidata?.pair_to === "OTC") {
        updatestarttime = startTimestamp - 5;
        updateclosetime = closeTimestamp + 5;
        let postdata = await callApi(
          {},
          `api/get-ohlc-data/${apidata?.ticker}/${DurationType?.duration}/${DurationType?.type}/${updatestarttime}/${updateclosetime}?adjusted=false&sort=asc&sametime=1`,
          "GET",
        );
        if (postdata?.data?.success) {
          response = { results: postdata?.data?.data, status: "OK" };
          callapi = await response;
        }
      } else {
        updatestarttime = (startTimestamp - 5) * 1000;
        updateclosetime = (closeTimestamp + 5) * 1000;
        let ticker = apidata?.trade_type === "currencies" ? "C" : "X";
        let postdata = `https://api.polygon.io/v2/aggs/ticker/${ticker}:${apidata?.pair_from}${apidata?.pair_to}/range/${DurationType?.duration}/${DurationType?.type}/${updatestarttime}/${updateclosetime}?adjusted=false&apiKey=${API_KEY}`;
        response = await fetch(postdata);
        callapi = await response.json();
      }
      if (callapi?.status === "OK") {
        if (callapi?.results?.length) {
          const data2 = callapi?.results
            ?.filter(({ t }) => t >= updatestarttime && t <= updateclosetime)
            .map(({ t, c }) => ({ time: t, value: c }));
          let data;
          if (apidata?.pair_to === "OTC") {
            data = await updateTradeData(
              data2,
              apidata,
              startTimestamp,
              closeTimestamp,
            );
          } else {
            data = await updateTradeData(
              data2,
              apidata,
              startTimestamp * 1000,
              closeTimestamp * 1000,
            );
          }
          const verticalPadding = 20;
          const base = data[0].value;
          const values = data.map((d) => d.value);
          const maxDeviation = Math.max(
            ...values.map((v) => Math.abs(v - base)),
          );

          const chartHeight = height - verticalPadding * 2;
          const pointGap = width / (data.length - 1);

          const points = data.map((d, idx) => {
            const x = idx * pointGap;
            const deviation = d.value - base;
            const y =
              height / 2 - (deviation / maxDeviation) * (chartHeight / 2);

            return { x, y };
          });

          let d = `M${points[0].x},${points[0].y}`;
          for (let i = 1; i < points.length; i++) {
            const prev = points[i - 1];
            const curr = points[i];
            const cx = (prev.x + curr.x) / 2;
            const cy = (prev.y + curr.y) / 2;
            d += ` Q${prev.x},${prev.y} ${cx},${cy}`;
          }
          d += ` L${points[points.length - 1].x},${height} L0,${height} Z`;
          let labelX;
          let labelY;
          let arrowEndX;
          let arrowEndY;
          let closestStartTime = null;
          let closestCloseTime = null;

          if (apidata?.pair_to === "OTC") {
            closestStartTime = data2
              .map((d) => d.time)
              .filter((t) => t >= startTimestamp)
              .sort((a, b) => a - b)[0];

            const times = data2.map((d) => d.time).sort((a, b) => a - b);
            const idx = times.findIndex((t) => t >= closeTimestamp);
            if (idx === -1) {
              closestCloseTime = times[times.length - 1];
            } else if (times[idx] === closeTimestamp) {
              closestCloseTime = times[idx];
            } else {
              closestCloseTime = idx > 0 ? times[idx - 1] : times[idx];
            }
          } else {
            const startTarget = startTimestamp * 1000;
            const closeTarget = closeTimestamp * 1000;
            closestStartTime = data2
              .map((d) => d.time)
              .filter((t) => t >= startTarget)
              .sort((a, b) => a - b)[0];
            closestCloseTime = data2
              .map((d) => d.time)
              .filter((t) => t >= closeTarget)
              .sort((a, b) => a - b)[0];
          }

          data2.forEach((item, key) => {
            if (item?.time === closestStartTime) {
              labelX = points[key].x;
              labelY = points[key].y;
            }
            if (item?.time === closestCloseTime) {
              arrowEndX = points[key].x;
              arrowEndY = points[key].y;
            }
          });
          setGraphdata({
            labelX: labelX,
            labelY: labelY,
            arrowEndX: arrowEndX,
            arrowEndY: arrowEndY,
            d: d,
            points: points,
          });
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const buyselltrades = (amount, time, peramount, type, closetime) => {
    if (!websoketrunning) return;
    if (parseInt(amount) < 1) {
      if (swetchtimer === 0) {
        handleBuy(1, time, peramount, type, false, [], closetime);
      } else {
        handleBuy(1, time, peramount, type, false, []);
      }

      setAmount("1");
      timepriceprefrence("0");
    } else {
      if (swetchtimer === 0) {
        handleBuy(amount, time, peramount, type, false, [], closetime);
      } else {
        handleBuy(amount, time, peramount, type, false, []);
      }
    }
  };

  const handleToggleCollapse1 = () => {
    const collapseEl = document.getElementById("tradesSidebarCollapse");
    // const bsCollapse = new window.bootstrap.Collapse(collapseEl, {
    //   toggle: false,
    // });

    if (collapseEl.classList.contains("show")) {
      // bsCollapse.hide();
      console.log("collapse.id");
    } else {
      // bsCollapse.show();

      // Force "Opened" tab to be active
      setTimeout(() => {
        document.querySelector("#opened-tab")?.click();
      }, 100);
    }
  };
  function toggleCollapseById(targetId) {
    // Get all elements with class "collapsePop"
    if (targetId === "tradesSidebarCollapse") {
      document.querySelector("#opened-tab")?.click();
      setCollapseshow((state) => ({
        ...state,
        tradesSidebarCollapse: !sidebaractive?.tradesSidebarCollapse,
        socialTradingCollapse: false,
        pendingTradesCollapse: false,
      }));
    } else if (targetId === "socialTradingCollapse") {
      setCollapseshow((state) => ({
        ...state,
        tradesSidebarCollapse: false,
        socialTradingCollapse: !sidebaractive?.socialTradingCollapse,
        pendingTradesCollapse: false,
      }));
    } else if (targetId === "pendingTradesCollapse") {
      setCollapseshow((state) => ({
        ...state,
        tradesSidebarCollapse: false,
        socialTradingCollapse: false,
        pendingTradesCollapse: !sidebaractive?.pendingTradesCollapse,
      }));
    } else if (targetId === "leaderBoardCollapse") {
      setCollapseshow((state) => ({
        ...state,
        leaderBoardCollapse: !sidebaractive?.leaderBoardCollapse,
      }));
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isLandscape = window.matchMedia("(orientation: portrait)").matches;
      const isSmallScreen = window.innerWidth <= 1402;
      const modal = modalRefs.current["socialTradingview_popup"];

      if (isLandscape && isSmallScreen) {
        const insideCollapse = event.target.closest(".collapsePop");
        const insideButton = event.target.closest("button[aria-controls]");
        // setShowCopyhistory(false);
        if (
          !insideCollapse &&
          !insideButton &&
          (!modal || !modal.contains(event.target))
        ) {
          // setShowcopydeleteicon(false)
          setCollapseshow({
            tradesSidebarCollapse: false,
            socialTradingCollapse: false,
            pendingTradesCollapse: false,
          });
        }
      }
    };

    document.addEventListener("click", handleClickOutside);
    // document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      // document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (window.innerWidth <= 1402) {
  //       // check if click happened inside any collapsePop OR collapse button
  //       const insideCollapse = event.target.closest(".collapsePop");
  //       const insideButton = event.target.closest("button[aria-controls]");

  //       if (!insideCollapse && !insideButton) {
  //         setCollapseshow({
  //           tradesSidebarCollapse: false,
  //           socialTradingCollapse: false,
  //           pendingTradesCollapse: false,
  //         });
  //       }
  //     }
  //   };
  //   document.addEventListener("click", handleClickOutside);
  //   document.addEventListener("touchstart", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //     document.removeEventListener("touchstart", handleClickOutside);
  //   };
  // }, []);
  //  const tooltipRef = useRef();

  //   useEffect(() => {
  //     // Initialize tooltip
  //     const tooltip = new window.bootstrap.Tooltip(tooltipRef.current);

  //     // Optional: clean up on unmount
  //     return () => {
  //       tooltip.dispose();
  //     };
  //   }, []);

  const handleSelect = (value) => {
    setSelectedOption(value);
    if (socialtype) {
      userdetailsfromid(userdata?.user_id, "", value, true, "copy");
    } else {
      userdetailsfromid(userdata?.user_id, "", value, true);
    }

    setIsOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setCheckcopy(false);
        // handleSelect("today");
      }
    };
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);
  const getLabel = (value) => {
    switch (value) {
      case "today":
        return t("Today");
      case "yesterday":
        return t("Yesterday");
      case "last_week":
        return t("Last Week");
      case "this_week":
        return t("This Week");
      case "this_month":
        return t("This Month");
      case "last_month":
        return t("Last Month");
      default:
        return t("Today");
    }
  };
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    tooltipTriggerList.forEach((el) => {
      new window.bootstrap.Tooltip(el);
    });
  }, []);
  function formatWithSameDecimal(num, decimals) {
    const truncated = truncateNumber(num, decimals);
    let str = truncated.toString();
    if (!str.includes(".")) {
      return str + "." + "0".repeat(decimals);
    }
    let [intPart, decPart] = str.split(".");
    decPart = decPart.padEnd(decimals, "0");
    return intPart + "." + decPart;
  }
  function truncateNumber(num, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  }
  function calculateSmartPoints01(open, close) {
    let toFixeddesimal = 2;
    let formattedDiff = "0.00";
    if (open && close) {
      let diff = Number(open) - Number(close);
      let absDiff = Math.abs(diff);
      if (absDiff !== 0) {
        const diffStr = absDiff.toFixed(10);
        const decimalPart = diffStr.split(".")[1];
        let index = 0;
        while (index < decimalPart.length && decimalPart[index] === "0") {
          index++;
        }
        toFixeddesimal = Math.max(2, index + 1);
      }
    }
    const openNum = truncateNumber(Number(open), toFixeddesimal);
    const closeNum = truncateNumber(Number(close), toFixeddesimal);
    if (isNaN(openNum) || isNaN(closeNum)) {
      return { error: "Invalid input" };
    }
    const diff = closeNum - openNum;
    const unitSize = Math.pow(10, -toFixeddesimal);
    const rawPoints = Math.round(diff / unitSize);
    const direction =
      rawPoints > 0 ? "Profit" : rawPoints < 0 ? "Loss" : "No Change";
    return {
      points: rawPoints,
      direction,
    };
  }
  function calculateSmartPoints(open, close) {
    const openVal = Number(open);
    const closeVal = Number(close);

    if (isNaN(openVal) || isNaN(closeVal)) {
      return { error: "Invalid input" };
    }

    const absDiff = Math.abs(openVal - closeVal);

    // Difference > 1 → use old calculateSmartPoints01 logic
    if (absDiff > 1) {
      let toFixeddesimal = 2;

      if (absDiff !== 0) {
        const diffStr = absDiff.toFixed(10);
        const decimalPart = diffStr.split(".")[1];

        let index = 0;
        while (index < decimalPart.length && decimalPart[index] === "0") {
          index++;
        }

        toFixeddesimal = Math.max(2, index + 1);
      }

      const openNum = truncateNumber(openVal, toFixeddesimal);
      const closeNum = truncateNumber(closeVal, toFixeddesimal);

      const diff = closeNum - openNum;
      const unitSize = Math.pow(10, -toFixeddesimal);

      const points = Math.round(diff / unitSize);

      return {
        points,
        direction: points > 0 ? "Profit" : points < 0 ? "Loss" : "No Change",
      };
    }

    // Difference <= 1 → use old calculateSmartPoints logic
    const diff = closeVal - openVal;
    const points = Math.round(diff * 1000000);

    return {
      points,
      direction: points > 0 ? "Profit" : points < 0 ? "Loss" : "No Change",
    };
  }
  //   function calculateSmartPoints(open, close) {
  //   const diff = Number(close) - Number(open);
  //   const points = Math.round(diff * 1000000); // 5 decimal precision
  //   return {
  //     points,
  //     direction:
  //       points > 0 ? "Profit" : points < 0 ? "Loss" : "No Change",
  //   };
  // }
  useEffect(() => {
    let checkpoint = calculateSmartPoints(70929.04, 70943.05);
  }, []);
  const [scrolled, setScrolled] = useState(false);
  const scrollContainerRef = useRef(null);
  const toggleButtonRef = useRef(null);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const handleToggleCollapse5 = () => {
    setCollapseOpen((prev) => !prev);
  };
  useEffect(() => {
    if (!collapseOpen) {
      setCollapseshow((state) => ({
        ...state,
        leaderBoardCollapse: false,
      }));
    }
  }, [collapseOpen]);
  useEffect(() => {
    const container = scrollContainerRef.current;
    const handleScroll = () => {
      if (container.scrollTop > 85) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        amountcollapseRef.current &&
        !amountcollapseRef.current.contains(event.target) &&
        !event.target.closest(".incTop")
      ) {
        setAmountInput("");
        let convertstring;
        if (typeof amount === "string") {
          convertstring = amount;
        } else {
          convertstring = toString(amount);
        }
        if (
          convertstring === "" ||
          convertstring === "0" ||
          convertstring === "0." ||
          Number(convertstring) < 1
        ) {
          setAmount("1");
          timepriceprefrence("1");
        } else if (convertstring?.endsWith(".")) {
          const updatedAmount = convertstring.slice(0, -1);
          setAmount(updatedAmount);
          timepriceprefrence(updatedAmount);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [amount]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        inputRef.current.blur();
      }
    };
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const modal = modalRefs.current["socialTradingview_popup"];
      if (
        collapseleaderboardRef.current &&
        !collapseleaderboardRef.current.contains(event.target) &&
        (!modal || !modal.contains(event.target)) &&
        (!toggleButtonRef.current ||
          !toggleButtonRef.current.contains(event.target))
      ) {
        setShowCopyhistory(false);
        // setShowcopydeleteicon(false)
        setCollapseOpen(false);
        setCheckcopy(false);
        handleSelect("today");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);
  const settimerpre = async (value) => {
    try {
      setSwetchtimer(value);
      if (value === 0) {
        getchangeclosetimemodefrence();
      } else {
        gettimeprefrence();
      }
      let postdata = {
        key: "changetimemode",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        // getchangetimemodefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getchangetimemodefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=changetimemode`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setSwetchtimer(parsedValue);
        //  getchangeclosetimemodefrence();
        if (parsedValue === 0) {
          getchangeclosetimemodefrence();
        } else {
          gettimeprefrence();
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const setclosetimerpre = async (value) => {
    try {
      setCheckclosetime(value);
      let postdata = {
        key: "setupclosetime",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getchangeclosetimemodefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getchangeclosetimemodefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=setupclosetime`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setCheckclosetime(parsedValue);
      } else {
        setCheckclosetime({
          hours: "00",
          minutes: "00",
          secound: "30",
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const setclosetimeroffsetpre = async (value) => {
    try {
      let postdata = {
        key: "setautotimeoffset",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        gettimeoffsetprefrence();
        nextGetTimeRef.current = null;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gettimeoffsetprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=setautotimeoffset`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        if (parsedValue === 1) {
          setChecktimeOffset(true);
        } else {
          setChecktimeOffset(false);
        }
      } else {
        setChecktimeOffset(true);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gettimeoffsetprefrence();
    getchangetimemodefrence();
    nextGetTimeRef.current = null;
  }, []);
  const formatTimeObject = (totalSeconds) => {
    let hours = Math.floor(totalSeconds / 3600) % 24;
    let minutes = Math.floor((totalSeconds % 3600) / 60);
    let seconds = totalSeconds % 60;

    return {
      hour: String(hours).padStart(2, "0"),
      minute: String(minutes).padStart(2, "0"),
      second: String(seconds).padStart(2, "0"),
    };
  };

  const getCloseTimeInSeconds = () => {
    return (
      parseInt(checkclosetime.hours) * 3600 +
      parseInt(checkclosetime.minutes) * 60 +
      parseInt(checkclosetime.secound)
    );
  };
  const formatDuration = (currentTimestamp, nextTimestamp) => {
    const diff = Math.max(0, nextTimestamp - currentTimestamp);
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    return {
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      secound: String(seconds).padStart(2, "0"),
    };
  };
  const convertutctimeformated = (utcTimestamp) => {
    const year = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      timeZone: "UTC",
    }).format(utcTimestamp * 1000);
    const month = new Intl.DateTimeFormat("en-GB", {
      month: "2-digit",
      timeZone: "UTC",
    }).format(utcTimestamp * 1000);
    const day = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      timeZone: "UTC",
    }).format(utcTimestamp * 1000);
    const hour = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      hour12: false,
      timeZone: "UTC",
    }).format(utcTimestamp * 1000);
    const minute = new Intl.DateTimeFormat("en-GB", {
      minute: "2-digit",
      timeZone: "UTC",
    }).format(utcTimestamp * 1000);
    const second = new Intl.DateTimeFormat("en-GB", {
      second: "2-digit",
      timeZone: "UTC",
    }).format(utcTimestamp * 1000);
    const formattedTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return formattedTime;
  };
  const addSecondsSmart = (currentSec, extraSeconds) => {
    const remainder = currentSec % extraSeconds;
    const snapped = currentSec - remainder;
    const remainingToBlockEnd = extraSeconds - remainder;
    if (remainingToBlockEnd < 5) {
      return snapped + extraSeconds * 2;
    }
    return snapped + extraSeconds;
  };
  useEffect(() => {
    console.log("Timezone/close-time effect refreshed");

    if (!updatetimezone || !checkclosetime || swetchtimer !== 0) {
      return;
    }

    // =====================================================
    // IMPORTANT:
    // Whenever timezone changes, start completely fresh
    // =====================================================
    nextGetTimeRef.current = null;

    const timezoneOffset =
      (parseInt(updatetimezone?.haur || 0, 10) * 3600 +
        parseInt(updatetimezone?.minute || 0, 10) * 60) *
      (updatetimezone?.plus === "+" ? 1 : -1);

    // =====================================================
    // MIN / MAX TRADE TIME
    // =====================================================
    const MIN_TIME = 5; // 5 seconds
    const MAX_TIME = 4 * 60 * 60; // 4 hours = 14400 seconds

    // =====================================================
    // GET VALID CLOSE DURATION
    // =====================================================
    const getValidCloseDuration = () => {
      let duration = parseInt(getCloseTimeInSeconds() || 0, 10);

      // Minimum 5 seconds
      if (duration < MIN_TIME) {
        duration = MIN_TIME;
      }

      // Maximum 4 hours
      if (duration > MAX_TIME) {
        duration = MAX_TIME;
      }

      return duration;
    };

    // =====================================================
    // CHECK TIME
    // =====================================================
    const checkTime = () => {
      const runningTimestamp = currenttimecheckRef?.current?.timestamp;

      if (!runningTimestamp) {
        return;
      }

      // Current time according to selected timezone
      const currentSec = runningTimestamp + timezoneOffset;

      console.log(
        "Current:",
        currentSec,
        "Next:",
        nextGetTimeRef.current,
        "Timezone:",
        timezoneOffset,
      );

      // ===================================================
      // INITIALIZE CLOSE TIME
      // ===================================================
      if (!nextGetTimeRef.current) {
        const closeDuration = getValidCloseDuration();

        nextGetTimeRef.current = addSecondsSmart(currentSec, closeDuration);

        // -----------------------------------------------
        // Set close time
        // -----------------------------------------------
        setGetclosetimeTime(formatTimeObject(nextGetTimeRef.current));

        console.log(
          "Fresh close time initialized:",
          closeDuration,
          currentSec,
          nextGetTimeRef.current,
        );

        // -----------------------------------------------
        // UTC conversion
        // -----------------------------------------------
        const utcTimestamp = nextGetTimeRef.current - timezoneOffset;

        const formattedTime = convertutctimeformated(utcTimestamp);

        setClosetradetime(formattedTime);

        // -----------------------------------------------
        // Duration
        // -----------------------------------------------
        const Duration = formatDuration(currentSec, nextGetTimeRef.current);

        getFutureTimestamp(Duration, true);

        return;
      }

      // ===================================================
      // UPDATE CLOSE TIME
      // ===================================================
      //
      // IMPORTANT:
      // Don't use exact === because setInterval can skip
      // a particular second.
      //
      // Use >= instead.
      // ===================================================

      if (
        nextGetTimeRef.current &&
        currentSec >= nextGetTimeRef.current - 5 &&
        checktimeOffset
      ) {
        const closeDuration = getValidCloseDuration();

        // -----------------------------------------------
        // New close timestamp
        // -----------------------------------------------
        nextGetTimeRef.current = addSecondsSmart(
          nextGetTimeRef.current,
          closeDuration,
        );

        // -----------------------------------------------
        // Update input time
        // -----------------------------------------------
        setGetclosetimeTime(formatTimeObject(nextGetTimeRef.current));

        console.log(
          "Close time refreshed:",
          closeDuration,
          nextGetTimeRef.current,
        );

        // -----------------------------------------------
        // UTC conversion
        // -----------------------------------------------
        const utcTimestamp = nextGetTimeRef.current - timezoneOffset;

        const formattedTime = convertutctimeformated(utcTimestamp);

        setClosetradetime(formattedTime);

        // -----------------------------------------------
        // Duration
        // -----------------------------------------------
        const Duration = formatDuration(currentSec, nextGetTimeRef.current);

        getFutureTimestamp(Duration, true);
      }
    };

    // =====================================================
    // START FRESH
    // =====================================================
    const interval = setInterval(checkTime, 1000);

    // Run immediately
    checkTime();

    // =====================================================
    // CLEANUP
    // =====================================================
    return () => {
      clearInterval(interval);

      console.log("Timezone effect cleanup");
    };
  }, [
    updatetimezone?.haur,
    updatetimezone?.minute,
    updatetimezone?.plus,
    checkclosetime,
    swetchtimer,
    checktimeOffset,
  ]);
  const timeToSeconds = ({ hour, minute, second }) => {
    return (
      parseInt(hour || 0, 10) * 3600 +
      parseInt(minute || 0, 10) * 60 +
      parseInt(second || 0, 10)
    );
  };
  const secondsToTime = (totalSeconds) => {
    totalSeconds = ((totalSeconds % 86400) + 86400) % 86400;

    const hour = Math.floor(totalSeconds / 3600);
    const minute = Math.floor((totalSeconds % 3600) / 60);
    const second = totalSeconds % 60;

    return {
      hour: String(hour).padStart(2, "0"),
      minute: String(minute).padStart(2, "0"),
      second: String(second).padStart(2, "0"),
    };
  };
  const secondsToTimeObj = (totalSeconds) => {
    const hour = Math.floor(totalSeconds / 3600) % 24;
    const minute = Math.floor((totalSeconds % 3600) / 60);
    const second = totalSeconds % 60;

    return {
      hour: hour.toString().padStart(2, "0"),
      minute: minute.toString().padStart(2, "0"),
      second: second.toString().padStart(2, "0"),
    };
  };
  function getUnixTimestamp(dateStr, { hour, minute, second }) {
    const [day, month, year] = dateStr.split("-").map(Number);

    const timestamp = Date.UTC(
      year,
      month - 1,
      day,
      parseInt(hour || 0, 10),
      parseInt(minute || 0, 10),
      parseInt(second || 0, 10),
    );

    return Math.floor(timestamp / 1000);
  }
  const updateTimeSafely = (newTime) => {
    const newSec = getUnixTimestamp(
      currenttimecheckRef.current.datetime.split(" ")[0],
      newTime,
    );

    const timezoneOffset =
      (parseInt(updatetimezone?.haur || 0, 10) * 3600 +
        parseInt(updatetimezone?.minute || 0, 10) * 60) *
      (updatetimezone?.plus === "+" ? 1 : -1);

    if (currenttimecheckRef?.current?.timestamp) {
      const currentSec = currenttimecheckRef.current.timestamp + timezoneOffset;

      // =================================================
      // SELECTED CLOSE TIME IS IN PAST / SAME TIME
      // =================================================

      if (newSec <= currentSec) {
        const fallbackSec = currentSec + getCloseTimeInSeconds();

        // Existing behavior preserved,
        // but maximum 4 hours enforced
        const maxAllowedSec = currentSec + MAX_CLOSE_TIME_SECONDS;

        const adjustedFallbackSec = Math.min(
          maxAllowedSec,
          Math.max(currentSec + MIN_CLOSE_TIME_SECONDS, fallbackSec),
        );

        const utcTimestamp = adjustedFallbackSec - timezoneOffset;

        const formattedTime = convertutctimeformated(utcTimestamp);

        setClosetradetime(formattedTime);

        setGetclosetimeTime(secondsToTime(adjustedFallbackSec));

        nextGetTimeRef.current = adjustedFallbackSec;

        const Duration = formatDuration(currentSec, adjustedFallbackSec);

        getFutureTimestamp(Duration, true);

        return;
      }

      // =================================================
      // SELECTED TIME IS FUTURE
      // =================================================

      let adjustedSec = newSec;

      // Minimum = current time + 5 seconds
      const minAllowedSec = currentSec + MIN_CLOSE_TIME_SECONDS;

      // Maximum = current time + 4 hours
      const maxAllowedSec = currentSec + MAX_CLOSE_TIME_SECONDS;

      // -----------------------------------------------
      // Less than minimum 5 seconds
      // -----------------------------------------------
      if (adjustedSec < minAllowedSec) {
        adjustedSec = minAllowedSec;
      }

      // -----------------------------------------------
      // More than maximum 4 hours
      // -----------------------------------------------
      if (adjustedSec > maxAllowedSec) {
        adjustedSec = maxAllowedSec;
      }

      // =================================================
      // UPDATE FINAL TIME
      // =================================================

      const Duration = formatDuration(currentSec, adjustedSec);

      getFutureTimestamp(Duration, true);

      const utcTimestamp = adjustedSec - timezoneOffset;

      const formattedTime = convertutctimeformated(utcTimestamp);

      setClosetradetime(formattedTime);

      setGetclosetimeTime(secondsToTime(adjustedSec));

      nextGetTimeRef.current = adjustedSec;

      return;
    }

    // =================================================
    // FALLBACK WHEN CURRENT TIMESTAMP IS NOT AVAILABLE
    // =================================================

    const utcTimestamp = newSec - timezoneOffset;

    const formattedTime = convertutctimeformated(utcTimestamp);

    setClosetradetime(formattedTime);

    setGetclosetimeTime(newTime);

    nextGetTimeRef.current = newSec;
  };

  const clampTime = (h, m, s) => {
    let hour = Math.max(0, h);
    let minute = Math.max(0, m);
    let second = Math.max(0, s);

    if (second > 59) {
      second = 0;
      minute += 1;
    }
    if (minute > 59) {
      minute = 0;
      hour += 1;
    }
    return {
      hour: String(hour).padStart(2, "0"),
      minute: String(minute).padStart(2, "0"),
      second: String(second).padStart(2, "0"),
    };
  };

  const handleIncrement = (field) => {
    let { hour, minute, second } = GetclosetimeTime;

    hour = parseInt(hour || 0, 10);

    minute = parseInt(minute || 0, 10);

    second = parseInt(second || 0, 10);

    if (field === "hour") {
      hour++;
    }

    if (field === "minute") {
      minute++;
    }

    if (field === "second") {
      second++;
    }

    // Handle normal clock rollover
    if (second > 59) {
      second = 0;
      minute++;
    }

    if (minute > 59) {
      minute = 0;
      hour++;
    }

    if (hour > 23) {
      hour = 0;
    }

    updateTimeSafely({
      hour: String(hour).padStart(2, "0"),
      minute: String(minute).padStart(2, "0"),
      second: String(second).padStart(2, "0"),
    });
  };

  // =====================================================
  // MINUS
  // =====================================================
  const handleDecrement = (field) => {
    let { hour, minute, second } = GetclosetimeTime;

    hour = parseInt(hour || 0, 10);

    minute = parseInt(minute || 0, 10);

    second = parseInt(second || 0, 10);

    if (field === "hour") {
      hour--;
    }

    if (field === "minute") {
      minute--;
    }

    if (field === "second") {
      second--;
    }

    // Handle clock rollover
    if (second < 0) {
      second = 59;
      minute--;
    }

    if (minute < 0) {
      minute = 59;
      hour--;
    }

    if (hour < 0) {
      hour = 23;
    }

    updateTimeSafely({
      hour: String(hour).padStart(2, "0"),
      minute: String(minute).padStart(2, "0"),
      second: String(second).padStart(2, "0"),
    });
  };
  const handlecloseInputChange = (e, field) => {
    let value = e.target.value.replace(/\D/g, "");

    // Don't allow invalid empty value to break calculation
    if (value === "") {
      return;
    }

    let num = parseInt(value, 10);

    // Actual clock hour
    if (field === "hour") {
      num = Math.min(23, num);
    }

    // Actual clock minute / second
    if (field === "minute" || field === "second") {
      num = Math.min(59, num);
    }

    const newTime = {
      ...GetclosetimeTime,
      [field]: String(num).padStart(2, "0"),
    };

    updateTimeSafely(newTime);
  };
  const getsocialcount = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/social-copy-count`, "GET");
      if (res?.data?.success) {
        //  setCopycount(res?.data?.copy);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsocialcount();
  }, []);

  const dissallowcopy = async (id, type) => {
    try {
      let postdata = {
        block_user_id: id,
        type: type,
      };
      let res = await authcallApi(postdata, `api/blocktrade`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        getblockcopylist();
        if (type === "copy") {
          getsocialtrade("Trader who copy me");
        } else {
          getsocialtrade("Trader who watch me");
        }
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const allowcopy = async (id, type) => {
    try {
      let postdata = {
        block_user_id: id,
        type: type,
      };
      let res = await authcallApi(postdata, `api/unblocktrade`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        getblockcopylist();
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getblockcopylist = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/blockall`, "GET");
      if (res?.data?.success) {
        setBlockcopylist(res?.data?.data);
        if (res?.data?.data?.length) {
          let array = [];
          res?.data?.data.forEach((item) => {
            if (item?.type === "copy") {
              array.push(item);
            }
          });
          setBlocklistcount(array?.length);
        } else {
          setBlocklistcount(0);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getblockcopylist();
  }, []);
  const checkleaderboardstatus = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/leaderboard-status`, "GET");
      if (res?.data?.success) {
        if (res?.data?.data?.site?.length) {
          res?.data?.data?.site.forEach((item, key) => {
            if (item?.sr === 1) {
              setCheckleaderboard((state) => ({
                ...state,
                hide_leaderboaed: item?.status === "1" ? true : false,
              }));
            } else {
              setCheckleaderboard((state) => ({
                ...state,
                rank: item?.status === "1" ? true : false,
              }));
            }
          });
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    checkleaderboardstatus();
  }, []);
  useEffect(() => {
    if (message?.data) {
      let stringifymsg = message?.data;
      if (stringifymsg?.leaderboard) {
        checkleaderboardstatus();
      }

      if (stringifymsg?.canceltrade?.length) {
        setWallupdate(false);
        const cancelIds = stringifymsg.canceltrade;
        let updatedClosedata = { ...closedata };
        for (const dateKey in updatedClosedata) {
          if (Array.isArray(updatedClosedata[dateKey])) {
            updatedClosedata[dateKey] = updatedClosedata[dateKey].filter(
              (item) => !cancelIds.includes(item.id),
            );
            if (updatedClosedata[dateKey].length === 0) {
              delete updatedClosedata[dateKey];
            }
          }
        }
        setWallupdate(true);
        const validDatePattern = /^\d{4}-\d{2}-\d{2}$/;
        const filteredGroupedTrades = Object.fromEntries(
          Object.entries(updatedClosedata).filter(([date]) =>
            validDatePattern.test(date),
          ),
        );
        setClosdata(filteredGroupedTrades);
      }
    }
  }, [message]);
  const searchtrader = async (tradetid) => {
    try {
      setSearchloading(true);
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/search-trader?trader_id=${tradetid}`,
        "GET",
      );
      if (res?.data?.success) {
        setSearchfilterdata(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setSearchloading(false);
    }
  };
  const deletecopyhistory = async (id) => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/copy-history-delete/${id}`,
        "DELETE",
      );
      if (res?.data?.success) {
        setShowcopydeleteicon(false);
        if (socialfilter?.label === "List of copied traders") {
          getsocialtrade("List of copied traders");
        }
        userdetailsfromid(userdata?.user_id, "", "today", false);
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    let bothamount_error = false;
    let mintotel = parseFloat(
      (100 * Number(unformatPrice(copysetting?.min_trade_amount))) /
        Number(copysetting?.proportion),
    ).toFixed(2);
    let checkminamount =
      Number(copysetting?.proportion) > 100
        ? 2 > Number(unformatPrice(copysetting?.min_trade_amount))
          ? true
          : false
        : 1 > Number(unformatPrice(copysetting?.min_trade_amount))
          ? true
          : false;

    let maxtotel = unformatPrice(copysetting?.max_copy_trade_value)
      ? parseFloat(
          (100 * Number(unformatPrice(copysetting?.max_copy_trade_value))) /
            Number(copysetting?.proportion),
        ).toFixed(2)
      : 0;

    let checkmaxamount = unformatPrice(copysetting?.max_copy_trade_value)
      ? Number(copysetting?.proportion) > 100
        ? 2 > Number(unformatPrice(copysetting?.max_copy_trade_value))
          ? true
          : false
        : 1 > Number(unformatPrice(copysetting?.max_copy_trade_value))
          ? true
          : false
      : false;
    if (unformatPrice(copysetting?.max_copy_trade_value)) {
      if (
        Number(unformatPrice(copysetting?.max_copy_trade_value)) <
        Number(unformatPrice(copysetting?.min_trade_amount))
      ) {
        bothamount_error = true;
      }
    }
    setcopysetting((state) => ({
      ...state,
      min_totel_amount: formatPrice(mintotel, 2),
      checkminamount: checkminamount,
      max_totel_amount: formatPrice(maxtotel, 2),
      checkmaxamount: checkmaxamount,
      bothamount_error: bothamount_error,
    }));
  }, [
    copysetting?.max_copy_trade_value,
    copysetting?.min_trade_amount,
    copysetting?.proportion,
  ]);

  const openassetcart = (name) => {
    let array = [];
    if (assetlist?.cryptocurrencieslist?.length) {
      array = [...array, ...assetlist?.cryptocurrencieslist];
    }
    if (assetlist?.currencieslist?.length) {
      array = [...array, ...assetlist?.currencieslist];
    }
    if (!array?.length || !name) return;
    array.forEach((item) => {
      if (item?.name === name) {
        setshowtradeasset(item, "chartasset");
        setChartLoader(true);
      }
    });
  };

  const [prices, setPrices] = useState({});
  const getliveprice = async (result) => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/otc/last?ct=${result}`, "get");
      if (res?.data?.success) {
        if (res?.data?.data?.c) {
          return { close: res?.data?.data?.c };
        } else {
          return { close: 0.0 };
        }
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };

  useEffect(() => {
    const fetchPrices = async () => {
      let priceObj = {};
      const uniqueTickers = [...new Set(opentrade.map((item) => item?.ticker))];
      for (const ticker of uniqueTickers) {
        const data = await getliveprice(ticker);
        priceObj[ticker] = data?.close;
      }
      setPrices(priceObj);
    };
    if (opentrade?.length) {
      fetchPrices();
    }
  }, [opentrade]);
  const getcopyhistory = async (id) => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/copyhistory?copy_trade_id=${id}`,
        "GET",
      );
      if (res?.data?.success) {
        setHistory(res?.data?.data || []);
        setCurrentIndex(0);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const currentHistory = history[currentIndex];
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleNext = () => {
    if (currentIndex < history.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  return (
    <React.Fragment>
      {/* right sidebar start */}
      <div
        className={`right_sidebarcol ${collapseOpen ? "leaderboard-show" : ""}`}
      >
        <div className="right-sidebar_fix">
          <div className="timerbox02">
            <div
              onClick={() => {
                // setOpenmodal(!openmodal);
                handleToggleCollapse(
                  "selecttradeCollapse",
                  {},
                  false,
                  null,
                  false,
                  false,
                );
              }}
              className="itemList onclicksearch"
              data-bs-toggle="collapse"
              // href="#selecttradeCollapse"
              role="button"
              aria-expanded="false"
              aria-controls="selecttradeCollapse"
            >
              <Link to="" onClick={(e) => e.preventDefault()}>
                <img
                  src={
                    chnagetyperef.current?.image
                      ? process.env.REACT_APP_BASE_IMAGE_URL +
                        chnagetyperef.current?.image
                      : Bitcoin
                  }
                  alt=""
                />
                <h5>
                  {chnagetyperef.current?.name}{" "}
                  <small>FT • +{chnagetyperef.current?.payout}%</small>
                </h5>
                <i className="fa-solid fa-chevron-down"></i>
              </Link>
            </div>
            <div className="pmincBox mb-3 timebox">
              <div className="incTop position-relative">
                <div
                  className={`timeClockoption ${swetchtimer === 0 && "d-none"}`}
                >
                  <div
                    className=""
                    data-bs-toggle="collapse"
                    // data-bs-target="#timeClockCollapse"
                    role="button"
                    aria-expanded="false"
                    aria-controls="timeClockCollapse"
                    onClick={() => {
                      handleToggleCollapse("timeClockCollapse");
                    }}
                  >
                    <h5>{t("Time")}</h5>
                    <div className="timeview">
                      {time?.hours}:{time?.minutes}:{time?.secound}
                    </div>
                    {/* <!-- <input type="time" name="time" step="1" required placeholder="hh:mm:ss" className="form-control amount time"> --> */}
                  </div>
                  <div
                    onClick={() => {
                      settimerpre(0);
                      setIsClicked((state) => ({
                        ...state,
                        timer: true,
                      }));
                      setTimeout(
                        () =>
                          setIsClicked((state) => ({
                            ...state,
                            timer: false,
                          })),
                        200,
                      );
                    }}
                    className={`icon_topborder pointercursor ${
                      isClicked?.timer ? "click" : ""
                    }`}
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    data-bs-original-title="Switch expiration mode"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2913 11.0417C17.2913 15.0667 14.0247 18.3333 9.99967 18.3333C5.97467 18.3333 2.70801 15.0667 2.70801 11.0417C2.70801 7.01667 5.97467 3.75 9.99967 3.75C14.0247 3.75 17.2913 7.01667 17.2913 11.0417Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 6.66663V10.8333"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.5 1.66663H12.5"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  className={`timeClockflagoption ${
                    swetchtimer === 1 && "d-none"
                  }`}
                >
                  <div
                    className="w-100"
                    data-bs-toggle="collapse"
                    onClick={() => {
                      handleToggleCollapse("timeClockCollapse");
                    }}
                    role="button"
                    aria-expanded="false"
                    aria-controls="timeClockCollapse"
                  >
                    <h5>
                      Time UTC
                      {updatetimezone?.time ? updatetimezone?.time : "00:00"}
                    </h5>
                    {GetclosetimeTime?.hour &&
                      GetclosetimeTime?.minute &&
                      GetclosetimeTime?.second && (
                        <div className="timeview">{`${GetclosetimeTime?.hour}:${GetclosetimeTime?.minute}:${GetclosetimeTime?.second}`}</div>
                      )}
                  </div>
                  <div
                    onClick={() => {
                      settimerpre(1);
                      setIsClicked((state) => ({
                        ...state,
                        timer: true,
                      }));
                      setTimeout(
                        () =>
                          setIsClicked((state) => ({
                            ...state,
                            timer: false,
                          })),
                        200,
                      );
                    }}
                    className={`icon_topborder pointercursor ${
                      isClicked?.timer ? "click" : ""
                    }`}
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    data-bs-original-title="Switch expiration mode"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      width="20"
                      height="20"
                      fill="rgba(255,255,255,1)"
                    >
                      <path d="M12.382 3C12.7607 3 13.107 3.214 13.2764 3.55279L14 5H20C20.5523 5 21 5.44772 21 6V17C21 17.5523 20.5523 18 20 18H13.618C13.2393 18 12.893 17.786 12.7236 17.4472L12 16H5V22H3V3H12.382ZM11.7639 5H5V14H13.2361L14.2361 16H19V7H12.7639L11.7639 5Z"></path>
                    </svg>
                  </div>
                </div>
                {/* <!-- <div className="incBottom">
               <span className="minus btn"><img src="images/minus.svg"></span>
               <span className="plus btn"><img src="images/add.svg"></span>
            </div> --> */}
                {/* <!-- --------- Time and clock Start----------- --> */}
                <div className="collapsePop collapse" id="timeClockCollapse">
                  {swetchtimer === 0 ? (
                    <div className="timeClockOption">
                      <div className="form-group mb-3">
                        <div className="input-group timeframeInput">
                          <div className="incdicbutton">
                            <span
                              className="plus btn"
                              onClick={() => handleIncrement("hour")}
                            >
                              <img src={add} alt="" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00"
                              value={GetclosetimeTime.hour}
                              onChange={(e) =>
                                handlecloseInputChange(e, "hour")
                              }
                            />
                            <span
                              className="minus btn"
                              onClick={() => handleDecrement("hour")}
                            >
                              <img src={minus} alt="" />
                            </span>
                          </div>

                          <div className="incdicbutton">
                            <span
                              className="plus btn"
                              onClick={() => handleIncrement("minute")}
                            >
                              <img src={add} alt="" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00"
                              value={GetclosetimeTime.minute}
                              onChange={(e) =>
                                handlecloseInputChange(e, "minute")
                              }
                            />
                            <span
                              className="minus btn"
                              onClick={() => handleDecrement("minute")}
                            >
                              <img src={minus} alt="" />
                            </span>
                          </div>

                          <div className="incdicbutton">
                            <span
                              className="plus btn"
                              onClick={() => handleIncrement("second")}
                            >
                              <img src={add} alt="" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00"
                              value={GetclosetimeTime.second}
                              onChange={(e) =>
                                handlecloseInputChange(e, "second")
                              }
                            />
                            <span
                              className="minus btn"
                              onClick={() => handleDecrement("second")}
                            >
                              <img src={minus} alt="" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="boxbg pb-0">
                        <div class="form-check form-switch">
                          <div class="check-input-div">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              checked={checktimeOffset}
                              onChange={(e) =>
                                setclosetimeroffsetpre(e.target.checked ? 1 : 0)
                              }
                            />
                          </div>
                          <label class="form-check-label">
                            Auto Time Offset
                          </label>
                        </div>
                      </div>
                      <ul
                        className={`timeframes ${!checktimeOffset && "d-none"}`}
                      >
                        <li
                          onClick={() =>
                            setclosetimerpre({
                              hours: "00",
                              minutes: "00",
                              secound: "30",
                            })
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${
                              checkclosetime?.hours === "00" &&
                              checkclosetime?.minutes === "00" &&
                              checkclosetime?.secound === "30"
                                ? "active"
                                : ""
                            }`}
                          >
                            +S30
                          </button>
                        </li>

                        <li
                          onClick={() =>
                            setclosetimerpre({
                              hours: "00",
                              minutes: "01",
                              secound: "00",
                            })
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${
                              checkclosetime?.hours === "00" &&
                              checkclosetime?.minutes === "01" &&
                              checkclosetime?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            +M1
                          </button>
                        </li>

                        <li
                          onClick={() =>
                            setclosetimerpre({
                              hours: "00",
                              minutes: "02",
                              secound: "00",
                            })
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${
                              checkclosetime?.hours === "00" &&
                              checkclosetime?.minutes === "02" &&
                              checkclosetime?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            +M2
                          </button>
                        </li>

                        <li
                          onClick={() =>
                            setclosetimerpre({
                              hours: "00",
                              minutes: "03",
                              secound: "00",
                            })
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${
                              checkclosetime?.hours === "00" &&
                              checkclosetime?.minutes === "03" &&
                              checkclosetime?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            +M3
                          </button>
                        </li>

                        <li
                          onClick={() =>
                            setclosetimerpre({
                              hours: "00",
                              minutes: "05",
                              secound: "00",
                            })
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${
                              checkclosetime?.hours === "00" &&
                              checkclosetime?.minutes === "05" &&
                              checkclosetime?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            +M5
                          </button>
                        </li>

                        <li
                          onClick={() =>
                            setclosetimerpre({
                              hours: "00",
                              minutes: "30",
                              secound: "00",
                            })
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${
                              checkclosetime?.hours === "00" &&
                              checkclosetime?.minutes === "30" &&
                              checkclosetime?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            +M30
                          </button>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div className="timeClockOption">
                      <div className="form-group mb-3">
                        <div className="input-group timeframeInput">
                          <div className="incdicbutton">
                            <span
                              className="plus btn"
                              onClick={() => updowntime("add", "hours")}
                            >
                              <img src={add} alt="" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00"
                              onChange={(e) =>
                                timeset(
                                  e.target.value,
                                  time?.minutes,
                                  time?.secound,
                                )
                              }
                              value={time?.hours}
                            />
                            <span
                              className="minus btn"
                              onClick={() => updowntime("minus", "hours")}
                            >
                              <img src={minus} alt="" />
                            </span>
                          </div>
                          <div className="incdicbutton">
                            <span
                              className="plus btn"
                              onClick={() => updowntime("add", "minutes")}
                            >
                              <img src={add} alt="" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00"
                              onChange={(e) =>
                                timeset(
                                  time?.hours,
                                  e.target.value,
                                  time?.secound,
                                )
                              }
                              value={time?.minutes}
                            />
                            <span
                              className="minus btn"
                              onClick={() => updowntime("minus", "minutes")}
                            >
                              <img src={minus} alt="" />
                            </span>
                          </div>
                          <div className="incdicbutton">
                            <span
                              className="plus btn"
                              onClick={() => updowntime("add", "secound")}
                            >
                              <img src={add} alt="" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="00"
                              onChange={(e) =>
                                timeset(
                                  time?.hours,
                                  time?.minutes,
                                  e.target.value,
                                )
                              }
                              value={time?.secound}
                            />
                            <span
                              className={`minus btn ${
                                time?.hours === "00" &&
                                time?.minutes === "00" &&
                                time?.secound === "05"
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() => {
                                if (
                                  !(
                                    time?.hours === "00" &&
                                    time?.minutes === "00" &&
                                    time?.secound === "05"
                                  )
                                ) {
                                  updowntime("minus", "secound");
                                }
                              }}
                              style={{
                                opacity:
                                  time?.hours === "00" &&
                                  time?.minutes === "00" &&
                                  time?.secound === "05"
                                    ? 0.5
                                    : 1,
                              }}
                            >
                              <img src={minus} alt="" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <ul className="timeframes">
                        <li onClick={() => timeset("00", "00", "05")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "00" &&
                              time?.secound === "05"
                                ? "active"
                                : ""
                            }`}
                          >
                            S5
                          </button>
                        </li>
                        <li onClick={() => timeset("00", "00", "15")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "00" &&
                              time?.secound === "15"
                                ? "active"
                                : ""
                            }`}
                          >
                            S15
                          </button>
                        </li>
                        <li onClick={() => timeset("00", "00", "30")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "00" &&
                              time?.secound === "30"
                                ? "active"
                                : ""
                            }`}
                          >
                            S30
                          </button>
                        </li>
                        <li onClick={() => timeset("00", "01", "00")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "01" &&
                              time?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            M1
                          </button>
                        </li>
                        <li onClick={() => timeset("00", "03", "00")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "03" &&
                              time?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            M3
                          </button>
                        </li>
                        <li onClick={() => timeset("00", "05", "00")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "05" &&
                              time?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            M5
                          </button>
                        </li>
                        <li onClick={() => timeset("00", "30", "00")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "00" &&
                              time?.minutes === "30" &&
                              time?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            M30
                          </button>
                        </li>
                        <li onClick={() => timeset("01", "00", "00")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "01" &&
                              time?.minutes === "00" &&
                              time?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            H1
                          </button>
                        </li>
                        <li onClick={() => timeset("04", "00", "00")}>
                          <button
                            type="button"
                            className={`btn ${
                              time?.hours === "04" &&
                              time?.minutes === "00" &&
                              time?.secound === "00"
                                ? "active"
                                : ""
                            }`}
                          >
                            H4
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                {/* <!-- --------- Time and clock End----------- --> */}
                {/* <!-- --------- Time Start ----------- --> */}
                <div className="collapsePop collapse" id="timeCollapse">
                  <div className="timeClockOption">
                    <div className="form-group mb-3">
                      <div className="input-group timeframeInput">
                        <div className="incdicbutton">
                          <span
                            className="plus btn"
                            onClick={() => updowntime("add", "hours")}
                          >
                            <img src={add} alt="" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="00"
                            onChange={(e) =>
                              timeset(
                                e.target.value,
                                time?.minutes,
                                time?.secound,
                              )
                            }
                            value={time?.hours}
                          />
                          <span
                            className="minus btn"
                            onClick={() => updowntime("minus", "hours")}
                          >
                            <img src={minus} alt="" />
                          </span>
                        </div>
                        <div className="incdicbutton">
                          <span
                            className="plus btn"
                            onClick={() => updowntime("add", "minutes")}
                          >
                            <img src={add} alt="" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="00"
                            onChange={(e) =>
                              timeset(
                                time?.hours,
                                e.target.value,
                                time?.secound,
                              )
                            }
                            value={time?.minutes}
                          />
                          <span
                            className="minus btn"
                            onClick={() => updowntime("minus", "minutes")}
                          >
                            <img src={minus} alt="" />
                          </span>
                        </div>
                        <div className="incdicbutton">
                          <span
                            className="plus btn"
                            onClick={() => updowntime("add", "secound")}
                          >
                            <img src={add} alt="" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="00"
                            onChange={(e) =>
                              timeset(
                                time?.hours,
                                time?.minutes,
                                e.target.value,
                              )
                            }
                            value={time?.secound}
                          />
                          <span
                            className={`minus btn ${
                              time?.hours === "00" &&
                              time?.minutes === "00" &&
                              time?.secound === "05"
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              if (
                                !(
                                  time?.hours === "00" &&
                                  time?.minutes === "00" &&
                                  time?.secound === "05"
                                )
                              ) {
                                updowntime("minus", "secound");
                              }
                            }}
                            style={{
                              opacity:
                                time?.hours === "00" &&
                                time?.minutes === "00" &&
                                time?.secound === "05"
                                  ? 0.5
                                  : 1,
                            }}
                          >
                            <img src={minus} alt="" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <ul className="timeframes">
                      <li onClick={() => timeset("00", "00", "05")}>
                        <button type="button" className="btn">
                          S5
                        </button>
                      </li>
                      <li onClick={() => timeset("00", "00", "15")}>
                        <button type="button" className="btn">
                          S15
                        </button>
                      </li>
                      <li onClick={() => timeset("00", "00", "30")}>
                        <button type="button" className="btn">
                          S30
                        </button>
                      </li>
                      <li onClick={() => timeset("00", "01", "00")}>
                        <button type="button" className="btn">
                          M1
                        </button>
                      </li>
                      <li onClick={() => timeset("00", "03", "00")}>
                        <button type="button" className="btn">
                          M3
                        </button>
                      </li>
                      <li onClick={() => timeset("00", "05", "00")}>
                        <button type="button" className="btn">
                          M5
                        </button>
                      </li>
                      <li onClick={() => timeset("00", "30", "00")}>
                        <button type="button" className="btn">
                          M30
                        </button>
                      </li>
                      <li onClick={() => timeset("01", "00", "00")}>
                        <button type="button" className="btn">
                          H1
                        </button>
                      </li>
                      <li onClick={() => timeset("04", "00", "00")}>
                        <button type="button" className="btn">
                          H4
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!-- --------- Time and clock End----------- --> */}
              </div>
            </div>
          </div>
          <div className="pmincBox position-relative">
            <div
              className="incTop"
              data-bs-toggle="collapse"
              // data-bs-target="#timeClockCollapse"
              role="button"
              aria-expanded="false"
              aria-controls="amountCollapse"
              onClick={() => {
                handleToggleCollapse("amountCollapse");
                setAmountInput("");
              }}
            >
              <h5>
                {t("Amount")} <img src={info} alt="" />
              </h5>
              <input
                ref={inputRef}
                type="text"
                name="amount"
                className="form-control amount"
                value={`$${formatPricewithdesimal(amount, 2)}`}
                placeholder="$1"
                onChange={handleInputChange}
                onBlur={handleBlur}
                autocomplete="off"
                onKeyDown={handleKeyDown}
              />
              <span className="form-control amount input-span">{`$${formatPrice(
                amount,
                2,
              )}`}</span>
            </div>
            <div className="incBottom">
              <span
                className={`minus btn ${isClicked?.minus ? "click" : ""}`}
                onClick={() => {
                  priceupdate("minus");
                  setIsClicked((state) => ({
                    ...state,
                    minus: true,
                  }));
                  setTimeout(
                    () =>
                      setIsClicked((state) => ({
                        ...state,
                        minus: false,
                      })),
                    200,
                  );
                }}
              >
                <img src={minus} alt="" />
              </span>
              <span
                className={`plus btn ${isClicked?.plus ? "click" : ""}`}
                onClick={() => {
                  priceupdate("add");
                  setIsClicked((state) => ({
                    ...state,
                    plus: true,
                  }));
                  setTimeout(
                    () =>
                      setIsClicked((state) => ({
                        ...state,
                        plus: false,
                      })),
                    200,
                  );
                }}
              >
                <img src={add} alt="" />
              </span>
            </div>

            <div
              className="collapsePop collapse"
              ref={amountcollapseRef}
              id="amountCollapse"
            >
              <div className="timeClockOption">
                <div className="form-group mb-3">
                  <div className="input-group amountfill">
                    <div className="defultamount">
                      {/* ${formatPrice(amount, 2)} */}${amount}
                    </div>
                    <div className="clickicon">
                      <button type="button" onClick={() => Calcamount("multi")}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="10"
                          viewBox="0 0 10 10"
                          fill="none"
                          class="injected-svg"
                          data-src="/themes/cabinet/svg/icons/trading-panel/amount-list-modal/umnozenie.svg"
                          // xmlns="http://www.w3.org/1999/xlink"
                          role="img"
                        >
                          <path
                            d="M4.97472 0C5.49667 0 5.90575 0.448521 5.85784 0.968265L5.54497 4.36264L8.74091 3.39639C9.25849 3.2399 9.79387 3.58121 9.87045 4.11648C9.94125 4.61131 9.58751 5.06617 9.09049 5.11943L6 5.45055L7.99098 8.20446C8.3066 8.64103 8.17371 9.25492 7.70579 9.52187C7.25175 9.78091 6.67331 9.60291 6.44345 9.13342L4.95238 6.08791L3.60336 9.09227C3.38379 9.58127 2.7936 9.77875 2.32395 9.52038C1.84203 9.25526 1.70001 8.62866 2.02052 8.18167L3.97884 5.45055L0.919005 5.12097C0.41837 5.06704 0.0640767 4.6061 0.140753 4.10844C0.222759 3.57619 0.757949 3.24063 1.27276 3.39868L4.4127 4.36264L4.0918 0.970389C4.04256 0.449916 4.45192 0 4.97472 0Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button
                        type="button"
                        onClick={() => Calcamount("divied")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="11"
                          viewBox="0 0 10 11"
                          fill="none"
                          class="injected-svg"
                          data-src="/themes/cabinet/svg/icons/trading-panel/amount-list-modal/delenie.svg"
                          // xmlns="http://www.w3.org/1999/xlink"
                          role="img"
                        >
                          <path
                            d="M6 1.5C6 2.05228 5.55228 2.5 5 2.5C4.44772 2.5 4 2.05228 4 1.5C4 0.947715 4.44772 0.5 5 0.5C5.55228 0.5 6 0.947715 6 1.5Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M6 9.5C6 10.0523 5.55228 10.5 5 10.5C4.44772 10.5 4 10.0523 4 9.5C4 8.94771 4.44772 8.5 5 8.5C5.55228 8.5 6 8.94771 6 9.5Z"
                            fill="currentColor"
                          ></path>
                          <path
                            d="M0 5.5C0 4.94772 0.447715 4.5 1 4.5H9C9.55228 4.5 10 4.94772 10 5.5C10 6.05228 9.55228 6.5 9 6.5H1C0.447716 6.5 0 6.05228 0 5.5Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    <input
                      onChange={(e) => {
                        const val = parseInt(e.target.value);
                        if (!isNaN(val) && val >= 1 && val <= 99) {
                          setCalculateamount(val);
                        } else if (e.target.value === "") {
                          setCalculateamount(0);
                        } else {
                          setCalculateamount(99);
                        }
                      }}
                      min="1"
                      max="99"
                      value={calculateamount}
                      type="number"
                      className="from-control text-center"
                    />
                  </div>
                </div>
                <ul className="timeframes amountblock">
                  {getSuggestedAmounts(amount).map((val, key) => {
                    return (
                      <li key={key}>
                        <button
                          type="button"
                          className="btn"
                          onClick={() => {
                            const intnumber = parseFloat(
                              walletdata.replace(/,/g, ""),
                            );
                            const value = parseFloat(val);

                            if (value > intnumber) {
                              return;
                            }

                            setAmountInput(String(val));
                            setAmount(val);
                          }}
                        >
                          ${formatPrice(parseFloat(val).toFixed(2), 2)}
                        </button>
                      </li>
                    );
                  })}
                  <li onClick={() => maxamoumt()}>
                    <button type="button" className="btn">
                      {t("MAX")}
                    </button>
                  </li>
                </ul>
                <ul className="timeframes">
                  {["7", "8", "9", "4", "5", "6", "1", "2", "3", ".", "0"].map(
                    (num, key) => {
                      return (
                        <li key={key}>
                          <button
                            // disabled={amountbuttionref.current}
                            type="button"
                            className="btn"
                            onClick={() => {
                              handleClick(num);
                            }}
                          >
                            {num}
                          </button>
                        </li>
                      );
                    },
                  )}
                  <li onClick={() => handleBackspace()}>
                    <button type="button" className="btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="14"
                        viewBox="0 0 20 14"
                        fill="none"
                        class="injected-svg"
                        data-src="/themes/cabinet/svg/icons/virtual-keyboards/back.svg"
                        // xmlns:xlink="http://www.w3.org/1999/xlink"
                        role="img"
                      >
                        <path
                          d="M17.7102 13.2825H6.58949C5.98304 13.2825 5.39019 13.0338 4.96259 12.6028L0.657742 8.25026C-0.219573 7.361 -0.219573 5.91639 0.657742 5.03228L4.96259 0.679716C5.39018 0.248721 5.98299 0 6.58949 0H17.7102C18.9708 0 19.9998 1.02555 19.9998 2.28956V10.9947C19.9998 12.2536 18.9708 13.2825 17.7102 13.2825ZM6.58949 1.08857C6.27092 1.08857 5.96088 1.21974 5.73943 1.44631L1.43458 5.79887C0.972917 6.26563 0.972917 7.02031 1.43458 7.48708L5.73943 11.8396C5.96259 12.0662 6.27606 12.1974 6.58949 12.1974H17.7102C18.3729 12.1974 18.9095 11.6608 18.9095 10.9981V2.28773C18.9095 1.62507 18.3729 1.08844 17.7102 1.08844L6.58949 1.08857Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M10.4529 9.20972C10.3133 9.20972 10.1736 9.15691 10.0696 9.04788C9.8567 8.83494 9.8567 8.48914 10.0696 8.27619L14.1207 4.22516C14.3336 4.01221 14.6794 4.01221 14.8924 4.22516C15.1053 4.4381 15.1053 4.78389 14.8924 4.99684L10.8413 9.04788C10.7323 9.15691 10.5926 9.20972 10.4529 9.20972Z"
                          fill="currentColor"
                        ></path>
                        <path
                          d="M14.5039 9.20972C14.3642 9.20972 14.2246 9.15691 14.1206 9.04788L10.0696 4.99684C9.85666 4.7839 9.85666 4.43811 10.0696 4.22516C10.2825 4.01221 10.6283 4.01221 10.8413 4.22516L14.8923 8.27619C15.1053 8.48913 15.1053 8.83493 14.8923 9.04788C14.7833 9.15691 14.6436 9.20972 14.5039 9.20972Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="percentage_payout">
            <h5 className="title">
              {t("Payout")}:{" "}
              <span className="price-up text-white">
                $
                {peramount
                  ? formatPrice(
                      parseFloat(parseInt(amount) + peramount).toFixed(2),
                      2,
                    )
                  : parseFloat(
                      parseInt(amount) +
                        (amount * parseInt(chnagetype?.payout)) / 100,
                    ).toFixed(2)}
              </span>
            </h5>
            <div className="price-up">
              +{chnagetype?.payout ? chnagetype?.payout : 92}%
            </div>
            <h5 className="title profittitle">
              {t("Profit")}:{" "}
              <span className="price-up text-white">
                +$
                {peramount
                  ? formatPrice(parseFloat(peramount).toFixed(2), 2)
                  : (amount * parseInt(chnagetype?.payout)) / 100}
              </span>
            </h5>
          </div>
          <div className="sidebar_btn">
            <div
              className={`btn bg_btn butBtn ${
                classNameicMode ? "afterbuyeffect" : ""
              }`}
              id="buyButton"
              onClick={() => {
                buyselltrades(amount, time, peramount, "buy", closetradetime);
              }}
              onMouseEnter={() => onHoverType?.("buy")}
              onMouseLeave={() => onHoverType?.(null)}
            >
              <img src={buyicon} alt="Buy" /> {t("Buy")}
            </div>
            <div
              className={`btn bg_btn sellBtn ${
                classNameicMode ? "afterselleffect" : ""
              }`}
              onMouseEnter={() => onHoverType?.("sell")}
              onMouseLeave={() => onHoverType?.(null)}
              onClick={() => {
                buyselltrades(amount, time, peramount, "sell", closetradetime);
              }}
            >
              <img src={sellicon} alt="Sell" /> {t("Sell")}
            </div>
          </div>
        </div>

        <div className="rightnavmenu_collapse">
          <div className="rightnavmenu">
            <ul className="navmenu">
              <li className="menu-link">
                <button
                  // data-bs-toggle="collapse"
                  // data-bs-target="#tradesSidebarCollapse"
                  aria-expanded={sidebaractive?.tradesSidebarCollapse}
                  aria-controls="tradesSidebarCollapse"
                  onClick={() => {
                    // handleToggleCollapse(
                    //   "tradesSidebarCollapse",
                    //   setCollapseshow,
                    //   true,
                    //   null,
                    //   false,
                    //   true
                    // );
                    setCollapseOpen(false);
                    toggleCollapseById("tradesSidebarCollapse");
                    // handleToggleCollapse1();
                  }}
                >
                  <span className="iconShap">
                    <img src={dashrighticon01} alt="" />
                  </span>
                  {opentrade?.length ? (
                    <span className="tradecount">{opentrade?.length}</span>
                  ) : (
                    ""
                  )}
                  <div>{t("Trades")}</div>
                </button>
              </li>
              <li className="menu-link">
                <button
                  // data-bs-toggle="collapse"
                  //  data-bs-target="#socialTradingCollapse"
                  aria-expanded={sidebaractive?.socialTradingCollapse}
                  aria-controls="socialTradingCollapse"
                  onClick={() => {
                    toggleCollapseById("socialTradingCollapse");
                    setCollapseOpen(false);
                    getsocialtrade("Top recommended traders");
                    setSocialfilter({
                      key: "recommended",
                      icon: "fa-solid fa-award",
                      label: "Top recommended traders",
                    });
                    //   handleToggleCollapse(
                    //     "socialTradingCollapse",
                    //     setCollapseshow,
                    //     true,
                    //     null,
                    //     false,
                    //     true
                    //   );
                  }}
                >
                  <span className="iconShap">
                    <i className="fa-solid fa-users"></i>
                  </span>{" "}
                  {copycount > 0 ? (
                    <span className="tradecount">{copycount}</span>
                  ) : (
                    ""
                  )}
                  <div>{t("Social Trading")}</div>
                </button>
              </li>
              {/* <!-- <li className="menu-link"><a href="javascript:;"><i className="fa-solid fa-users"></i> Social Trading</a></li> --> */}
              {/* <!-- <li className="menu-link"><a href="javascript:;"><img src="images/dash-right-icon04.svg"> Express Trades</a></li> --> */}
              <li className="menu-link">
                <button
                  // data-bs-toggle="collapse"
                  // data-bs-target="#pendingTradesCollapse"
                  aria-expanded={sidebaractive?.pendingTradesCollapse}
                  aria-controls="pendingTradesCollapse"
                  onClick={() => {
                    toggleCollapseById("pendingTradesCollapse");
                    setCollapseOpen(false);
                    //   handleToggleCollapse(
                    //     "pendingTradesCollapse",
                    //     setCollapseshow,
                    //     true,
                    //     null,
                    //     false,
                    //     true
                    //   );
                  }}
                >
                  <span className="iconShap">
                    <img src={dashrighticon06} alt="" />
                  </span>{" "}
                  <div>{t("Pending trades")}</div>
                </button>
              </li>
              <li className="menu-link">
                <button
                  onClick={() => {
                    openModal("hotkeysModal");
                    setCollapseOpen(false);
                  }}

                  // data-bs-toggle="modal"
                  //  data-bs-target="#hotkeysModal"
                >
                  <span className="iconShap">
                    <img src={dashrighticon07} alt="" />
                  </span>{" "}
                  <div>{t("Hotkeys")}</div>
                </button>
              </li>

              <li className="menu-link">
                <button
                  ref={toggleButtonRef}
                  data-bs-toggle="collapse"
                  // href="#leaderBoardCollapse"
                  aria-expanded={sidebaractive?.leaderBoardCollapse}
                  aria-controls="leaderBoardCollapse"
                  onClick={() => {
                    toggleCollapseById("leaderBoardCollapse");
                    // handleToggleCollapse("leaderBoardCollapse", "", false);
                    getleaderdata();
                    getleaderboard();
                    handleToggleCollapse5();
                  }}
                >
                  <span className="iconShap">
                    <img src={dashrighticon08} alt="" />
                  </span>{" "}
                  <div>{t("Leader Board")}</div>
                </button>
              </li>
              {/* <!-- <li className="menu-link"><button data-bs-toggle="modal" data-bs-target="#leaderBoardModal"><img src="images/dash-right-icon08.svg"> Leader Board</button></li> -->             */}
            </ul>
            <ul className="navmenu telegram-link0">
              <li className="menu-link">
                <a
                  href="https://t.me/EqulixOfficial"
                  target="_blank"
                  rel="noreferrer"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  data-bs-original-title="Telegram"
                >
                  <span className="iconShap">
                    <img src={telegram2line} alt="" />
                  </span>{" "}
                  {t("Official")}
                </a>
              </li>
            </ul>
          </div>

          {/* <!-- --------- Right Sidebar Modal Start----------- --> */}
          <div className="rightSidebarModal">
            {/* <!-- --------- Trades Start----------- --> */}
            {sidebaractive?.tradesSidebarCollapse && (
              <div className="collapsePop" id="tradesSidebarCollapse">
                <div className="pendingTrades_topbar">
                  <h5 className="rightsidebar_title">
                    {t("Trades")}{" "}
                    <Link
                      to={`${base_url}accounthistory`}
                      state={{ from: "trading_history" }}
                      className="icon_link"
                      onClick={() => handleClearData()}
                    >
                      <i className="fa-solid fa-list-ul"></i>
                    </Link>
                  </h5>
                </div>
                <div className="pendingTrades_body">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li
                      className="nav-item"
                      role="presentation"
                      onClick={() => {
                        setIndexOpenCollapseKey(null);
                        setOpenIndex(null);
                      }}
                    >
                      <button
                        className="nav-link active"
                        id="opened-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#opened"
                        type="button"
                        role="tab"
                        aria-controls="opened"
                        aria-selected="true"
                      >
                        {t("Opened")}
                      </button>
                    </li>
                    <li
                      className="nav-item"
                      role="presentation"
                      onClick={() => {
                        setIndexOpenCollapseKey(null);
                        setOpenIndex(null);
                      }}
                    >
                      <button
                        className="nav-link"
                        id="closed-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#closed"
                        type="button"
                        role="tab"
                        aria-controls="closed"
                        aria-selected="false"
                      >
                        {t("Closed")}
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="opened"
                      role="tabpanel"
                      aria-labelledby="opened-tab"
                    >
                      <div
                        className="trades-list_group accordion"
                        id="accordionExample"
                      >
                        <div className="column_reverse">
                          {opentrade?.length ? (
                            [...opentrade]
                              .sort((a, b) => a.id - b.id)
                              .map((result, key) => {
                                // const latestData = seriesRef.current.data();
                                const lastCandle = {
                                  close: prices?.[result?.ticker],
                                };
                                // const lastCandle =
                                //   tradestyle === "3"
                                //     ? {
                                //         close: valueSeriesref.current.data.getIndex(
                                //           valueSeriesref.current.data.length - 1,
                                //         )?.value,
                                //       }
                                //     : valueSeriesref.current
                                //       ? valueSeriesref.current.data.getIndex(
                                //           valueSeriesref.current.data.length - 1,
                                //         )
                                //       : "";
                                let toFixeddesimal = 2;
                                let formattedDiff = "0.00";
                                if (result?.entry_price && lastCandle?.close) {
                                  let diff =
                                    Number(result?.entry_price) -
                                    Number(lastCandle?.close);

                                  let absDiff = Math.abs(diff);

                                  if (absDiff === 0) {
                                    formattedDiff = "0.00";
                                  } else {
                                    // Difference > 1 => existing logic
                                    if (absDiff > 1) {
                                      const diffStr = absDiff.toFixed(10);
                                      const decimalPart = diffStr.split(".")[1];

                                      let index = 0;
                                      while (
                                        index < decimalPart.length &&
                                        decimalPart[index] === "0"
                                      ) {
                                        index++;
                                      }

                                      toFixeddesimal = Math.max(2, index + 1);
                                    } else {
                                      // Difference <= 1 => fixed 6 decimals
                                      toFixeddesimal = 6;
                                    }

                                    const truncated = truncateNumber(
                                      absDiff,
                                      toFixeddesimal,
                                    );

                                    formattedDiff =
                                      truncated.toFixed(toFixeddesimal);
                                  }
                                }
                                // if (result?.entry_price && lastCandle?.close) {
                                //   let diff =
                                //     Number(result?.entry_price) -
                                //     Number(lastCandle?.close);
                                //   let absDiff = Math.abs(diff);

                                //   if (absDiff === 0) {
                                //     formattedDiff = "0.00";
                                //   } else {
                                //     const diffStr = absDiff.toFixed(10);
                                //     const decimalPart = diffStr.split(".")[1];
                                //     let index = 0;
                                //     while (
                                //       index < decimalPart.length &&
                                //       decimalPart[index] === "0"
                                //     ) {
                                //       index++;
                                //     }
                                //     toFixeddesimal = Math.max(2, index + 1);
                                //     const truncated = truncateNumber(
                                //       absDiff,
                                //       toFixeddesimal,
                                //     );
                                //     formattedDiff =
                                //       truncated.toFixed(toFixeddesimal);
                                //   }
                                // }

                                const { startTime, closeTime, duration } =
                                  getStartAndCloseTime(
                                    result?.trade_timestamp,
                                    result?.duration,
                                  );
                                const isOpen =
                                  openindexCollapseKey === result?.id;
                                const isAnyMatch = opentrade.some(
                                  (item, i) =>
                                    item?.id === openindexCollapseKey,
                                );
                                return (
                                  <div
                                    className={`trades-list_item opentradelist0 ${
                                      !isOpen &&
                                      openindexCollapseKey !== null &&
                                      isAnyMatch
                                        ? "opacity-down"
                                        : ""
                                    }`}
                                  >
                                    <div
                                      ref={collapseRef}
                                      className="trades-list_item-short"
                                      // data-bs-toggle="collapse"
                                      // // data-bs-target="#opendetradesList_group1"
                                      // aria-expanded="true"
                                      // aria-controls={`opendetradesList_group${key}`}
                                      onClick={() => {
                                        setIndexOpenCollapseKey(
                                          isOpen ? null : result?.id,
                                        );
                                        // still run your polygonapi if needed
                                        // polygonapi(result);
                                      }}
                                    >
                                      <div className="item-row">
                                        <div>
                                          <span className="favorites">
                                            <Link
                                              to=""
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              <i className="fa-regular fa-star"></i>
                                            </Link>
                                          </span>
                                          <Link
                                            to=""
                                            style={{ color: "#ccc" }}
                                            onClick={(e) => {
                                              openassetcart(result?.asset_name);
                                              e.preventDefault();
                                              e.stopPropagation();
                                            }}
                                          >
                                            {result?.asset_name}
                                          </Link>{" "}
                                          <span
                                            className={
                                              result?.type === "buy"
                                                ? "price-up"
                                                : "price-up"
                                            }
                                          >
                                            +
                                            {result?.payout
                                              ? result?.payout
                                              : 92}
                                            %
                                          </span>
                                          {result?.copy_id ? (
                                            <i class="fa-regular fa-copy ms-2"></i>
                                          ) : (
                                            ""
                                          )}
                                        </div>

                                        <div></div>
                                        <div>{result?.newTimeLeftCompact}</div>
                                      </div>
                                      <div className="item-row">
                                        <div className="leftuparrow">
                                          {result?.type === "buy" ? (
                                            <i
                                              className="fa-solid fa-arrow-right price-up"
                                              style={{
                                                transform: "rotate(-45deg)",
                                              }}
                                            ></i>
                                          ) : (
                                            <i
                                              className="fa-solid fa-arrow-right price-down"
                                              style={{
                                                transform: "rotate(45deg)",
                                              }}
                                            ></i>
                                          )}
                                          $
                                          {result?.amount
                                            ? formatPrice(result?.amount, 2)
                                            : ""}
                                        </div>
                                        {result?.type === "buy" ? (
                                          parseFloat(lastCandle?.close) >
                                          parseFloat(result?.entry_price) ? (
                                            <div className="centered price-up">
                                              $
                                              {formatPrice(
                                                parseFloat(
                                                  parseFloat(result?.amount) +
                                                    parseFloat(
                                                      result?.profit_loss,
                                                    ),
                                                ).toFixed(2),
                                                2,
                                              )}
                                            </div>
                                          ) : (
                                            <div className="centered">$0</div>
                                          )
                                        ) : parseFloat(lastCandle?.close) <
                                          parseFloat(result?.entry_price) ? (
                                          <div className="centered price-up">
                                            $
                                            {formatPrice(
                                              parseFloat(
                                                parseFloat(result?.amount) +
                                                  parseFloat(
                                                    result?.profit_loss,
                                                  ),
                                              ).toFixed(2),
                                              2,
                                            )}
                                          </div>
                                        ) : (
                                          <div className="centered">$0</div>
                                        )}

                                        {result?.type === "buy" ? (
                                          parseFloat(lastCandle?.close) >
                                          parseFloat(result?.entry_price) ? (
                                            <div className="centered price-up">
                                              $
                                              {formatPrice(
                                                result?.profit_loss,
                                                2,
                                              )}
                                            </div>
                                          ) : (
                                            <div className="centered">$0</div>
                                          )
                                        ) : parseFloat(lastCandle?.close) <
                                          parseFloat(result?.entry_price) ? (
                                          <div className="centered price-up">
                                            $
                                            {formatPrice(
                                              result?.profit_loss,
                                              2,
                                            )}
                                          </div>
                                        ) : (
                                          <div className="centered">$0</div>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      id={`opendetradesList_group${key}`}
                                      className={isOpen ? "d-block" : "d-none"}
                                      aria-labelledby="headingOne"
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div className="accordion-body trade-result-body">
                                        <div className="trades-list_item">
                                          <div className="trades-list_item-short">
                                            <div className="item-row">
                                              <div>
                                                {t("Open time")}:
                                                <br />
                                                {
                                                  convertLocalToUTCFormatted(
                                                    result?.trade_timestamp,
                                                    updatetimezone,
                                                  )?.all
                                                }
                                                .
                                                {result?.opentime
                                                  ? result?.opentime
                                                  : "000"}
                                              </div>
                                              <div className="centered">
                                                {duration}
                                              </div>
                                              <div className="text-end">
                                                {t("Closing time")}
                                                <br />
                                                {
                                                  convertLocalToUTCFormatted(
                                                    result?.close_time,
                                                    updatetimezone,
                                                  )?.all
                                                }
                                                .
                                                {result?.closetime
                                                  ? result?.closetime
                                                  : "000"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div>
                                          <div className="timeprogress">
                                            <div className="progress">
                                              <div
                                                className="progress-bar progress-bar-striped progress-bar-animated"
                                                role="progressbar"
                                                style={{
                                                  width: `${result?.progress}%`,
                                                }}
                                                aria-valuenow={result?.progress}
                                                // style={{ width: "10%" }}
                                                // aria-valuenow={50}
                                                aria-valuemin={0}
                                                aria-valuemax={100}
                                              ></div>
                                            </div>
                                            <p>
                                              {t("Time left")}:{" "}
                                              {result?.timeleft}
                                            </p>
                                          </div>
                                          <div className="trades-listbox">
                                            <div className="payout-profit">
                                              <div>
                                                {t("Forecast")}{" "}
                                                {result?.type === "buy" ? (
                                                  <span className="price-up">
                                                    {t("Buy")}
                                                  </span>
                                                ) : (
                                                  <span className="price-down">
                                                    {t("Sell")}
                                                  </span>
                                                )}
                                              </div>
                                              <div>
                                                {t("Payout")}:{" "}
                                                {result?.type === "buy" ? (
                                                  parseFloat(
                                                    lastCandle?.close,
                                                  ) >
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                    <span className="price-up">
                                                      $
                                                      {formatPrice(
                                                        parseFloat(
                                                          result?.amount,
                                                        ) +
                                                          parseFloat(
                                                            result?.profit_loss,
                                                          ),
                                                        2,
                                                      )}
                                                    </span>
                                                  ) : (
                                                    <span>$0</span>
                                                  )
                                                ) : parseFloat(
                                                    lastCandle?.close,
                                                  ) <
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                  <span className="price-up">
                                                    $
                                                    {formatPrice(
                                                      parseFloat(
                                                        result?.amount,
                                                      ) +
                                                        parseFloat(
                                                          result?.profit_loss,
                                                        ),
                                                      2,
                                                    )}
                                                  </span>
                                                ) : (
                                                  <span>$0</span>
                                                )}
                                              </div>
                                              <div className="profit-tooltip">
                                                {t("Profit")}:{" "}
                                                {result?.type === "buy" ? (
                                                  parseFloat(
                                                    lastCandle?.close,
                                                  ) >
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                    <span className="price-up">
                                                      $
                                                      {formatPrice(
                                                        result?.profit_loss,
                                                        2,
                                                      )}
                                                    </span>
                                                  ) : (
                                                    <span>$0</span>
                                                  )
                                                ) : parseFloat(
                                                    lastCandle?.close,
                                                  ) <
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                  <span className="price-up">
                                                    $
                                                    {formatPrice(
                                                      result?.profit_loss,
                                                      2,
                                                    )}
                                                  </span>
                                                ) : (
                                                  <span>$0</span>
                                                )}
                                                {/* <span
                                              className="tooltip01"
                                              data-bs-toggle="tooltip"
                                              data-bs-placement="top"
                                              data-bs-original-title="Lorem ipsum dolor sit amet, consectetur adipisicing elit,"
                                            >
                                              ?
                                            </span> */}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="trades-list_item">
                                          <div className="trades-list_item-short">
                                            <p
                                              style={{
                                                fontSize: "12px",
                                                margin: "0",
                                              }}
                                            >
                                              {t("Order")}:
                                              {result?.reference_id}
                                            </p>
                                            <div className="item-row">
                                              <div>
                                                {t("Open price")}:
                                                <br />
                                                {/* {parseFloat(
                                              result?.entry_price
                                            ).toFixed(2)} */}
                                                {/* {result?.entry_price
                                                  ? parseFloat(
                                                      result?.entry_price,
                                                    ).toFixed(toFixeddesimal)
                                                  : ""} */}
                                                {formatWithSameDecimal(
                                                  Number(result?.entry_price),
                                                  toFixeddesimal,
                                                )}
                                              </div>
                                              <div className="centered">
                                                {t("Current price")}:
                                                <br />
                                                {/* {parseFloat(
                                              lastCandle?.close
                                            ).toFixed(2)} */}
                                                {/* {lastCandle?.close
                                                  ? parseFloat(
                                                      lastCandle?.close,
                                                    ).toFixed(toFixeddesimal)
                                                  : ""} */}
                                                {formatWithSameDecimal(
                                                  Number(lastCandle?.close),
                                                  toFixeddesimal,
                                                )}
                                              </div>
                                              <div className="text-end">
                                                {t("Difference")}
                                                <br />(
                                                {/* {result?.entry_price >
                                                lastCandle?.close ? (
                                                  <span className="price-down">
                                                    {
                                                      calculateSmartPoints(
                                                        result?.entry_price,
                                                        lastCandle?.close,
                                                      )?.points
                                                    }
                                                  </span>
                                                ) : result?.entry_price <
                                                  lastCandle?.close ? (
                                                  <span className="price-up">
                                                    +
                                                    {
                                                      calculateSmartPoints(
                                                        result?.entry_price,
                                                        lastCandle?.close,
                                                      )?.points
                                                    }
                                                  </span>
                                                ) : (
                                                  <span>
                                                    {
                                                      calculateSmartPoints(
                                                        result?.entry_price,
                                                        lastCandle?.close,
                                                      )?.points
                                                    }
                                                  </span>
                                                )} */}
                                                {result?.type === "buy" ? (
                                                  parseFloat(
                                                    lastCandle?.close,
                                                  ) ===
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                    0
                                                  ) : parseFloat(
                                                      lastCandle?.close,
                                                    ) >
                                                    parseFloat(
                                                      result?.entry_price,
                                                    ) ? (
                                                    <span
                                                      className="price-up"
                                                      //  className="tooltip-wrapper"
                                                    >
                                                      +
                                                      {
                                                        calculateSmartPoints(
                                                          result?.entry_price,
                                                          lastCandle?.close,
                                                        )?.points
                                                      }
                                                    </span>
                                                  ) : (
                                                    <span className="price-down">
                                                      {
                                                        calculateSmartPoints(
                                                          result?.entry_price,
                                                          lastCandle?.close,
                                                        )?.points
                                                      }
                                                    </span>
                                                  )
                                                ) : parseFloat(
                                                    lastCandle?.close,
                                                  ) ===
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                  0
                                                ) : parseFloat(
                                                    lastCandle?.close,
                                                  ) <
                                                  parseFloat(
                                                    result?.entry_price,
                                                  ) ? (
                                                  <span className="price-down">
                                                    {
                                                      calculateSmartPoints(
                                                        result?.entry_price,
                                                        lastCandle?.close,
                                                      )?.points
                                                    }
                                                  </span>
                                                ) : (
                                                  <span className="price-up">
                                                    +
                                                    {
                                                      calculateSmartPoints(
                                                        result?.entry_price,
                                                        lastCandle?.close,
                                                      )?.points
                                                    }
                                                  </span>
                                                )}{" "}
                                                {t("Points")})
                                              </div>
                                            </div>
                                            <div className="item-row">
                                              {result?.copy_id ? (
                                                <div className="w-100 text-center">
                                                  <i class="fa-regular fa-copy"></i>{" "}
                                                  Trade copied
                                                  <br />
                                                  Trader ID:{" "}
                                                  <span
                                                    onClick={(e) => {
                                                      openModal(
                                                        "socialTradingview_popup",
                                                      );
                                                      setShowCopyhistory(false);
                                                      userdetailsfromid(
                                                        result?.copy_user_id,
                                                        result?.rank,
                                                        "today",
                                                        false,
                                                      );
                                                      setModelloading(true);
                                                      e.stopPropagation();
                                                    }}
                                                    onMouseEnter={() => {
                                                      userdetailsfromid(
                                                        result?.copy_user_id,
                                                        result?.rank,
                                                        "today",
                                                        false,
                                                      );
                                                    }}
                                                    className="opcty05"
                                                  >
                                                    {result?.copy_user_id} (
                                                    {formatName(
                                                      result?.copy_user_name,
                                                    )}
                                                    )
                                                  </span>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <p className="text-center">
                              {t("No opened trades")}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="closed"
                      role="tabpanel"
                      aria-labelledby="closed-tab"
                    >
                      <>
                        <div
                          className="trades-list_group accordion"
                          id="closedaccordionExample"
                        >
                          {!loadingclosetrade ? (
                            Object.keys(closedata).length !== 0 ? (
                              <>
                                {Object.entries(closedata).map(
                                  ([date, trades]) => (
                                    <>
                                      <h5 className="rightsidebar_subtitle p-3 pb-0 text-center">
                                        <span>{date}</span>
                                      </h5>
                                      {trades?.length ? (
                                        trades.map((result, key) => {
                                          const textValue = `$ ${Number(result.amount)}`;
                                          const rectWidth =
                                            textValue.length * 7;
                                          const safeX = Math.max(
                                            rectWidth / 2,
                                            Math.min(
                                              graphdata?.labelX,
                                              width - rectWidth / 2,
                                            ),
                                          );
                                          let toFixeddesimal = 2;
                                          let formattedDiff = "0.00";
                                          if (
                                            result?.entry_price &&
                                            result?.exit_price
                                          ) {
                                            let diff =
                                              Number(result?.entry_price) -
                                              Number(result?.exit_price);

                                            let absDiff = Math.abs(diff);

                                            if (absDiff === 0) {
                                              formattedDiff = "0.00";
                                            } else {
                                              // Difference > 1 => existing logic
                                              if (absDiff > 1) {
                                                const diffStr =
                                                  absDiff.toFixed(10);
                                                const decimalPart =
                                                  diffStr.split(".")[1];

                                                let index = 0;
                                                while (
                                                  index < decimalPart.length &&
                                                  decimalPart[index] === "0"
                                                ) {
                                                  index++;
                                                }

                                                toFixeddesimal = Math.max(
                                                  2,
                                                  index + 1,
                                                );
                                              } else {
                                                // Difference <= 1 => fixed 6 decimals
                                                toFixeddesimal = 6;
                                              }

                                              const truncated = truncateNumber(
                                                absDiff,
                                                toFixeddesimal,
                                              );

                                              formattedDiff =
                                                truncated.toFixed(
                                                  toFixeddesimal,
                                                );
                                            }
                                          }
                                          // if (
                                          //   result?.entry_price &&
                                          //   result?.exit_price
                                          // ) {
                                          //   let diff =
                                          //     Number(result?.entry_price) -
                                          //     Number(result?.exit_price);
                                          //   let absDiff = Math.abs(diff);

                                          //   if (absDiff === 0) {
                                          //     formattedDiff = "0.00";
                                          //   } else {
                                          //     const diffStr =
                                          //       absDiff.toFixed(10);
                                          //     const decimalPart =
                                          //       diffStr.split(".")[1];
                                          //     let index = 0;
                                          //     while (
                                          //       index < decimalPart.length &&
                                          //       decimalPart[index] === "0"
                                          //     ) {
                                          //       index++;
                                          //     }
                                          //     toFixeddesimal = Math.max(
                                          //       2,
                                          //       index + 1,
                                          //     );
                                          //     const truncated = truncateNumber(
                                          //       absDiff,
                                          //       toFixeddesimal,
                                          //     );
                                          //     formattedDiff =
                                          //       truncated.toFixed(
                                          //         toFixeddesimal,
                                          //       );
                                          //   }
                                          // }

                                          const split = splitString(
                                            result?.asset,
                                          );
                                          const {
                                            startTime,
                                            closeTime,
                                            duration,
                                          } = getStartAndCloseTime(
                                            result?.trade_timestamp,
                                            result?.duration,
                                          );
                                          const isOpen =
                                            openIndex ===
                                            `${date}${result?.id}`;
                                          return (
                                            <div
                                              ref={collapseRef}
                                              className={`trades-list_item ${
                                                !isOpen && openIndex !== null
                                                  ? "opacity-down"
                                                  : ""
                                              }`}
                                              data-bs-toggle="collapse"
                                              aria-expanded="true"
                                              aria-controls={`closedtradesList_group${date}${result?.id}`}
                                              onClick={() => {
                                                if (isOpen) {
                                                  setOpenIndex(null);
                                                } else {
                                                  setOpenIndex(
                                                    `${date}${result?.id}`,
                                                  );
                                                }
                                                polygonapi(result);
                                              }}
                                            >
                                              <div className="trades-list_item-short">
                                                <div className="item-row">
                                                  <div className="d-flex align-items-center">
                                                    <div className="trades_rgltcrncy">
                                                      <span className="favorites">
                                                        <Link
                                                          to=""
                                                          onClick={(e) =>
                                                            e.preventDefault()
                                                          }
                                                        >
                                                          <i className="fa-regular fa-star"></i>
                                                        </Link>
                                                      </span>
                                                      <Link
                                                        className={` ${
                                                          isClicked?.asset_name ===
                                                          `${result?.asset_name}+${key}`
                                                            ? "click"
                                                            : ""
                                                        }`}
                                                        to=""
                                                        onClick={(e) => {
                                                          openassetcart(
                                                            result?.asset_name,
                                                          );
                                                          e.preventDefault();
                                                          e.stopPropagation();

                                                          setIsClicked(
                                                            (state) => ({
                                                              ...state,
                                                              asset_name: `${result?.asset_name}+${key}`,
                                                            }),
                                                          );
                                                          setTimeout(
                                                            () =>
                                                              setIsClicked(
                                                                (state) => ({
                                                                  ...state,
                                                                  asset_name: false,
                                                                }),
                                                              ),
                                                            400,
                                                          );
                                                        }}
                                                        style={{
                                                          color: "#ccc",
                                                        }}
                                                      >
                                                        {result?.asset_name
                                                          ? result?.asset_name
                                                          : result?.asset}
                                                      </Link>{" "}
                                                      <span className="price-up">
                                                        +
                                                        {result?.payout
                                                          ? result?.payout
                                                          : 92}
                                                        %
                                                      </span>
                                                    </div>
                                                    {result?.copy_id ? (
                                                      <i class="fa-regular fa-copy ms-2"></i>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                  {/* <div></div> */}
                                                  <div className="text-end">
                                                    {
                                                      convertLocalToUTCFormatted(
                                                        result?.close_time,
                                                        updatetimezone,
                                                      )?.timemin
                                                    }
                                                  </div>
                                                </div>
                                                <div className="item-row">
                                                  <div className="leftuparrow">
                                                    {result?.type === "buy" ? (
                                                      <img src={up} alt="" />
                                                    ) : (
                                                      <img src={Down} alt="" />
                                                    )}
                                                    $
                                                    {result?.amount
                                                      ? formatPrice(
                                                          result?.amount,
                                                          2,
                                                        )
                                                      : 0}
                                                  </div>
                                                  {result?.profit_loss > 0 ? (
                                                    <div className="centered price-up">
                                                      $
                                                      {formatPrice(
                                                        (
                                                          parseFloat(
                                                            result?.profit_loss,
                                                          ) +
                                                          parseFloat(
                                                            result?.amount,
                                                          )
                                                        ).toFixed(2),
                                                        2,
                                                      )}
                                                    </div>
                                                  ) : result?.profit_loss <
                                                    0 ? (
                                                    <div className="centered">
                                                      $0
                                                    </div>
                                                  ) : (
                                                    <div className="centered price-up">
                                                      $
                                                      {formatPrice(
                                                        result?.amount,
                                                        2,
                                                      )}
                                                    </div>
                                                  )}

                                                  {result?.profit_loss > 0 ? (
                                                    <div className="price-up">
                                                      +$
                                                      {formatPrice(
                                                        result?.profit_loss,
                                                        2,
                                                      )}
                                                    </div>
                                                  ) : result?.profit_loss <
                                                    0 ? (
                                                    <div className="">$0</div>
                                                  ) : (
                                                    <div className="">$0</div>
                                                  )}
                                                </div>
                                              </div>
                                              <div
                                                id={`closedtradesList_group${date}${result?.id}`}
                                                className={
                                                  isOpen ? "d-block" : "d-none"
                                                }
                                                aria-labelledby="headingOne"
                                                data-bs-parent="#closedaccordionExample"
                                              >
                                                <div className="accordion-body trade-result-body">
                                                  <div className="trades-list_item">
                                                    <div className="trades-list_item-short">
                                                      <div className="item-row">
                                                        <div>
                                                          <span className="opcty05">
                                                            {t("Open time")}:
                                                          </span>
                                                          <br />
                                                          {
                                                            convertLocalToUTCFormatted(
                                                              result?.trade_timestamp,
                                                              updatetimezone,
                                                            )?.all
                                                          }
                                                          .
                                                          {result?.opentime
                                                            ? result?.opentime
                                                            : "000"}
                                                        </div>
                                                        <div className="centered">
                                                          {duration}
                                                        </div>
                                                        <div className="text-end">
                                                          <span className="opcty05">
                                                            {t("Closing time")}
                                                          </span>
                                                          <br />
                                                          {
                                                            convertLocalToUTCFormatted(
                                                              result?.close_time,
                                                              updatetimezone,
                                                            )?.all
                                                          }
                                                          .
                                                          {result?.closetime
                                                            ? result?.closetime
                                                            : "000"}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="trades-listbox">
                                                    <div className="payout-profit">
                                                      <div>
                                                        <img
                                                          src={Forecast}
                                                          alt=""
                                                        />
                                                        {t("Forecast")}{" "}
                                                        {result?.type ===
                                                        "buy" ? (
                                                          <span className="price-up">
                                                            {t("Buy")}
                                                          </span>
                                                        ) : (
                                                          <span className="price-down">
                                                            {t("Sell")}
                                                          </span>
                                                        )}
                                                      </div>
                                                      <div>
                                                        <img
                                                          src={Payout}
                                                          alt=""
                                                        />
                                                        {t("Payout")}:{" "}
                                                        {result?.profit_loss >
                                                        0 ? (
                                                          <span className="price-up">
                                                            $
                                                            {formatPrice(
                                                              (
                                                                parseFloat(
                                                                  result?.profit_loss,
                                                                ) +
                                                                parseFloat(
                                                                  result?.amount,
                                                                )
                                                              ).toFixed(2),
                                                              2,
                                                            )}
                                                          </span>
                                                        ) : result?.profit_loss <
                                                          0 ? (
                                                          <span
                                                            style={{
                                                              color: "#ccc",
                                                            }}
                                                          >
                                                            $0
                                                          </span>
                                                        ) : (
                                                          <span
                                                            style={{
                                                              color: "#f88737",
                                                            }}
                                                          >
                                                            $
                                                            {formatPrice(
                                                              result?.amount,
                                                              2,
                                                            )}
                                                          </span>
                                                        )}
                                                      </div>
                                                      <div className="profit-tooltip">
                                                        <img
                                                          src={Profit}
                                                          alt=""
                                                        />{" "}
                                                        {result?.profit_loss > 0
                                                          ? "Profit:"
                                                          : result?.profit_loss <
                                                              0
                                                            ? `${t("Profit")}:`
                                                            : `${t("Refund")}:`}
                                                        {result?.profit_loss >
                                                        0 ? (
                                                          <span className="price-up">
                                                            +$
                                                            {formatPrice(
                                                              result?.profit_loss,
                                                              2,
                                                            )}
                                                          </span>
                                                        ) : result?.profit_loss <
                                                          0 ? (
                                                          <span
                                                            style={{
                                                              color: "#ccc",
                                                            }}
                                                          >
                                                            $0
                                                          </span>
                                                        ) : (
                                                          <span
                                                            style={{
                                                              color: "#f88737",
                                                            }}
                                                          >
                                                            $
                                                            {formatPrice(
                                                              result?.amount,
                                                              2,
                                                            )}
                                                          </span>
                                                        )}
                                                      </div>
                                                    </div>

                                                    <div className="trade-result-img">
                                                      <svg
                                                        width={width}
                                                        height={height}
                                                        viewBox={`0 0 ${width} ${height}`}
                                                      >
                                                        <defs>
                                                          <linearGradient
                                                            id={`fade-${key}${date}`}
                                                            x1="0"
                                                            y1="0"
                                                            x2="0"
                                                            y2="1"
                                                          >
                                                            <stop
                                                              offset="0%"
                                                              stopColor="#999"
                                                              stopOpacity="0.8"
                                                            />
                                                            <stop
                                                              offset="100%"
                                                              stopColor="#fff"
                                                              stopOpacity="0"
                                                            />
                                                          </linearGradient>
                                                        </defs>
                                                        <path
                                                          key={key}
                                                          d={graphdata?.d}
                                                          fill={`url(#fade-${key}${date})`}
                                                          stroke="#333"
                                                          strokeWidth="1"
                                                        />
                                                        <rect
                                                          x={
                                                            safeX -
                                                            rectWidth / 2
                                                          }
                                                          y={
                                                            graphdata?.labelY -
                                                            25
                                                          }
                                                          width={rectWidth}
                                                          height="20"
                                                          rx="7"
                                                          fill={
                                                            result?.type ===
                                                            "buy"
                                                              ? "rgba(15, 175, 89, 0.3)"
                                                              : "rgba(243, 56, 44, 0.3)"
                                                          }
                                                        />

                                                        <text
                                                          x={safeX}
                                                          y={
                                                            graphdata?.labelY -
                                                            15
                                                          }
                                                          fill="#fff"
                                                          fontSize="10"
                                                          textAnchor="middle"
                                                          dominantBaseline="middle"
                                                        >
                                                          {textValue}
                                                        </text>
                                                        <line
                                                          x1={graphdata?.labelX}
                                                          y1={graphdata?.labelY}
                                                          x2={
                                                            graphdata?.arrowEndX
                                                          }
                                                          y2={graphdata?.labelY}
                                                          stroke={
                                                            result?.type ===
                                                            "buy"
                                                              ? "#0FAF59"
                                                              : "#f3382c"
                                                          }
                                                          strokeWidth="2"
                                                        />
                                                        <circle
                                                          cx={graphdata?.labelX}
                                                          cy={graphdata?.labelY}
                                                          r="3"
                                                          fill={
                                                            result?.type ===
                                                            "buy"
                                                              ? "#0FAF59"
                                                              : "#f3382c"
                                                          }
                                                        />
                                                        <line
                                                          x1={
                                                            graphdata?.arrowEndX
                                                          }
                                                          y1={graphdata?.labelY}
                                                          x2={
                                                            graphdata?.arrowEndX
                                                          }
                                                          y2={
                                                            graphdata?.arrowEndY
                                                          }
                                                          stroke="#ddcaca"
                                                          strokeWidth="1"
                                                        />
                                                      </svg>
                                                    </div>
                                                  </div>
                                                  <div className="trades-list_item">
                                                    <div className="trades-list_item-short">
                                                      <p
                                                        style={{
                                                          fontSize: "12px",
                                                          margin: "0",
                                                        }}
                                                      >
                                                        {t("Order")}:{" "}
                                                        {result?.reference_id}
                                                      </p>
                                                      <div className="item-row">
                                                        <div>
                                                          <span className="opcty05">
                                                            {t("Open price")}:
                                                          </span>
                                                          <br />
                                                          {/* {result?.entry_price
                                                          ? parseFloat(
                                                              result?.entry_price
                                                            ).toFixed(2)
                                                          : ""} */}
                                                          {formatWithSameDecimal(
                                                            Number(
                                                              result?.entry_price,
                                                            ),
                                                            toFixeddesimal,
                                                          )}
                                                          {/* {result?.entry_price
                                                            ? parseFloat(
                                                                result?.entry_price,
                                                              ).toFixed(
                                                                toFixeddesimal,
                                                              )
                                                            : ""} */}
                                                        </div>
                                                        <div className="centered">
                                                          <span className="opcty05">
                                                            {t("Closing price")}
                                                            :
                                                          </span>
                                                          <br />
                                                          {formatWithSameDecimal(
                                                            Number(
                                                              result?.exit_price,
                                                            ),
                                                            toFixeddesimal,
                                                          )}

                                                          {/* {result?.exit_price
                                                          ? parseFloat(
                                                              result?.exit_price
                                                            ).toFixed(2)
                                                          : ""} */}
                                                        </div>
                                                        <div className="text-end">
                                                          <span className="opcty05">
                                                            {t("Difference")}
                                                          </span>
                                                          <br />(
                                                          {result?.type ===
                                                          "buy" ? (
                                                            parseFloat(
                                                              result?.exit_price,
                                                            ) ===
                                                            parseFloat(
                                                              result?.entry_price,
                                                            ) ? (
                                                              0
                                                            ) : parseFloat(
                                                                result?.exit_price,
                                                              ) >
                                                              parseFloat(
                                                                result?.entry_price,
                                                              ) ? (
                                                              <span
                                                                className="price-up"
                                                                //  className="tooltip-wrapper"
                                                              >
                                                                +
                                                                {
                                                                  calculateSmartPoints(
                                                                    result?.entry_price,
                                                                    result?.exit_price,
                                                                  )?.points
                                                                }
                                                              </span>
                                                            ) : (
                                                              <span className="price-down">
                                                                {
                                                                  calculateSmartPoints(
                                                                    result?.entry_price,
                                                                    result?.exit_price,
                                                                  )?.points
                                                                }
                                                              </span>
                                                            )
                                                          ) : parseFloat(
                                                              result?.exit_price,
                                                            ) ===
                                                            parseFloat(
                                                              result?.entry_price,
                                                            ) ? (
                                                            0
                                                          ) : parseFloat(
                                                              result?.exit_price,
                                                            ) <
                                                            parseFloat(
                                                              result?.entry_price,
                                                            ) ? (
                                                            <span className="price-down">
                                                              {
                                                                calculateSmartPoints(
                                                                  result?.entry_price,
                                                                  result?.exit_price,
                                                                )?.points
                                                              }
                                                            </span>
                                                          ) : (
                                                            <span className="price-up">
                                                              +
                                                              {
                                                                calculateSmartPoints(
                                                                  result?.entry_price,
                                                                  result?.exit_price,
                                                                )?.points
                                                              }
                                                            </span>
                                                          )}{" "}
                                                          {t("Points")})
                                                        </div>
                                                      </div>

                                                      <div className="item-row">
                                                        {result?.copy_id ? (
                                                          <div className="w-100 text-center">
                                                            <i class="fa-regular fa-copy"></i>{" "}
                                                            Trade copied
                                                            <br />
                                                            Trader ID:{" "}
                                                            <span
                                                              onClick={(e) => {
                                                                openModal(
                                                                  "socialTradingview_popup",
                                                                );
                                                                setShowCopyhistory(
                                                                  false,
                                                                );
                                                                userdetailsfromid(
                                                                  result?.copy_user_id,
                                                                  result?.rank,
                                                                  "today",
                                                                  false,
                                                                );
                                                                setModelloading(
                                                                  true,
                                                                );
                                                                e.stopPropagation();
                                                              }}
                                                              onMouseEnter={() => {
                                                                userdetailsfromid(
                                                                  result?.copy_user_id,
                                                                  result?.rank,
                                                                  "today",
                                                                  false,
                                                                );
                                                              }}
                                                              className="opcty05"
                                                            >
                                                              {
                                                                result?.copy_user_id
                                                              }{" "}
                                                              (
                                                              {formatName(
                                                                result?.copy_user_name,
                                                              )}
                                                              )
                                                            </span>
                                                          </div>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <p className="text-center">
                                          {t("No closed trades")}
                                        </p>
                                      )}
                                    </>
                                  ),
                                )}
                                <div className="tradelist_morebtn text-center mt-3 mb-3">
                                  <Link
                                    to={`${base_url}accounthistory`}
                                    state={{ from: "trading_history" }}
                                    type="button"
                                    className="btn morebtn-btn"
                                  >
                                    More
                                  </Link>
                                </div>
                              </>
                            ) : (
                              <p className="text-center">
                                {t("No closed trades")}
                              </p>
                            )
                          ) : (
                            <div className="loading-container text-center">
                              <div
                                className="spinner-border text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* <!-- --------- Trades End----------- --> */}

            {/* <!-- --------- Social Trading Start----------- --> */}
            {sidebaractive?.socialTradingCollapse && (
              <div className="collapsePop" id="socialTradingCollapse">
                <div className="socialTrading_topbar">
                  <h5 className="rightsidebar_title">{t("Social Trading")}</h5>
                  {checkliveaccount ? (
                    <div
                      style={{
                        background: "#4b4040",
                        color: "#fff",
                        border: "1px dashed #fff",
                        height: "30px",
                        marginBottom: "10px",
                        textAlign: "center",
                        display: "block",
                        display: "-webkit-box",
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <small>
                        {t("This section is only available for real account.")}
                      </small>
                    </div>
                  ) : (
                    ""
                  )}
                  <Dropdown>
                    <Dropdown.Toggle
                      className="form-select form-control"
                      id="dropdown-select-country"
                    >
                      <i className={socialfilter?.icon}></i>{" "}
                      {t(socialfilter?.label)}
                      <i class="arrow-angle-down fa-solid fa-angle-down"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {socialdroplist?.length
                        ? socialdroplist.map((item) => (
                            <Dropdown.Item
                              className={
                                item?.label === "Leaderboard"
                                  ? !checkleaderboaed?.hide_leaderboaed
                                    ? "d-none"
                                    : ""
                                  : ""
                              }
                              key={item.key}
                              eventKey={item.key}
                              // disabled={loadingsocial}
                              onClick={() => {
                                {
                                  getsocialtrade(item.label);
                                  setSocialfilter(item);
                                  setShowcopydeleteicon(false);
                                }
                              }}
                            >
                              <i className={item.icon}></i>{" "}
                              {item.label === "List of copied traders"
                                ? `${t(item.label)} ${
                                    copycount ? `(${copycount})` : ""
                                  }`
                                : t(item.label)}
                            </Dropdown.Item>
                          ))
                        : ""}
                    </Dropdown.Menu>
                  </Dropdown>

                  {socialfilter?.label === "Trader who watch me" ? (
                    <h5 className="rightsidebar_subtitle mt-2 mb-3">
                      {t("Watching me")}{" "}
                      {watchmecount > 0 ? `(${watchmecount})` : ""}
                    </h5>
                  ) : socialfilter?.label === "Trader who copy me" ? (
                    <h5 className="rightsidebar_subtitle mt-2 mb-3">
                      {t("Copying me")}{" "}
                      {sociallist?.length > 0 ? `(${sociallist?.length})` : ""}
                    </h5>
                  ) : socialfilter?.label === "Search" ||
                    socialfilter?.label === "Settings" ? (
                    <span></span>
                  ) : (
                    <h5 className="rightsidebar_subtitle mt-2 mb-3">
                      {t("Real trading")}
                    </h5>
                  )}
                </div>
                <div className="socialTradingList">
                  <div
                    className="searchsocialTrading"
                    style={{
                      display:
                        socialfilter?.label === "Search" ? "block" : "none",
                    }}
                  >
                    {/* <form action="#"> */}
                    <div className="form-group position-relative mt-2">
                      <input
                        type="number"
                        name="search"
                        className="form-control"
                        placeholder={t("Enter user ID")}
                        value={searchfilter}
                        onChange={(e) => {
                          searchtrader(e.target.value);
                          setSearchfilter(e.target.value); // optional for tracking
                          // const filtered = sociallist.filter(
                          //   (item) =>
                          //     item.user_id.toString() ===
                          //     e.target.value.toString()
                          // );
                          // setSearchfilterdata(filtered);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            searchtrader(e.target.value);
                            setSearchfilter(e.target.value); // optional for tracking
                            // const filtered = sociallist.filter(
                            //   (item) =>
                            //     item.user_id.toString() ===
                            //     e.target.value.toString()
                            // );
                            // setSearchfilterdata(filtered);
                          }
                        }}
                      />
                      {searchfilter ? (
                        <i
                          onClick={() => {
                            searchtrader("");
                            setSearchfilter("");
                          }}
                          className="fa-solid fa-xmark search_input_close"
                        ></i>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* </form> */}
                  </div>
                  <div
                    className="searchsocialTrading"
                    style={{
                      display:
                        socialfilter?.label === "Settings" ? "block" : "none",
                    }}
                  >
                    {/* <form action="#"> */}
                    <div className="cardBox h-100 mt-2">
                      <h4 className="card_title">
                        {t("Social Trading Settings")}
                      </h4>
                      <div className="socialTradingSeting">
                        {socialTradingSettings &&
                          Object.keys(socialTradingSettings).map((key) => (
                            <div key={key} className="form-check form-switch">
                              <div className="check-input-div">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={!socialTradingSettings[key]}
                                  onChange={() => setupsocialsetting(key)}
                                />
                              </div>
                              <label className="form-check-label">
                                {settingLabels[key] || key}{" "}
                                {/* Fallback to key if not found */}
                              </label>
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* </form> */}
                  </div>
                  <div
                    className="emptyinfo copiedtraders"
                    style={{ display: "none" }}
                  >
                    <div
                      className="alert alert-primary d-flex align-items-center"
                      role="alert"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="rgba(100,106,108,1)"
                      >
                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"></path>
                      </svg>{" "}
                      <div>{t("Your list of copied traders is empty")}</div>
                    </div>
                  </div>

                  <div
                    className="emptyinfo tradeswhocopyme"
                    style={{ display: "none" }}
                  >
                    <div
                      className="alert alert-primary d-flex align-items-center"
                      role="alert"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="rgba(100,106,108,1)"
                      >
                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"></path>
                      </svg>{" "}
                      <div>{t("No data")}</div>
                    </div>
                  </div>

                  <div
                    className="emptyinfo watchedtraders"
                    style={{ display: "none" }}
                  >
                    <div
                      className="alert alert-primary d-flex align-items-center"
                      role="alert"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="rgba(100,106,108,1)"
                      >
                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"></path>
                      </svg>{" "}
                      <div>{t("Your list of watched traders is empty")}</div>
                    </div>
                  </div>

                  <div
                    className="emptyinfo whowatchme"
                    style={{ display: "none" }}
                  >
                    <div
                      className="alert alert-primary d-flex align-items-center"
                      role="alert"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="rgba(100,106,108,1)"
                      >
                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"></path>
                      </svg>{" "}
                      <div>{t("No data")}</div>
                    </div>
                  </div>

                  <div
                    className="socialTradingSeting"
                    style={{ display: "none" }}
                  >
                    <div className="form-check form-switch">
                      <div className="check-input-div">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked=""
                        />
                      </div>
                      <label className="form-check-label">
                        {t("Display social trades")}
                      </label>
                    </div>
                    <div className="form-check form-switch">
                      <div className="check-input-div">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked=""
                        />
                      </div>
                      <label className="form-check-label">
                        Watching copied trades
                      </label>
                    </div>
                    <div className="form-check form-switch">
                      <div className="check-input-div">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked=""
                        />
                      </div>
                      <label className="form-check-label">
                        Hide copying and statistics of my profile
                      </label>
                    </div>
                    <div className="form-check form-switch">
                      <div className="check-input-div">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked=""
                        />
                      </div>
                      <label className="form-check-label">
                        Hide watching of my trading
                      </label>
                    </div>
                    <div className="form-check form-switch">
                      <div className="check-input-div">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked=""
                        />
                      </div>
                      <label className="form-check-label">
                        Show only watched traders
                      </label>
                    </div>
                  </div>
                  <div>
                    <div
                      className="topranking_list"
                      style={{
                        display:
                          socialfilter?.label === "Search" ||
                          socialfilter?.label === "Settings" ||
                          socialfilter?.label === "Trader who copy me" ||
                          socialfilter?.label === "Trader who watch me"
                            ? "none"
                            : "block",
                      }}
                    >
                      <div>
                        {loadingsocial ? (
                          <div className="socialloaderno">
                            <CommonSpinner />
                          </div>
                        ) : sociallist?.length ? (
                          <>
                            {socialfilter?.label === "List of copied traders" &&
                            allCopyZero ? (
                              <div className="text-white text-center mt-xl-0 socialnodata">
                                {t("No Data Found")}
                              </div>
                            ) : (
                              sociallist.map((result, key) => {
                                if (
                                  socialfilter?.label ===
                                    "List of copied traders" &&
                                  result?.copy_status === 0
                                ) {
                                  return null;
                                }
                                return (
                                  <div
                                    className="topranking_item"
                                    key={key}
                                    // style={{
                                    //   display:
                                    //     socialfilter?.label ===
                                    //     "List of copied traders"
                                    //       ? result?.copy_status === 0
                                    //         ? "none"
                                    //         : ""
                                    //       : "",
                                    // }}
                                  >
                                    <button
                                      onClick={() => {
                                        openModal("socialTradingview_popup");
                                        setShowCopyhistory(false);
                                        userdetailsfromid(
                                          result?.user_id,
                                          result?.rank,
                                          "today",
                                          false,
                                        );
                                        setModelloading(true);
                                        setShowcopydeleteicon(false);
                                      }}
                                      onMouseEnter={() => {
                                        userdetailsfromid(
                                          result?.user_id,
                                          result?.rank,
                                          "today",
                                          false,
                                        );
                                      }}
                                      // onTouchStart={()=>{
                                      //     userdetailsfromid(
                                      //     result?.user_id,
                                      //     result?.rank,
                                      //     "today",
                                      //     false
                                      //   );
                                      // }}
                                      className="popsocialbtn"
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#socialTradingview_popup"
                                    >
                                      <div className="realtradingcolOne">
                                        <img
                                          src={
                                            result?.user_profile
                                              ? process.env
                                                  .REACT_APP_IMAGE_URL +
                                                result?.user_profile
                                              : user
                                          }
                                          alt=""
                                        />

                                        <span>
                                          <div className="realtradinguser">
                                            {result?.nickname
                                              ? result?.nickname
                                              : formatName(
                                                  result?.user_name,
                                                )}{" "}
                                          </div>
                                          {!result?.is_deleted ? (
                                            result?.socialtradingsettings
                                              ?.hideCopyingStatistics ? (
                                              <small
                                                style={{
                                                  display:
                                                    socialfilter?.label ===
                                                    "List of copied traders"
                                                      ? "none"
                                                      : "",
                                                }}
                                              >
                                                {t("Number of trades")}{" "}
                                                <span className="text-white">
                                                  {result?.trade_count}
                                                </span>
                                              </small>
                                            ) : (
                                              <small
                                                style={{
                                                  display:
                                                    socialfilter?.label ===
                                                    "List of copied traders"
                                                      ? "none"
                                                      : "",
                                                }}
                                              >
                                                {t("Number of trades")}{" "}
                                                <span className="text-white">
                                                  0
                                                </span>
                                              </small>
                                            )
                                          ) : (
                                            <small
                                              style={{
                                                display:
                                                  socialfilter?.label ===
                                                  "List of copied traders"
                                                    ? "none"
                                                    : "",
                                              }}
                                            >
                                              {t("Number of trades")}{" "}
                                              <span className="text-white">
                                                0
                                              </span>
                                            </small>
                                          )}
                                        </span>
                                      </div>
                                      {!result?.is_deleted ? (
                                        result?.socialtradingsettings
                                          ?.hideCopyingStatistics ? (
                                          <span
                                            className={
                                              parseInt(result?.total_profit) > 0
                                                ? "textgreen text-end"
                                                : parseInt(
                                                      result?.total_profit,
                                                    ) < 0
                                                  ? "textgreen text-danger text-end"
                                                  : "text-end"
                                            }
                                          >
                                            ${" "}
                                            {result?.total_profit
                                              ? formatPrice(
                                                  Math.abs(
                                                    unformatPrice(
                                                      result.total_profit,
                                                    ),
                                                  ),
                                                )
                                              : "0.00"}
                                            <small
                                              style={{
                                                display:
                                                  socialfilter?.label ===
                                                  "List of copied traders"
                                                    ? "none"
                                                    : "",
                                              }}
                                            >
                                              {t("Profitable Trades")} :{" "}
                                              <span className="text-white">
                                                {result?.profitable_trades_percentage
                                                  ? parseInt(
                                                      result?.profitable_trades_percentage,
                                                    )
                                                  : 0.0}
                                                %
                                              </span>
                                            </small>
                                            <small
                                              style={{
                                                display:
                                                  socialfilter?.label !==
                                                  "List of copied traders"
                                                    ? "none"
                                                    : "",
                                              }}
                                            >
                                              <span className="text-white">
                                                {result?.copy_time}
                                              </span>
                                            </small>
                                          </span>
                                        ) : (
                                          <span className="text-end">
                                            $ 0.00
                                            <small
                                              style={{
                                                display:
                                                  socialfilter?.label ===
                                                  "List of copied traders"
                                                    ? "none"
                                                    : "",
                                              }}
                                            >
                                              {t("Profitable Trades")} :{" "}
                                              <span className="text-white">
                                                0 %
                                              </span>
                                            </small>
                                          </span>
                                        )
                                      ) : (
                                        <span className="text-end">
                                          $ 0.00
                                          <small
                                            style={{
                                              display:
                                                socialfilter?.label ===
                                                "List of copied traders"
                                                  ? "none"
                                                  : "",
                                            }}
                                          >
                                            {t("Profitable Trades")} :{" "}
                                            <span className="text-white">
                                              0 %
                                            </span>
                                          </small>
                                        </span>
                                      )}
                                    </button>
                                  </div>
                                );
                              })
                            )}
                          </>
                        ) : socialfilter?.label !== "List of copied traders" ? (
                          <div className="text-white text-center mt-xl-0 socialnodata">
                            {t("No Data Found")}{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <h5
                        class="rightsidebar_subtitle mt-2 mb-3 text-center"
                        style={{
                          display:
                            socialfilter?.label === "List of copied traders"
                              ? "block"
                              : "none",
                        }}
                      >
                        {t("History")}
                      </h5>
                      {socialfilter?.label === "List of copied traders" ? (
                        <div>
                          {loadingsocial ? (
                            <div className="socialloaderno pt-3">
                              <CommonSpinner />
                            </div>
                          ) : sociallist?.length ? (
                            sociallist.map((result, key) => {
                              const shouldShow =
                                socialfilter?.label ===
                                  "List of copied traders" &&
                                result?.copy_status === 0;
                              if (!shouldShow) return null;
                              return (
                                <div
                                  className="topranking_item"
                                  key={key}
                                  // style={{
                                  //   display:
                                  //     socialfilter?.label ===
                                  //     "List of copied traders"
                                  //       ? result?.copy_status === 0
                                  //         ? "block"
                                  //         : "none"
                                  //       : "none",
                                  // }}
                                >
                                  <button
                                    onClick={() => {
                                      openModal("socialTradingview_popup");
                                      setShowCopyhistory(false);
                                      userdetailsfromid(
                                        result?.user_id,
                                        result?.rank,
                                        "today",
                                        false,
                                      );
                                      setModelloading(true);
                                      setShowcopydeleteicon(true);
                                    }}
                                    onMouseEnter={() => {
                                      userdetailsfromid(
                                        result?.user_id,
                                        result?.rank,
                                        "today",
                                        false,
                                      );
                                    }}
                                    className="popsocialbtn"
                                  >
                                    <div>
                                      <img
                                        src={
                                          result?.user_profile
                                            ? process.env.REACT_APP_IMAGE_URL +
                                              result?.user_profile
                                            : user
                                        }
                                        alt=""
                                      />
                                      <span>
                                        <div className="realtradinguser">
                                          {result?.nickname
                                            ? result?.nickname
                                            : formatName(
                                                result?.user_name,
                                              )}{" "}
                                        </div>
                                      </span>
                                    </div>
                                    {!result?.is_deleted ? (
                                      <span
                                        className={
                                          parseInt(result?.total_profit) > 0
                                            ? "textgreen text-end"
                                            : parseInt(result?.total_profit) < 0
                                              ? "textgreen text-danger text-end"
                                              : "text-end"
                                        }
                                      >
                                        ${" "}
                                        {result?.total_profit
                                          ? formatPrice(
                                              Math.abs(
                                                unformatPrice(
                                                  result.total_profit,
                                                ),
                                              ),
                                            )
                                          : "0.00"}{" "}
                                        <small>
                                          <span className="text-gray">
                                            Total profit
                                          </span>
                                        </small>
                                      </span>
                                    ) : (
                                      <span className="text-end">
                                        $ 0.00
                                        <small>
                                          <span className="text-gray">
                                            Total profit
                                          </span>
                                        </small>
                                      </span>
                                    )}
                                  </button>
                                </div>
                              );
                            })
                          ) : (
                            <div className="text-white text-center mt-xl-0 socialnodata">
                              {t("No Data Found")}{" "}
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {socialfilter?.label === "Trader who copy me" ||
                  socialfilter?.label === "Trader who watch me" ? (
                    <div>
                      <div
                        className="topranking_list"
                        style={{
                          display:
                            socialfilter?.label === "Trader who copy me" ||
                            socialfilter?.label === "Trader who watch me"
                              ? "block"
                              : "none",
                        }}
                      >
                        {loadingsocial ? (
                          <div className="socialloaderno">
                            <CommonSpinner />
                          </div>
                        ) : sociallist?.length ? (
                          sociallist.map((result, key) => {
                            return (
                              <div className="topranking_item" key={key}>
                                <button
                                  onClick={() => {
                                    openModal("socialTradingview_popup");
                                    setShowCopyhistory(false);
                                    userdetailsfromid(
                                      result?.user_id,
                                      result?.rank,
                                      "today",
                                      false,
                                    );
                                    setShowcopydeleteicon(false);
                                    setModelloading(true);
                                  }}
                                  onMouseEnter={() => {
                                    userdetailsfromid(
                                      result?.user_id,
                                      result?.rank,
                                      "today",
                                      false,
                                    );
                                  }}
                                  className="popsocialbtn"
                                >
                                  <div>
                                    <img
                                      src={
                                        result?.user_profile
                                          ? process.env.REACT_APP_IMAGE_URL +
                                            result?.user_profile
                                          : user
                                      }
                                      alt=""
                                    />
                                    <span>
                                      <div className="realtradinguser">
                                        {result?.nickname
                                          ? result?.nickname
                                          : formatName(result?.user_name)}{" "}
                                      </div>
                                      <div className="socialuserid">
                                        ID: {result?.user_id}
                                      </div>
                                    </span>
                                  </div>
                                </button>

                                {socialfilter?.label ===
                                "Trader who copy me" ? (
                                  <div className="disallowsocial">
                                    <span
                                      onClick={() =>
                                        dissallowcopy(result?.user_id, "copy")
                                      }
                                      class="badge rounded-pill bg-danger pointercursor"
                                    >
                                      {t("Disallow Copy")}
                                    </span>
                                    <span className="text-white disallowsocial">
                                      {result?.copy_time}
                                    </span>
                                  </div>
                                ) : socialfilter?.label ===
                                  "Trader who watch me" ? (
                                  <div className="disallowsocial">
                                    <span
                                      onClick={() =>
                                        dissallowcopy(result?.user_id, "watch")
                                      }
                                      class="badge rounded-pill bg-danger pointercursor"
                                    >
                                      {t("Disallow Watch")}
                                    </span>
                                    <span className="text-white">
                                      {result?.copy_time}
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-white text-center mt-xl-0 socialnodata">
                            {t("No Data Found")}{" "}
                          </div>
                        )}
                      </div>
                      <h5 class="rightsidebar_subtitle mt-2 mb-3 text-center">
                        {t("Blocked Traders")}{" "}
                        {socialfilter?.label === "Trader who copy me"
                          ? blocklistcount > 0
                            ? `(${blocklistcount})`
                            : ""
                          : ""}
                      </h5>
                      <div
                        className="topranking_list"
                        style={{
                          display:
                            socialfilter?.label === "Trader who copy me" ||
                            socialfilter?.label === "Trader who watch me"
                              ? "block"
                              : "none",
                        }}
                      >
                        {blockcopylist?.length ? (
                          blockcopylist.map((result, key) => {
                            if (
                              socialfilter?.label === "Trader who watch me" &&
                              result?.type === "copy"
                            ) {
                              return null;
                            }
                            if (
                              socialfilter?.label === "Trader who copy me" &&
                              result?.type === "watch"
                            ) {
                              return null;
                            }
                            return (
                              <div className={`topranking_item`} key={key}>
                                <button
                                  onClick={() => {
                                    openModal("socialTradingview_popup");
                                    setShowCopyhistory(false);
                                    userdetailsfromid(
                                      result?.blocked_user_id,
                                      result?.rank,
                                      "today",
                                      false,
                                    );
                                    setModelloading(true);
                                    setShowcopydeleteicon(false);
                                  }}
                                  onMouseEnter={() => {
                                    userdetailsfromid(
                                      result?.blocked_user_id,
                                      result?.rank,
                                      "today",
                                      false,
                                    );
                                  }}
                                  // onTouchStart={()=>{
                                  //     userdetailsfromid(
                                  //     result?.user_id,
                                  //     result?.rank,
                                  //     "today",
                                  //     false
                                  //   );
                                  // }}
                                  className="popsocialbtn"
                                  // data-bs-toggle="modal"
                                  // data-bs-target="#socialTradingview_popup"
                                >
                                  <div>
                                    <img
                                      src={
                                        result?.blocked_user?.profile
                                          ? process.env.REACT_APP_IMAGE_URL +
                                            result?.blocked_user?.profile
                                          : user
                                      }
                                      alt=""
                                    />
                                    <span>
                                      <div className="realtradinguser">
                                        {formatName(
                                          result?.blocked_user?.name,
                                        )}{" "}
                                      </div>
                                    </span>
                                  </div>
                                </button>
                                {socialfilter?.label ===
                                "Trader who copy me" ? (
                                  <div className="disallowsocial">
                                    <span
                                      onClick={() =>
                                        allowcopy(
                                          result?.blocked_user_id,
                                          "copy",
                                        )
                                      }
                                      class="badge rounded-pill bg-success pointercursor"
                                    >
                                      {t("Allow Copy")}
                                    </span>
                                    <span className="text-white">
                                      {result?.blocked_time_ago}
                                    </span>
                                  </div>
                                ) : socialfilter?.label ===
                                  "Trader who watch me" ? (
                                  <div className="disallowsocial">
                                    <span
                                      onClick={() =>
                                        allowcopy(
                                          result?.blocked_user_id,
                                          "watch",
                                        )
                                      }
                                      class="badge rounded-pill bg-success pointercursor"
                                    >
                                      {t("Allow watch")}
                                    </span>
                                    <span className="text-white">
                                      {result?.blocked_time_ago}
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-white text-center mt-xl-0 socialnodata">
                            {t("No Data Found")}{" "}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    className="topranking_list"
                    style={{
                      display:
                        socialfilter?.label === "Search" ? "block" : "none",
                    }}
                  >
                    {searchloading ? (
                      <div className="socialnodata">
                        <CommonSpinner />
                      </div>
                    ) : searchfilterdata?.length ? (
                      searchfilterdata.map((result, key) => {
                        return (
                          <div className="topranking_item" key={key}>
                            <button
                              onClick={() => {
                                openModal("socialTradingview_popup");
                                setShowcopydeleteicon(false);
                                userdetailsfromid(
                                  result?.user_id,
                                  result?.rank,
                                  "today",
                                  false,
                                );
                              }}
                              className="popsocialbtn"
                              // data-bs-toggle="modal"
                              // data-bs-target="#socialTradingview_popup"
                            >
                              <div>
                                <img
                                  src={
                                    result?.user_profile
                                      ? process.env.REACT_APP_IMAGE_URL +
                                        result?.user_profile
                                      : user
                                  }
                                  alt=""
                                />

                                <span>
                                  <div className="realtradinguser">
                                    {" "}
                                    {result?.nickname
                                      ? result?.nickname
                                      : formatName(result?.user_name)}{" "}
                                  </div>
                                  {result?.socialtradingSettings
                                    ?.hideCopyingStatistics ? (
                                    //   &&
                                    // result?.socialTradingSettings
                                    //   ?.hideWatchingTrading
                                    <small>
                                      {t("Number of trades")}{" "}
                                      <span
                                        className={` ${
                                          result?.trade_count === 0
                                            ? "text-secondary"
                                            : "text-white"
                                        }`}
                                      >
                                        {result?.trade_count}
                                      </span>
                                    </small>
                                  ) : (
                                    <small>
                                      {t("Number of trades")}{" "}
                                      <span className="text-secondary">0</span>
                                    </small>
                                  )}
                                </span>
                              </div>
                              {result?.socialtradingSettings
                                ?.hideCopyingStatistics ? (
                                <span
                                  className={
                                    parseInt(result?.total_profit) > 0
                                      ? "textgreen text-end"
                                      : parseInt(result?.total_profit) < 0
                                        ? "textgreen text-danger text-end"
                                        : "text-secondary text-end"
                                  }
                                >
                                  ${" "}
                                  {result?.total_profit
                                    ? result?.total_profit
                                    : "0.00"}{" "}
                                  <small>
                                    {t("Profitable Trades")} :{" "}
                                    <span
                                      className={
                                        result?.profitable_trades_percentage ===
                                        "0.00"
                                          ? "text-secondary"
                                          : "text-white"
                                      }
                                    >
                                      {result?.profitable_trades_percentage
                                        ? parseInt(
                                            result?.profitable_trades_percentage,
                                          )
                                        : 0.0}
                                      %
                                    </span>
                                  </small>
                                </span>
                              ) : (
                                <span className="text-secondary text-end">
                                  $ 0.00
                                  <small>
                                    {t("Profitable Trades")} :{" "}
                                    <span className="text-white">0.00 %</span>
                                  </small>
                                </span>
                              )}
                            </button>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-white text-center mt-xl-0 socialnodata">
                        {t("No Data Found")}{" "}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* <!-- --------- Social Trading End----------- --> */}
            {/* <!-- --------- Pending Trades Start----------- --> */}
            {sidebaractive?.pendingTradesCollapse && (
              <div class="collapsePop" id="pendingTradesCollapse">
                <div class="pendingTrades_topbar">
                  <h5 class="rightsidebar_title">{t("Pending trades")}</h5>
                </div>
                <div class="pendingTrades_body">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="bythetime-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#bythetime"
                        type="button"
                        role="tab"
                        aria-controls="bythetime"
                        aria-selected="true"
                      >
                        {t("By the time")}
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="bytheassetprice-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#bytheassetprice"
                        type="button"
                        role="tab"
                        aria-controls="bytheassetprice"
                        aria-selected="false"
                      >
                        {t("By the asset price")}
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="current-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#current"
                        type="button"
                        role="tab"
                        aria-controls="current"
                        aria-selected="false"
                      >
                        {t("Current")}{" "}
                        {/* <span>{pendingtrade?.length}</span> */}
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="bythetime"
                      role="tabpanel"
                      aria-labelledby="bythetime-tab"
                    >
                      <form action="#">
                        <p>{t("Make a trade at the specified time")}</p>
                        <div class="form-group mb-3">
                          <label>{t("Asset")}</label>
                          <Dropdown>
                            <Dropdown.Toggle
                              className="form-select form-control"
                              id="dropdown-select-country"
                            >
                              {pendingbytime?.asset ||
                                `${chnagetype?.sortname}/${chnagetype?.csymbol}` ||
                                "Crypto Currency"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{ maxHeight: "300px", overflowY: "auto" }}
                            >
                              <Dropdown.Header style={{ textAlign: "center" }}>
                                {t("Crypto Currency")}
                              </Dropdown.Header>
                              {cryptocurrencieslist?.map((result, key) =>
                                parseInt(result?.status) === 1 ? (
                                  <Dropdown.Item
                                    key={`crypto-${key}`}
                                    onClick={() => {
                                      buythetime("asset", result);
                                    }}
                                  >
                                    {result?.sortname}/{result?.csymbol}
                                  </Dropdown.Item>
                                ) : null,
                              )}
                              <Dropdown.Header style={{ textAlign: "center" }}>
                                {t("Currency")}
                              </Dropdown.Header>
                              {currencieslist?.map((result, key) =>
                                parseInt(result?.status) === 1 ? (
                                  <Dropdown.Item
                                    key={`currency-${key}`}
                                    onClick={() => {
                                      buythetime("asset", result);
                                    }}
                                  >
                                    {result?.sortname}/{result?.csymbol}
                                  </Dropdown.Item>
                                ) : null,
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                          {/* <select
                            className="form-select"
                            aria-label="Default select example"
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              const selectedObject =
                                cryptocurrencieslist?.find(
                                  (item) =>
                                    `${item?.sortname}/${item?.csymbol}` ===
                                    selectedValue
                                ) ||
                                currencieslist?.find(
                                  (item) =>
                                    `${item?.sortname}/${item?.csymbol}` ===
                                    selectedValue
                                );

                              buythetime("asset", selectedObject || chnagetype);
                            }}
                            value={
                              pendingbytime?.asset ||
                              `${chnagetype?.sortname}/${chnagetype?.csymbol}`
                            }
                          >
                            <option
                              style={{ textAlign: "center" }}
                              value=""
                              disabled
                            >
                              Crypto Currency
                            </option>
                            {cryptocurrencieslist?.map((result, key) =>
                              parseInt(result?.status) === 1 ? (
                                <option
                                  key={key}
                                  value={`${result?.sortname}/${result?.csymbol}`}
                                >
                                  {result?.sortname}/{result?.csymbol}
                                </option>
                              ) : null
                            )}
                            <option style={{ textAlign: "center" }} disabled>
                              {t("Currency")}
                            </option>
                            {currencieslist?.map((result, key) =>
                              parseInt(result?.status) === 1 ? (
                                <option
                                  key={key}
                                  value={`${result?.sortname}/${result?.csymbol}`}
                                >
                                  {result?.sortname}/{result?.csymbol}
                                </option>
                              ) : (
                                ""
                              )
                            )}
                          </select> */}
                        </div>
                        <div class="form-group mb-3">
                          <label>{t("Open time")}</label>
                          <div class="row">
                            <div class="col-6 pe-1 customdatrpicker02">
                              <DatePicker
                                selected={
                                  pendingbytime?.opentime
                                    ? new Date(pendingbytime.opentime)
                                    : new Date()
                                }
                                value={
                                  pendingbytime?.opentime ||
                                  new Date().toISOString().split("T")[0]
                                }
                                onChange={(date) =>
                                  buythetime(
                                    "opentime",
                                    date
                                      ? date.toLocaleDateString("en-CA")
                                      : "",
                                  )
                                }
                                dayPlaceholder="DD"
                                monthPlaceholder="MM"
                                yearPlaceholder="YYYY"
                                dateFormat="dd-MM-yyyy"
                                minDate={new Date()}
                                showYearDropdown
                                scrollableYearDropdown
                                wrapperClassName="w-100"
                              />
                              {/* <input
                                onChange={(e) => {
                                  const selectedDate = e.target.value;
                                  const today = new Date()
                                    .toISOString()
                                    .split("T")[0];

                                  if (selectedDate < today) {
                                    e.target.value = today; // Reset to today if past date is entered
                                  } else {
                                    buythetime("opentime", selectedDate);
                                  }
                                }}
                                value={
                                  pendingbytime?.opentime ||
                                  new Date().toISOString().split("T")[0]
                                } // Defaults to today if no value is set
                                type="date"
                                className="form-control"
                                placeholder="date"
                                aria-label="date"
                                min={new Date().toISOString().split("T")[0]} // Prevents selection of past dates
                                style={{
                                  WebkitAppearance: "none",
                                  position: "relative",
                                }}
                              />
                              <style>
                                {`
    input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }
  `}
                              </style> */}
                            </div>
                            <div class="col-6 ps-1">
                              <input
                                id="timeInput"
                                type="text"
                                className="form-control"
                                placeholder="HH:mm:ss"
                                value={pendingbytime?.time}
                                onChange={handleTimeChange}
                                aria-label="time"
                              />
                              {timeerror && (
                                <span style={{ color: "red" }}>
                                  {timeerror}
                                </span>
                              )}
                              {/* <input
                              onChange={(e) =>
                                buythetime("time", e.target.value)
                              }
                              value={pendingbytime?.time}
                              type="text"
                              className="form-control"
                              placeholder="HH:MM:SS"
                              aria-label="time"
                            /> */}
                            </div>
                          </div>
                        </div>
                        {/* <div class="form-group mb-3">
                        <label>
                          {t("Payout")}{" "}
                          <span
                            class="tooltip01"
                            data-bs-toggle="tooltip"
                            data-bs-placement="left"
                            title="Lorem ipsum dolor sit amet,"
                          >
                            ?
                          </span>
                        </label>
                        <div class="input-group mb-3">
                          <span class="input-group-text">{t("From")}</span>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              if (
                                value === "" ||
                                (/^\d+$/.test(value) && parseInt(value) <= 98)
                              ) {
                                buythetime("payout", value || 92);
                              } else if (parseInt(value) > 98) {
                                buythetime("payout", 98);
                              }
                            }}
                            value={pendingbytime?.payout || 92}
                            type="text"
                            className="form-control"
                            aria-label="Amount (to the nearest dollar)"
                          />
                          <span class="input-group-text">%</span>
                        </div>
                      </div> */}
                        <div class="form-group mb-3">
                          <label>{t("Timeframe")}</label>
                          <div class="input-group timeframeInput">
                            <div class="incdicbutton">
                              <span
                                class="plus btn"
                                onClick={() =>
                                  updowntime("add", "hours", "pendingbytime")
                                }
                              >
                                <img src={add} />
                              </span>
                              <input
                                onChange={(e) =>
                                  pendingtimeset(
                                    e.target.value,
                                    pendingtime?.minutes,
                                    pendingtime?.secound,
                                  )
                                }
                                value={pendingtime?.hours}
                                type="text"
                                class="form-control"
                                placeholder="00"
                              />
                              <span
                                class="minus btn"
                                onClick={() =>
                                  updowntime("minus", "hours", "pendingbytime")
                                }
                              >
                                <img src={minus} />
                              </span>
                            </div>
                            <div class="incdicbutton">
                              <span
                                class="plus btn"
                                onClick={() =>
                                  updowntime("add", "minutes", "pendingbytime")
                                }
                              >
                                <img src={add} />
                              </span>
                              <input
                                onChange={(e) =>
                                  pendingtimeset(
                                    pendingtime?.hours,
                                    e.target.value,
                                    pendingtime?.secound,
                                  )
                                }
                                value={pendingtime?.minutes}
                                type="text"
                                class="form-control"
                                placeholder="00"
                              />
                              <span
                                class="minus btn"
                                onClick={() =>
                                  updowntime(
                                    "minus",
                                    "minutes",
                                    "pendingbytime",
                                  )
                                }
                              >
                                <img src={minus} />
                              </span>
                            </div>
                            <div class="incdicbutton">
                              <span
                                class="plus btn"
                                onClick={() =>
                                  updowntime("add", "secound", "pendingbytime")
                                }
                              >
                                <img src={add} />
                              </span>
                              <input
                                onChange={(e) =>
                                  pendingtimeset(
                                    pendingtime?.hours,
                                    pendingtime?.minutes,
                                    e.target.value,
                                  )
                                }
                                value={pendingtime?.secound}
                                type="text"
                                class="form-control"
                                placeholder="00"
                              />
                              <span
                                className={`minus btn ${
                                  pendingtime?.hours === "00" &&
                                  pendingtime?.minutes === "00" &&
                                  pendingtime?.secound === "05"
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (
                                    !(
                                      pendingtime?.hours === "00" &&
                                      pendingtime?.minutes === "00" &&
                                      pendingtime?.secound === "05"
                                    )
                                  ) {
                                    updowntime(
                                      "minus",
                                      "secound",
                                      "pendingbytime",
                                    );
                                  }
                                }}
                                style={{
                                  opacity:
                                    pendingtime?.hours === "00" &&
                                    pendingtime?.minutes === "00" &&
                                    pendingtime?.secound === "05"
                                      ? 0.5
                                      : 1,
                                }}
                              >
                                <img src={minus} />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="form-group mb-3">
                          <label>{t("Amount")} </label>
                          <div class="input-group mb-3">
                            <input
                              onChange={(e) => {
                                const value = e.target.value;
                                if (
                                  value === "" ||
                                  (/^\d+$/.test(value) &&
                                    parseInt(value) <= 20000) ||
                                  parseInt(value) <= parseFloat(walletdata)
                                ) {
                                  buythetime("amount", value || 1);
                                } else if (parseInt(value) > 20000) {
                                  buythetime("amount", 20000);
                                } else if (
                                  parseInt(value) > parseFloat(walletdata)
                                ) {
                                  buythetime("amount", walletdata);
                                }
                              }}
                              value={pendingbytime?.amount || 1}
                              type="text"
                              className="form-control"
                              aria-label="Amount (to the nearest dollar)"
                            />
                            <span class="input-group-text">$</span>
                          </div>
                        </div>

                        <div class="buysellBtn">
                          <button
                            type="button"
                            class="btn bg_btn buyBtn"
                            // onClick={() => pendingtradsbytime("buy")}
                          >
                            <img src={buyicon} alt="Buy" /> {t("Buy")}
                          </button>
                          <button
                            type="button"
                            class="btn bg_btn sellBtn"
                            // onClick={() => pendingtradsbytime("Sell")}
                          >
                            <img src={sellicon} alt="Sell" /> {t("Sell")}
                          </button>
                        </div>
                        <p>
                          {t(
                            "Your should have enough balance at the time of making a trade. The actual payout rate at the moment of making a trade will be applied.",
                          )}
                        </p>
                      </form>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="bytheassetprice"
                      role="tabpanel"
                      aria-labelledby="bytheassetprice-tab"
                    >
                      <form action="#">
                        <p>{t("Make a trade at the specified asset price")}</p>
                        <div class="form-group mb-3">
                          <label>{t("Asset")}</label>
                          <Dropdown>
                            <Dropdown.Toggle
                              className="form-select form-control"
                              id="dropdown-select-price"
                            >
                              {pendingbyprice?.asset ||
                                `${chnagetype?.sortname}/${chnagetype?.csymbol}` ||
                                "Crypto Currency"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              style={{ maxHeight: "300px", overflowY: "auto" }}
                            >
                              <Dropdown.Header style={{ textAlign: "center" }}>
                                {t("Crypto Currency")}
                              </Dropdown.Header>
                              {cryptocurrencieslist?.map((result, key) => (
                                <Dropdown.Item
                                  key={`crypto-price-${key}`}
                                  onClick={() => {
                                    buytheprice("asset", result);
                                  }}
                                >
                                  {result?.sortname}/{result?.csymbol}
                                </Dropdown.Item>
                              ))}
                              <Dropdown.Header style={{ textAlign: "center" }}>
                                {t("Currency")}
                              </Dropdown.Header>
                              {currencieslist?.map((result, key) => (
                                <Dropdown.Item
                                  key={`currency-price-${key}`}
                                  onClick={() => {
                                    buytheprice("asset", result);
                                  }}
                                >
                                  {result?.sortname}/{result?.csymbol}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div class="form-group mb-3">
                          <label>{t("Open price")}</label>
                          <input
                            onChange={(e) =>
                              buytheprice("openprice", e.target.value)
                            }
                            value={pendingbyprice?.openprice}
                            type="number"
                            class="form-control"
                            name="openprice"
                            placeholder="0"
                          />
                        </div>
                        <div class="form-group mb-3">
                          <label>
                            {t("Payout")}{" "}
                            <span
                              class="tooltip01"
                              data-bs-toggle="tooltip"
                              data-bs-placement="left"
                              title="Lorem ipsum dolor sit amet,"
                            >
                              ?
                            </span>
                          </label>
                          {/* <div class="input-group mb-3">
                          <span class="input-group-text">{t("From")}</span>
                          <input
                            onChange={(e) => {
                              const value = e.target.value;
                              if (
                                value === "" ||
                                (/^\d+$/.test(value) && parseInt(value) <= 98)
                              ) {
                                buytheprice("payout", value || 92);
                              } else if (parseInt(value) > 98) {
                                buytheprice("payout", 98);
                              }
                            }}
                            value={pendingbyprice?.payout || 92}
                            type="text"
                            className="form-control"
                            aria-label="Amount (to the nearest dollar)"
                          />
                          <input
                            onChange={(e) =>
                              buytheprice("payout", e.target.value)
                            }
                            value={pendingbyprice?.payout}
                            type="text"
                            class="form-control"
                            aria-label="Amount (to the nearest dollar)"
                          />
                          <span class="input-group-text">%</span>
                        </div> */}
                        </div>
                        <div class="form-group mb-3">
                          <label>{t("Timeframe")}</label>
                          <div class="input-group timeframeInput">
                            <div class="incdicbutton">
                              <span
                                class="plus btn"
                                onClick={() =>
                                  updowntime(
                                    "add",
                                    "hours",
                                    "pendingbytimeprice",
                                  )
                                }
                              >
                                <img src={add} />
                              </span>
                              <input
                                onChange={(e) =>
                                  pendingtimeprice(
                                    e.target.value,
                                    pendingpricetime?.minutes,
                                    pendingpricetime?.secound,
                                  )
                                }
                                value={pendingpricetime?.hours}
                                type="text"
                                class="form-control"
                                placeholder="00"
                              />
                              <span
                                class="minus btn"
                                onClick={() =>
                                  updowntime(
                                    "minus",
                                    "hours",
                                    "pendingbytimeprice",
                                  )
                                }
                              >
                                <img src={minus} />
                              </span>
                            </div>
                            <div class="incdicbutton">
                              <span
                                class="plus btn"
                                onClick={() =>
                                  updowntime(
                                    "add",
                                    "minutes",
                                    "pendingbytimeprice",
                                  )
                                }
                              >
                                <img src={add} />
                              </span>
                              <input
                                onChange={(e) =>
                                  pendingtimeprice(
                                    pendingpricetime?.hours,
                                    e.target.value,
                                    pendingpricetime?.secound,
                                  )
                                }
                                value={pendingpricetime?.minutes}
                                type="text"
                                class="form-control"
                                placeholder="00"
                              />
                              <span
                                class="minus btn"
                                onClick={() =>
                                  updowntime(
                                    "minus",
                                    "minutes",
                                    "pendingbytimeprice",
                                  )
                                }
                              >
                                <img src={minus} />
                              </span>
                            </div>
                            <div
                              class="incdicbutton"
                              onClick={() =>
                                updowntime(
                                  "add",
                                  "secound",
                                  "pendingbytimeprice",
                                )
                              }
                            >
                              <span class="plus btn">
                                <img src={add} />
                              </span>
                              <input
                                onChange={(e) =>
                                  pendingtimeprice(
                                    pendingpricetime?.hours,
                                    pendingpricetime?.minutes,
                                    e.target.value,
                                  )
                                }
                                value={pendingpricetime?.secound}
                                type="text"
                                class="form-control"
                                placeholder="00"
                              />
                              <span
                                className={`minus btn ${
                                  pendingpricetime?.hours === "00" &&
                                  pendingpricetime?.minutes === "00" &&
                                  pendingpricetime?.secound === "05"
                                    ? "disabled"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (
                                    !(
                                      pendingpricetime?.hours === "00" &&
                                      pendingpricetime?.minutes === "00" &&
                                      pendingpricetime?.secound === "05"
                                    )
                                  ) {
                                    updowntime(
                                      "minus",
                                      "secound",
                                      "pendingbytime",
                                    );
                                  }
                                }}
                                style={{
                                  opacity:
                                    pendingtime?.hours === "00" &&
                                    pendingtime?.minutes === "00" &&
                                    pendingtime?.secound === "05"
                                      ? 0.5
                                      : 1,
                                }}
                              >
                                <img src={minus} />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="form-group mb-3">
                          <label>{t("Amount")} </label>
                          <div class="input-group mb-3">
                            <input
                              onChange={(e) => {
                                const value = e.target.value;
                                if (
                                  value === "" ||
                                  (/^\d+$/.test(value) &&
                                    parseInt(value) <= 20000) ||
                                  parseInt(value) <= parseFloat(walletdata)
                                ) {
                                  buytheprice("amount", value || 1);
                                } else if (parseInt(value) > 20000) {
                                  buytheprice("amount", 20000);
                                } else if (
                                  parseInt(value) > parseFloat(walletdata)
                                ) {
                                  buytheprice("amount", walletdata);
                                }
                              }}
                              value={pendingbyprice?.amount || 1}
                              type="text"
                              className="form-control"
                              aria-label="Amount (to the nearest dollar)"
                            />
                            {/* <input
                            onChange={(e) =>
                              buytheprice("amount", e.target.value)
                            }
                            value={pendingbyprice?.amount}
                            type="number"
                            class="form-control"
                            aria-label="Amount (to the nearest dollar)"
                          /> */}
                            <span class="input-group-text">$</span>
                          </div>
                        </div>

                        <div class="buysellBtn">
                          <button
                            type="button"
                            class="btn bg_btn buyBtn"
                            // onClick={() => pendingtradsbyprice("buy")}
                          >
                            <img src={buyicon} alt="Buy" /> {t("Buy")}
                          </button>
                          <button
                            type="button"
                            class="btn bg_btn sellBtn"
                            // onClick={() => pendingtradsbyprice("Sell")}
                          >
                            <img src={sellicon} alt="Sell" /> {t("Sell")}
                          </button>
                        </div>
                        <p>
                          {t(
                            "Your should have enough balance at the time of making a trade. The actual payout rate at the moment of making a trade will be applied.",
                          )}
                        </p>
                      </form>
                    </div>
                    {/* <div
                    class="tab-pane fade"
                    id="current"
                    role="tabpanel"
                    aria-labelledby="current-tab"
                  > */}

                    <div
                      className="tab-pane fade"
                      id="current"
                      role="tabpanel"
                      aria-labelledby="closed-tab"
                    >
                      <div
                        className="trades-list_group accordion"
                        id="closedaccordionExample"
                      >
                        {pendingtrade?.length || pricetradelist?.length ? (
                          <>
                            {pendingtrade.map((result, key) => {
                              const split = splitString(result?.asset);
                              const { startTime, closeTime, duration } =
                                getStartAndCloseTime(
                                  result?.trade_timestamp,
                                  result?.duration,
                                );

                              return (
                                <div className="trades-list_item">
                                  <div
                                    className="trades-list_item-short"
                                    data-bs-toggle="collapse"
                                    // data-bs-target="#closedtradesList_group1"
                                    aria-expanded="true"
                                    aria-controls={`pendingtradesList_group${key}`}
                                    onClick={() =>
                                      handleToggleCollapse(
                                        `pendingtradesList_group${key}`,
                                        "",
                                        false,
                                        null,
                                        true,
                                      )
                                    }
                                  >
                                    <div className="item-row">
                                      <div className="trades_rgltcrncy">
                                        <span className="favorites">
                                          <Link
                                            to=""
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="fa-regular fa-star"></i>
                                          </Link>
                                        </span>
                                        <Link
                                          to=""
                                          style={{ color: "#ccc" }}
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          {result?.asset}
                                        </Link>{" "}
                                        <span className="price-up">
                                          +{result?.payout}%
                                        </span>
                                      </div>
                                      <div
                                        onClick={() =>
                                          deletependingtrade(result?.id, "time")
                                        }
                                      >
                                        <i
                                          class="fa-solid fa-trash"
                                          style={{ color: "red" }}
                                        ></i>
                                      </div>
                                    </div>
                                    <div className="item-row">
                                      <div className="leftuparrow">
                                        {result?.type === "buy" ? (
                                          <img src={up} alt="" />
                                        ) : (
                                          <img src={Down} alt="" />
                                        )}
                                        ${result?.amount ? result?.amount : 0}
                                      </div>
                                      <div className="centered price-up">
                                        {result?.payout}%
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    id={`pendingtradesList_group${key}`}
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body trade-result-body">
                                      <div className="trades-list_item">
                                        <div className="trades-list_item-short">
                                          <div className="item-row">
                                            <div>
                                              {t("Trade Time")}:
                                              <br />
                                              {
                                                convertLocalToUTCFormatted(
                                                  result?.trade_timestamp,
                                                  updatetimezone,
                                                )?.all
                                              }
                                            </div>
                                            <div className="centered">
                                              {duration}
                                            </div>
                                            {/*  <div className="text-end">
                    Closing time
                    <br />
                    {closeTime}
                  </div> */}
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div className="timeprogress">
                                          <div className="progress">
                                            <div
                                              className="progress-bar progress-bar-striped progress-bar-animated"
                                              role="progressbar"
                                              style={{
                                                width: `${result?.progress}%`,
                                              }}
                                              aria-valuenow={result?.progress}
                                              // style={{ width: "10%" }}
                                              // aria-valuenow={50}
                                              aria-valuemin={0}
                                              aria-valuemax={100}
                                            ></div>
                                          </div>
                                          <p>
                                            {t("Time left")}: {result?.timeleft}
                                          </p>
                                        </div>
                                        <div className="trades-listbox">
                                          <div className="payout-profit">
                                            {/* <div>
                    Forecast{" "}
                    {result?.type === "buy" ? (
                      <span className="price-up">
                        Buy
                      </span>
                    ) : (
                      <span className="price-down">
                        Sell
                      </span>
                    )}
                  </div> */}
                                            {/* <div>
                    Payout:{" "}
                    {result?.type === "buy" ? (
                      parseFloat(lastCandle?.close) >
                      parseFloat(
                        result?.entry_price
                      ) ? (
                        <span className="price-up">
                          $
                          {parseFloat(result?.amount) +
                            parseFloat(
                              result?.profit_loss
                            )}
                        </span>
                      ) : (
                        <span>$0</span>
                      )
                    ) : parseFloat(lastCandle?.close) <
                      parseFloat(
                        result?.entry_price
                      ) ? (
                      <span className="price-up">
                        $
                        {parseFloat(result?.amount) +
                          parseFloat(
                            result?.profit_loss
                          )}
                      </span>
                    ) : (
                      <span>$0</span>
                    )}
                  </div> */}
                                            {/* <div className="profit-tooltip">
                    Profit:{" "}
                    {result?.type === "buy" ? (
                      parseFloat(lastCandle?.close) >
                      parseFloat(
                        result?.entry_price
                      ) ? (
                        <span className="price-up">
                          ${result?.profit_loss}
                        </span>
                      ) : (
                        <span>$0</span>
                      )
                    ) : parseFloat(lastCandle?.close) <
                      parseFloat(
                        result?.entry_price
                      ) ? (
                      <span className="price-up">
                        ${result?.profit_loss}
                      </span>
                    ) : (
                      <span>$0</span>
                    )}
                    <span
                      className="tooltip01"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-original-title="Lorem ipsum dolor sit amet, consectetur adipisicing elit,"
                    >
                      ?
                    </span>
                  </div> */}
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="trades-list_item">
              <div className="trades-list_item-short">
                <p
                  style={{
                    fontSize: "12px",
                    margin: "0",
                  }}
                >
                  Order:
                  {result?.id}
                </p>
                <div className="item-row">
                  <div>
                    Open price:
                    <br />
                    {result?.entry_price}
                  </div>
                  <div className="centered">
                    Closing price:
                    <br />
                    {parseFloat(
                      lastCandle?.close
                    ).toFixed(2)}
                  </div>
                  <div className="text-end">
                    Difference
                    <br />(
                    <span className="price-up">
                      {parseFloat(
                        lastCandle?.close -
                          parseFloat(
                            result?.entry_price
                          ).toFixed(2)
                      ).toFixed(2)}
                    </span>{" "}
                    Points)
                  </div>
                </div>
              </div>
            </div> */}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {pricetradelist.map((result, key) => {
                              const split = splitString(result?.asset);
                              const { startTime, closeTime, duration } =
                                getStartAndCloseTime(
                                  result?.trade_timestamp,
                                  result?.duration,
                                );

                              return (
                                <div className="trades-list_item">
                                  <div
                                    className="trades-list_item-short"
                                    data-bs-toggle="collapse"
                                    // data-bs-target="#closedtradesList_group1"
                                    aria-expanded="true"
                                    aria-controls={`pendingtradespriceList_group${key}`}
                                    onClick={() =>
                                      handleToggleCollapse(
                                        `pendingtradespriceList_group${key}`,
                                        "",
                                        false,
                                        null,
                                        true,
                                      )
                                    }
                                  >
                                    <div className="item-row">
                                      <div className="trades_rgltcrncy">
                                        <span className="favorites">
                                          <Link
                                            to=""
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <i className="fa-regular fa-star"></i>
                                          </Link>
                                        </span>
                                        <Link
                                          to=""
                                          onClick={(e) => e.preventDefault()}
                                          style={{ color: "#ccc" }}
                                        >
                                          {result?.asset}
                                        </Link>{" "}
                                        <span className="price-up">+92%</span>
                                      </div>
                                      <div
                                        onClick={() =>
                                          deletependingtrade(
                                            result?.id,
                                            "price",
                                          )
                                        }
                                      >
                                        <i
                                          class="fa-solid fa-trash"
                                          style={{ color: "red" }}
                                        ></i>
                                      </div>
                                    </div>
                                    <div className="item-row">
                                      <div className="leftuparrow">
                                        {result?.type === "buy" ? (
                                          <img src={up} alt="" />
                                        ) : (
                                          <img src={Down} alt="" />
                                        )}
                                        ${result?.amount ? result?.amount : 0}
                                      </div>
                                      <div className="centered price-up">
                                        {result?.payout}%
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    id={`pendingtradespriceList_group${key}`}
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="accordion-body trade-result-body">
                                      <div className="trades-list_item">
                                        <div className="trades-list_item-short">
                                          <div className="item-row">
                                            <div>
                                              {t("Trade price")}:
                                              <br />
                                              {result?.entry_price}
                                            </div>
                                            <div className="centered">
                                              {duration}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div></div>
                                      {/* <div className="trades-list_item">
              <div className="trades-list_item-short">
                <p
                  style={{
                    fontSize: "12px",
                    margin: "0",
                  }}
                >
                  Order:
                  {result?.id}
                </p>
                <div className="item-row">
                  <div>
                    Open price:
                    <br />
                    {result?.entry_price}
                  </div>
                  <div className="centered">
                    Closing price:
                    <br />
                    {parseFloat(
                      lastCandle?.close
                    ).toFixed(2)}
                  </div>
                  <div className="text-end">
                    Difference
                    <br />(
                    <span className="price-up">
                      {parseFloat(
                        lastCandle?.close -
                          parseFloat(
                            result?.entry_price
                          ).toFixed(2)
                      ).toFixed(2)}
                    </span>{" "}
                    Points)
                  </div>
                </div>
              </div>
            </div> */}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          <form action="#">
                            <p>{t("Make a trade at the specified time")}</p>
                            <div class="emptyinfo p-0">
                              <div
                                class="alert alert-primary d-flex align-items-center"
                                role="alert"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="24"
                                  height="24"
                                  fill="rgba(100,106,108,1)"
                                >
                                  <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"></path>
                                </svg>{" "}
                                <div>{t("There are no pending trades")}</div>
                              </div>
                            </div>
                          </form>
                        )}
                      </div>
                    </div>

                    {/* </div> */}
                  </div>
                </div>
              </div>
            )}

            {/* <!-- --------- Pending Trades End----------- --> */}
          </div>
          {/* <!-- --------- Right Sidebar Modal End----------- --> */}
        </div>
      </div>
      {/* right sidebar end */}

      {/* Join Us Modal start */}
      <div
        ref={(el) => (modalRefs.current["socialTradingview_popup"] = el)}
        className="modal fade"
        id="socialTradingview_popup"
        tabindex="-1"
        aria-labelledby="socialTradingLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div
                className={`d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 ${
                  !modelloading && "d-none"
                }`}
                style={{
                  zIndex: 1,
                  backgroundColor: "rgb(0 0 0)",
                  borderRadius: "20px",
                  height: "100%",
                }}
              >
                <svg
                  className="ajax-loader-v2__icon"
                  width="64"
                  height="64"
                  xmlns="http://www.w3.org/2000/svg"
                  shapeRendering="geometricPrecision"
                  textRendering="geometricPrecision"
                  viewBox="0 0 64 64"
                  style={{ whiteSpace: "pre" }}
                >
                  <style>
                    {`
        @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
        @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
        @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
        @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
        @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
        @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
        @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
      `}
                  </style>

                  <rect
                    width="2"
                    height="37"
                    fill="#fff"
                    opacity="0"
                    transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                    }}
                  />
                  <rect
                    width="10"
                    height="19.5"
                    fill="#fff"
                    rx="1"
                    opacity="0"
                    transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                    }}
                  />
                  <rect
                    width="2"
                    height="42"
                    fill="#fff"
                    opacity="0"
                    transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                    }}
                  />
                  <rect
                    width="10"
                    height="21"
                    fill="#fff"
                    rx="1"
                    opacity="0"
                    transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                    }}
                  />
                  <rect
                    width="2"
                    height="28"
                    fill="#fff"
                    opacity="0"
                    transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                    }}
                  />
                  <rect
                    width="10"
                    height="16"
                    fill="#fff"
                    rx="1"
                    opacity="0"
                    transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                    }}
                  />
                  <rect
                    width="2"
                    height="40"
                    fill="#fff"
                    opacity="0"
                    transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                    }}
                  />
                  <rect
                    width="10"
                    height="23"
                    fill="#fff"
                    rx="1"
                    opacity="0"
                    transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                    style={{
                      animation:
                        "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                    }}
                  />
                </svg>
              </div>
              <h5 className="modal-title mb-3 big-title">
                <span>{t("Real Trading profile ID")}:</span>#
                {userdata?.user_id ? userdata?.user_id : ""}{" "}
                <i
                  onClick={() => handleCopy(userdata?.user_id)}
                  style={{ cursor: "pointer" }}
                  class="fa-regular fa-copy"
                ></i>
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setCheckcopy(false);
                  handleSelect("today");
                }}
              ></button>
              <div className="socialTradingview-body">
                <div className="popup_profile_view">
                  <div className="profileTag">
                    <img
                      src={
                        userdata?.user_profile
                          ? process.env.REACT_APP_IMAGE_URL +
                            userdata?.user_profile
                          : user
                      }
                      className="profilepopPic"
                      alt=""
                    />
                    {userdata?.rank === 1 ? (
                      <img
                        src={rankingstaricon01}
                        className="profiltg"
                        alt=""
                      />
                    ) : userdata?.rank === 2 ? (
                      <img
                        src={rankingstaricon02}
                        className="profiltg"
                        alt=""
                      />
                    ) : userdata?.rank === 3 ? (
                      <img
                        src={rankingstaricon03}
                        className="profiltg"
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                    {userdata?.iscopied === 1 ? (
                      <div className="btnsGroupPop desktopForNone flex-column mt-2">
                        <button
                          type="button"
                          className={`btn btnBorder ${!socialtype ? "active" : ""}`}
                          onClick={() => {
                            setSelectedOption("today");
                            userdetailsfromid(
                              userdata?.user_id,
                              "",
                              "today",
                              true,
                            );
                          }}
                        >
                          <span>
                            <i className="fa-solid fa-chart-line"></i>
                            <label>{t("Trader")}</label>
                          </span>
                          <span class="toolTip01">Trader Statistics</span>
                        </button>

                        <button
                          type="button"
                          className={`btn btnBorder ${socialtype ? "active" : ""}`}
                          onClick={() => {
                            setSelectedOption("today");
                            userdetailsfromid(
                              userdata?.user_id,
                              "",
                              "today",
                              true,
                              "copy",
                            );
                          }}
                        >
                          <span>
                            <i className="fa-solid fa-user-group"></i>
                            <label>{t("Copy")}</label>
                          </span>
                          <span class="toolTip01">Copy Statistics</span>
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="w-100">
                    <div className="profile_dt01">
                      <div className="view_dt">
                        <label>
                          {t("Name")}
                          <span>{formatName(userdata?.user_name)}</span>
                        </label>
                      </div>
                      <div className="view_dt">
                        <label>
                          {t("Status")}
                          {userdata?.isOnline === "Online" ? (
                            <span>
                              {userdata?.isOnline}{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="12"
                                height="12"
                                fill="rgba(173,184,194,1)"
                              >
                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
                              </svg>
                            </span>
                          ) : (
                            <span>{t("Offline")} </span>
                          )}
                        </label>
                      </div>
                      <div className="view_dt">
                        <label>
                          {t("Followers")}
                          <span>
                            {userdata?.followers ? userdata?.followers : 0}
                          </span>
                        </label>
                      </div>
                      <div className="view_dt">
                        <label>
                          {t("Profile Level")}
                          <span>{userdata?.profile_level}</span>
                        </label>
                      </div>
                      <div className="view_dt">
                        <label>
                          {t("Account Level")}
                          <span>{userdata?.account_level}</span>
                        </label>
                      </div>
                      <div className="view_dt">
                        <label>
                          {t("Watchers")}
                          <span>{userdata?.watchers}</span>
                        </label>
                      </div>
                    </div>
                    {/* {!checkliveaccount ? ( */}
                    {Number(livewalletdata) <= 0 ? (
                      <div className="alertBox">
                        <div className="alert alert-exclamation">
                          <i className="fa-solid fa-circle-exclamation"></i>
                          <p>
                            <Link
                              onClick={() => {
                                const modal =
                                  document.querySelector(".modal.show");
                                if (modal) {
                                  const modalInstance =
                                    window.bootstrap.Modal.getInstance(modal);
                                  modalInstance?.hide();
                                }
                              }}
                              className="link"
                              to={`${base_url}userdashboarddeposit`}
                              state={{ from: "deposit" }}
                            >
                              Add money
                            </Link>{" "}
                            to your account in order to copy trades.
                          </p>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {showcopydeleteicon ? (
                      <div className="btnsGroupPop nowrap align-items-center mb-2">
                        <button type="button" className="btn btndotBorder">
                          You've previously copied this trader
                        </button>

                        <i
                          onClick={() => deletecopyhistory(userdata?.user_id)}
                          style={{ cursor: "pointer" }}
                          className="text-white fa-solid fa-trash-can"
                        ></i>
                      </div>
                    ) : (
                      userdata?.cancopy === 1 &&
                      userdata?.single_copy === 1 &&
                      parseInt(userdata?.user_id) !==
                        parseInt(userDetails?.id) && (
                        <>
                          {checkcopytrade ? (
                            <>
                              <div className="btnsGroupPop nowrap align-items-center mb-2">
                                <button
                                  type="button"
                                  className="btn btndotBorder"
                                >
                                  You are copying this trader
                                </button>
                                <svg
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    getcopyhistory(userdata?.user_id);
                                    setShowCopyhistory(!showcopyhistory);
                                    setCheckcopy(false);
                                  }}
                                  className="text-white"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 323 347"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M216 0C238.091 0 256 17.9086 256 40V200.44C253.373 200.15 250.704 200 248 200C208.235 200 176 232.235 176 272C176 290.441 182.934 307.262 194.335 320H40C17.9086 320 0 302.091 0 280V40C0 17.9086 17.9086 0 40 0H216ZM68 149C61.3726 149 56 154.373 56 161C56 167.627 61.3726 173 68 173H188C194.627 173 200 167.627 200 161C200 154.373 194.627 149 188 149H68ZM68 93C61.3726 93 56 98.3726 56 105C56 111.627 61.3726 117 68 117H188C194.627 117 200 111.627 200 105C200 98.3726 194.627 93 188 93H68ZM68 37C61.3726 37 56 42.3726 56 49C56 55.6274 61.3726 61 68 61H188C194.627 61 200 55.6274 200 49C200 42.3726 194.627 37 188 37H68Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M254.579 243.188V267.495L274.734 279.587C275.549 280.056 276.262 280.682 276.832 281.43C277.402 282.178 277.818 283.032 278.054 283.942C278.291 284.852 278.344 285.8 278.21 286.73C278.076 287.661 277.758 288.556 277.274 289.362C276.791 290.169 276.152 290.871 275.394 291.427C274.636 291.984 273.775 292.384 272.861 292.604C271.946 292.824 270.998 292.86 270.069 292.709C269.141 292.558 268.253 292.224 267.455 291.726L243.861 277.57C242.813 276.941 241.945 276.052 241.342 274.988C240.74 273.924 240.423 272.723 240.422 271.5V243.188C240.422 241.311 241.168 239.51 242.496 238.183C243.823 236.855 245.623 236.11 247.501 236.11C249.378 236.11 251.178 236.855 252.506 238.183C253.833 239.51 254.579 241.311 254.579 243.188ZM304.126 226.672C302.248 226.672 300.448 227.418 299.121 228.745C297.793 230.073 297.047 231.873 297.047 233.75V238.097C294.564 235.343 291.987 232.606 289.208 229.792C281.01 221.595 270.578 215.996 259.216 213.693C247.854 211.391 236.065 212.488 225.322 216.848C214.58 221.207 205.36 228.636 198.816 238.205C192.271 247.774 188.691 259.06 188.524 270.652C188.357 282.244 191.609 293.628 197.875 303.382C204.141 313.136 213.142 320.828 223.754 325.495C234.367 330.163 246.119 331.6 257.543 329.626C268.967 327.653 279.556 322.357 287.987 314.4C289.353 313.111 290.151 311.332 290.205 309.455C290.259 307.577 289.565 305.756 288.276 304.39C286.987 303.024 285.209 302.227 283.331 302.172C281.454 302.118 279.632 302.812 278.267 304.101C271.86 310.147 263.814 314.172 255.133 315.672C246.453 317.172 237.523 316.082 229.458 312.536C221.394 308.991 214.553 303.149 209.789 295.738C205.026 288.328 202.552 279.678 202.675 270.87C202.799 262.062 205.515 253.485 210.484 246.211C215.454 238.937 222.456 233.289 230.617 229.971C238.777 226.654 247.735 225.814 256.37 227.557C265.005 229.3 272.935 233.549 279.169 239.773C282.661 243.306 285.84 246.727 288.925 250.266H280.532C278.655 250.266 276.854 251.012 275.527 252.339C274.199 253.666 273.454 255.467 273.454 257.344C273.454 259.221 274.199 261.022 275.527 262.349C276.854 263.676 278.655 264.422 280.532 264.422H304.126C306.003 264.422 307.803 263.676 309.131 262.349C310.458 261.022 311.204 259.221 311.204 257.344V233.75C311.204 231.873 310.458 230.073 309.131 228.745C307.803 227.418 306.003 226.672 304.126 226.672Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      )
                    )}

                    <div className="btnsGroupPop align-items-center">
                      {userdata?.watchblocked !== 1 && (
                        <>
                          {watchusersref.current.includes(
                            parseInt(userdata?.user_id),
                          ) ? (
                            <button
                              type="button"
                              className="btn btnBorder"
                              onClick={() => deletewatchlist(userdata?.user_id)}
                            >
                              <span>{t("Stop Watching")}</span>
                            </button>
                          ) : (
                            <>
                              {userdata?.socialTradingSettings
                                ?.hideWatchingTrading ? (
                                !userdata?.is_deleted ? (
                                  <button
                                    type="button"
                                    className="btn btnBorder"
                                    onClick={() =>
                                      watchsocialtrade(userdata?.user_id)
                                    }
                                  >
                                    <span>{t("Watch")}</span>
                                  </button>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      )}

                      {userdata?.cancopy === 1 &&
                        userdata?.single_copy === 1 &&
                        parseInt(userdata?.user_id) !==
                          parseInt(userDetails?.id) && (
                          <>
                            {checkcopytrade ? (
                              <>
                                <button
                                  type="button"
                                  className="btn btnBorder"
                                  onClick={() =>
                                    stopcopytrade(copysetting?.copy_user_id)
                                  }
                                >
                                  <span>{t("Stop Copying")}</span>
                                </button>
                                <i
                                  onClick={() => setCheckcopy(!checkcopy)}
                                  className="fa-solid fa-gear text-white pointercursor"
                                ></i>
                              </>
                            ) : (
                              <>
                                {userdata?.socialTradingSettings
                                  ?.hideCopyingStatistics ? (
                                  !userdata?.is_deleted ? (
                                    <button
                                      type="button"
                                      className={`btn btnBorder ${
                                        checkcopy ? "active" : ""
                                      }`}
                                      onClick={() => setCheckcopy(!checkcopy)}
                                    >
                                      <span>{t("Copy")}</span>
                                    </button>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        )}
                      {/* {showcopydeleteicon ?  <i onClick={()=>deletecopyhistory(userdata?.user_id)} style={{cursor:"pointer"}} className="text-white fa-solid fa-trash-can"></i> :""} */}
                    </div>
                  </div>
                </div>
                {userdata?.iscopied === 1 ? (
                  <div className="btnsGroupPop align-items-center mobileForNone">
                    <button
                      type="button"
                      className={`btn btnBorder ${!socialtype ? "active" : ""}`}
                      onClick={() => {
                        setSelectedOption("today");
                        userdetailsfromid(userdata?.user_id, "", "today", true);
                      }}
                    >
                      <span>
                        <i className="fa-solid fa-chart-line"></i> Trader
                        Statistics
                      </span>
                    </button>

                    <button
                      type="button"
                      className={`btn btnBorder ${socialtype ? "active" : ""}`}
                      onClick={() => {
                        setSelectedOption("today");
                        userdetailsfromid(
                          userdata?.user_id,
                          "",
                          "today",
                          true,
                          "copy",
                        );
                      }}
                    >
                      <span>
                        <i className="fa-solid fa-user-group"></i> Copy
                        Statistics
                      </span>
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {!checkcopy ? (
                  <div className="trading_profileViewHor">
                    {userdata?.is_deleted ? (
                      <div class="row">
                        <div class="col-6">
                          <div class="popcard0">
                            <i class="fa-solid fa-xmark"></i>
                            <br />
                            The trader has disabled viewing profile statistics
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="popcard0">
                            <i class="fa-solid fa-xmark"></i>
                            <br />
                            The trader has disabled copying trades
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {userdata?.blocked ||
                    socialTradingSettings?.hideCopyingStatistic ||
                    userdata?.watchblocked ||
                    !userdata?.socialTradingSettings?.hideCopyingStatistics ? (
                      !userdata?.is_deleted ? (
                        <div class="row">
                          {!userdata?.socialTradingSettings
                            ?.hideWatchingTrading ? (
                            <div class="col-6">
                              <div class="popcard0">
                                <i class="fa-solid fa-xmark"></i>
                                <br />
                                The trader has disabled watching and copying of
                                trades
                              </div>
                            </div>
                          ) : (
                            <>
                              {userdata?.blocked ? (
                                <div class="col-6">
                                  <div class="popcard0">
                                    <i class="fa-solid fa-xmark"></i>
                                    <br />
                                    The trader has disabled copying trades
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                              {userdata?.watchblocked ||
                              !userdata?.socialTradingSettings
                                ?.hideWatchingTrading ? (
                                <div class="col-6">
                                  <div class="popcard0">
                                    <i class="fa-solid fa-xmark"></i>
                                    <br />
                                    The trader has disabled watching trades
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          )}

                          {!socialTradingSettings?.hideCopyingStatistics ||
                          !userdata?.socialTradingSettings
                            ?.hideCopyingStatistics ? (
                            <div class="col-6">
                              <div class="popcard0">
                                <i class="fa-solid fa-vr-cardboard"></i>
                                <br />
                                The trader has disabled viewing profile
                                statistics
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {!userdata?.blocked && !userdata?.watchblocked ? (
                      userdata?.socialTradingSettings?.hideCopyingStatistics ? (
                        !userdata?.is_deleted ? (
                          <>
                            {showcopyhistory ? (
                              <>
                                <div className="userCopyHistory_arrow">
                                  <i
                                    className="fa-solid fa-chevron-left"
                                    onClick={handlePrev}
                                    style={{
                                      cursor:
                                        currentIndex === 0
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity: currentIndex === 0 ? 0.5 : 1,
                                    }}
                                  />

                                  <span>
                                    #{currentIndex + 1} / {history.length}
                                  </span>

                                  <i
                                    className="fa-solid fa-chevron-right"
                                    onClick={handleNext}
                                    style={{
                                      cursor:
                                        currentIndex === history.length - 1
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        currentIndex === history.length - 1
                                          ? 0.5
                                          : 1,
                                    }}
                                  />
                                </div>

                                {currentHistory && (
                                  <ul className="trade-data">
                                    <li>
                                      Copying started
                                      <span>
                                        {
                                          convertLocalToUTCFormatted(
                                            currentHistory?.start_date,
                                            updatetimezone,
                                          )?.datetime
                                        }
                                      </span>
                                    </li>

                                    <li>
                                      Copying stopped
                                      {currentHistory.end_date ? (
                                        <span>
                                          {currentHistory.end_date
                                            ? convertLocalToUTCFormatted(
                                                currentHistory?.end_date,
                                                updatetimezone,
                                              )?.datetime
                                            : "Active"}
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          Active
                                        </span>
                                      )}
                                    </li>

                                    <li>
                                      Copy in proportion
                                      <span>
                                        {currentHistory.setting.proportion}%
                                      </span>
                                    </li>

                                    <li>
                                      Stop balance
                                      <span>
                                        ${currentHistory.setting.stop_balance}
                                      </span>
                                    </li>

                                    <li>
                                      Min. copy trade amount
                                      <span>
                                        $
                                        {
                                          currentHistory.setting
                                            .min_trade_amount
                                        }
                                      </span>
                                    </li>

                                    <li>
                                      Max. copy trade amount
                                      <span>
                                        {currentHistory?.setting?.max_amount ===
                                          "0" ||
                                        currentHistory?.setting?.max_amount ===
                                          null
                                          ? "Unlimited"
                                          : `$${currentHistory?.setting?.max_amount}`}
                                      </span>
                                    </li>
                                  </ul>
                                )}
                              </>
                            ) : (
                              <>
                                <div className="d-flex gap-lg-3 gap-2 mb-3 align-items-center justify-content-between flex-wrap">
                                  <div
                                    className="dropdown realTrading_dt mb-0"
                                    ref={dropdownRef}
                                  >
                                    <button
                                      className="btn dropdown-toggle"
                                      type="button"
                                      id="dropdownMenuButton1"
                                      data-bs-toggle="dropdown"
                                      aria-expanded={isOpen}
                                      onClick={() => setIsOpen(!isOpen)}
                                    >
                                      <span>
                                        <i className="fa-solid fa-calendar-days"></i>{" "}
                                        {getLabel(selectedOption)}
                                      </span>
                                      <i className="fa-solid fa-angle-down"></i>
                                    </button>
                                    <ul
                                      className={`${
                                        isOpen
                                          ? "dropdown-menu show"
                                          : "dropdown-menu"
                                      }`}
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="realTradingDefault1"
                                            checked={selectedOption === "today"}
                                            onClick={() =>
                                              handleSelect("today")
                                            } // 👈 use onClick instead
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="realTradingDefault1"
                                          >
                                            {t("Today")}
                                          </label>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="realTradingDefault2"
                                            checked={
                                              selectedOption === "yesterday"
                                            }
                                            onClick={() =>
                                              handleSelect("yesterday")
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="realTradingDefault2"
                                          >
                                            {t("Yesterday")}
                                          </label>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="realTradingDefault6"
                                            checked={
                                              selectedOption === "this_week"
                                            }
                                            onClick={() =>
                                              handleSelect("this_week")
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="realTradingDefault6"
                                          >
                                            {t("This Week")}
                                          </label>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="realTradingDefault3"
                                            checked={
                                              selectedOption === "last_week"
                                            }
                                            onClick={() =>
                                              handleSelect("last_week")
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="realTradingDefault3"
                                          >
                                            {t("Last Week")}
                                          </label>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="realTradingDefault4"
                                            checked={
                                              selectedOption === "this_month"
                                            }
                                            onClick={() =>
                                              handleSelect("this_month")
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="realTradingDefault4"
                                          >
                                            {t("This Month")}
                                          </label>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="realTradingDefault5"
                                            checked={
                                              selectedOption === "last_month"
                                            }
                                            onClick={() =>
                                              handleSelect("last_month")
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="realTradingDefault5"
                                          >
                                            {t("Last Month")}
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                  {userdata?.iscopied === 1 && socialtype ? (
                                    userdata?.copy_updated_at ? (
                                      <div className="text-white">
                                        <small>
                                          <strong style={{ opacity: "0.4" }}>
                                            Copying started:
                                          </strong>{" "}
                                          {
                                            convertLocalToUTCFormatted(
                                              userdata?.copy_updated_at,
                                              updatetimezone,
                                            )?.datetime
                                          }
                                        </small>
                                      </div>
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  )}
                                </div>

                                <div className="tab-content" id="myTabContent">
                                  <div
                                    className="tab-pane fade show active"
                                    id="today"
                                    role="tabpanel"
                                    aria-labelledby="today-tab"
                                  >
                                    <ul className="trade-data">
                                      <li>
                                        {t("Trades")}{" "}
                                        <span>{userfilter?.trades_count}</span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}{" "}
                                        <span>
                                          {userfilter?.profitable_trades}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}
                                        {"(%) "}
                                        <span>
                                          {userfilter?.profitable_trades_percentage >
                                          0
                                            ? `${userfilter?.profitable_trades_percentage}%`
                                            : "0"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Turnover")}{" "}
                                        <span>
                                          $
                                          {userfilter?.net_turnover
                                            ? userfilter?.net_turnover
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.trades_profit
                                            ? userfilter?.trades_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_trade_amount
                                            ? userfilter?.max_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Min Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.min_trade_amount
                                            ? userfilter?.min_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_profit
                                            ? userfilter?.max_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      {/* <li></li> */}
                                    </ul>
                                  </div>
                                  <div
                                    className="tab-pane fade"
                                    id="yesterday"
                                    role="tabpanel"
                                    aria-labelledby="yesterday-tab"
                                  >
                                    <ul className="trade-data">
                                      <li>
                                        {t("Trades")}{" "}
                                        <span>{userfilter?.trades_count}</span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}{" "}
                                        <span>
                                          {userfilter?.profitable_trades}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}
                                        {" (%) "}
                                        <span>
                                          {userfilter?.profitable_trades_percentage >
                                          0
                                            ? `${userfilter?.profitable_trades_percentage}%`
                                            : "0"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Turnover")}{" "}
                                        <span>
                                          $
                                          {userfilter?.net_turnover
                                            ? userfilter?.net_turnover
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.trades_profit
                                            ? userfilter?.trades_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_trade_amount
                                            ? userfilter?.max_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Min Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.min_trade_amount
                                            ? userfilter?.min_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_profit
                                            ? userfilter?.max_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      {/* <li></li> */}
                                    </ul>
                                  </div>
                                  <div
                                    className="tab-pane fade"
                                    id="lastWeek"
                                    role="tabpanel"
                                    aria-labelledby="lastWeek-tab"
                                  >
                                    <ul className="trade-data">
                                      <li>
                                        {t("Trades")}{" "}
                                        <span>{userfilter?.trades_count}</span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}{" "}
                                        <span>
                                          {userfilter?.profitable_trades}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}
                                        {" (%) "}
                                        <span>
                                          {userfilter?.profitable_trades_percentage >
                                          0
                                            ? `${userfilter?.profitable_trades_percentage}%`
                                            : "0"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Turnover")}{" "}
                                        <span>
                                          $
                                          {userfilter?.net_turnover
                                            ? userfilter?.net_turnover
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.trades_profit
                                            ? userfilter?.trades_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_trade_amount
                                            ? userfilter?.max_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Min Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.min_trade_amount
                                            ? userfilter?.min_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_profit
                                            ? userfilter?.max_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      {/* <li></li> */}
                                    </ul>
                                  </div>
                                  <div
                                    className="tab-pane fade"
                                    id="thismonth"
                                    role="tabpanel"
                                    aria-labelledby="thismonth-tab"
                                  >
                                    <ul className="trade-data">
                                      <li>
                                        {t("Trades")}{" "}
                                        <span>{userfilter?.trades_count}</span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}{" "}
                                        <span>
                                          {userfilter?.profitable_trades}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}
                                        {" (%) "}
                                        <span>
                                          {userfilter?.profitable_trades_percentage >
                                          0
                                            ? `${userfilter?.profitable_trades_percentage}%`
                                            : "0"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Turnover")}{" "}
                                        <span>
                                          $
                                          {userfilter?.net_turnover
                                            ? userfilter?.net_turnover
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.trades_profit
                                            ? userfilter?.trades_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_trade_amount
                                            ? userfilter?.max_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Min Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.min_trade_amount
                                            ? userfilter?.min_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_profit
                                            ? userfilter?.max_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      {/* <li></li> */}
                                    </ul>
                                  </div>
                                  <div
                                    className="tab-pane fade"
                                    id="lastMonth"
                                    role="tabpanel"
                                    aria-labelledby="lastMonth-tab"
                                  >
                                    <ul className="trade-data">
                                      <li>
                                        {t("Trades")}{" "}
                                        <span>{userfilter?.trades_count}</span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}{" "}
                                        <span>
                                          {userfilter?.profitable_trades}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Profitable Trades")}
                                        {"(%)  "}
                                        <span>
                                          {userfilter?.profitable_trades_percentage >
                                          0
                                            ? `${userfilter?.profitable_trades_percentage}%`
                                            : "0"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Turnover")}{" "}
                                        <span>
                                          $
                                          {userfilter?.net_turnover
                                            ? userfilter?.net_turnover
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Trading Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.trades_profit
                                            ? userfilter?.trades_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_trade_amount
                                            ? userfilter?.max_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Min Trade")}{" "}
                                        <span>
                                          $
                                          {userfilter?.min_trade_amount
                                            ? userfilter?.min_trade_amount
                                            : "0.00"}
                                        </span>
                                      </li>
                                      <li>
                                        {t("Max Profit")}{" "}
                                        <span>
                                          $
                                          {userfilter?.max_profit
                                            ? userfilter?.max_profit
                                            : "0.00"}
                                        </span>
                                      </li>
                                      {/* <li></li> */}
                                    </ul>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="trading_profileViewHor withdrawal_form">
                    <div className="col-lg-6 col-md-6 text-white">
                      {t("Copy Setting")}
                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="mb-3">
                          <label
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            {t("Copy in proportion")} :
                            <span>{t("(1-200%)")}</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter percentage"
                              value={
                                copysetting?.proportion
                                  ? `${copysetting?.proportion}`
                                  : ""
                              }
                              onChange={handleChange}
                            />
                            <span
                              class="input-group-text"
                              id="basic-addon2"
                              style={{
                                backgroundColor: "#474451",
                                border: "#474451",
                                color: "#fff",
                              }}
                            >
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="mb-3">
                          <label
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            {t("Stop Balance")}:{" "}
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder={t("Stop Balance")}
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              value={
                                copysetting?.stop_balance
                                  ? /,/.test(copysetting.stop_balance)
                                    ? copysetting.stop_balance
                                    : formatPricewithdesimal(
                                        copysetting.stop_balance,
                                      )
                                  : ""
                              }
                              onChange={(e) => {
                                let rawValue = e.target.value.replace(
                                  /[^0-9.]/g,
                                  "",
                                );
                                if ((rawValue.match(/\./g) || []).length > 1)
                                  return;
                                if (rawValue.startsWith(".")) {
                                  rawValue = "0" + rawValue;
                                }

                                handlecopychange("stop_balance", rawValue);
                              }}
                            />
                            <span
                              class="input-group-text"
                              id="basic-addon2"
                              style={{
                                backgroundColor: "#474451",
                                border: "#474451",
                                color: "#fff",
                              }}
                            >
                              $
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="mb-3">
                          <label
                            className={`${
                              copysetting?.bothamount_error ? "text-danger" : ""
                            }`}
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            {t("Min. copy trade amount")}:{" "}
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control"
                              placeholder={t("Min. copy trade amount")}
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              value={
                                copysetting?.min_trade_amount
                                  ? /,/.test(copysetting.min_trade_amount)
                                    ? copysetting.min_trade_amount
                                    : formatPricewithdesimal(
                                        copysetting.min_trade_amount,
                                      )
                                  : ""
                              }
                              onChange={(e) => {
                                const rawValue = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );
                                if (!/^\d*$/.test(rawValue)) return;
                                handlecopychange(
                                  "min_trade_amount",
                                  e.target.value,
                                );
                              }}
                            />
                            <span
                              class="input-group-text"
                              id="basic-addon2"
                              style={{
                                backgroundColor: "#474451",
                                border: "#474451",
                                color: "#fff",
                              }}
                            >
                              $
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="mb-3">
                          <label
                            className={`${
                              copysetting?.bothamount_error ? "text-danger" : ""
                            }`}
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            {t("Max. copy trade amount")}:{" "}
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder={t("unlimited")}
                              aria-label="Recipient's username"
                              aria-describedby="basic-addon2"
                              value={
                                copysetting?.max_copy_trade_value !==
                                  undefined &&
                                copysetting?.max_copy_trade_value !== null &&
                                copysetting?.max_copy_trade_value !== 0
                                  ? /,/.test(copysetting.max_copy_trade_value)
                                    ? copysetting.max_copy_trade_value
                                    : formatPricewithdesimal(
                                        copysetting.max_copy_trade_value,
                                      )
                                  : ""
                              }
                              onChange={(e) => {
                                const rawValue = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );
                                if (!/^\d*$/.test(rawValue)) return;

                                handlecopychange(
                                  "max_copy_trade_value",
                                  e.target.value ? e.target.value : 0,
                                );
                              }}
                            />
                            <span
                              class="input-group-text"
                              id="basic-addon2"
                              style={{
                                backgroundColor: "#474451",
                                border: "#474451",
                                color: "#fff",
                              }}
                            >
                              $
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div>
                          <p
                            style={{
                              fontSize: "13px",
                              lineHeight: "15px",
                              marginBottom: "0",
                            }}
                          >
                            {t("You will copy")}
                          </p>
                          <p
                            className="text-white"
                            style={{ fontSize: "15px" }}
                          >
                            {copysetting?.proportion}%{" "}
                            {t("of the provider's trade amount")}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontSize: "13px",
                              lineHeight: "15px",
                              marginBottom: "0",
                            }}
                          >
                            {t("Min. amount for copy trading")}
                          </p>
                          <p
                            className="text-white"
                            style={{ fontSize: "15px" }}
                          >
                            $
                            {copysetting?.checkminamount ||
                            Number(
                              unformatPrice(copysetting?.min_totel_amount),
                            ) < 1
                              ? copysetting?.min_trade_amount
                              : copysetting?.min_totel_amount
                                ? copysetting?.min_totel_amount
                                : parseFloat(
                                    (100 *
                                      Number(copysetting?.min_trade_amount)) /
                                      Number(copysetting?.proportion),
                                  ).toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div>
                          <p
                            style={{
                              fontSize: "13px",
                              lineHeight: "15px",
                              marginBottom: "0",
                            }}
                          >
                            {t("Copying will stop if the balance is less than")}
                          </p>
                          <p
                            className="text-white"
                            style={{ fontSize: "15px" }}
                          >
                            $
                            {copysetting?.stop_balance
                              ? /,/.test(copysetting.stop_balance)
                                ? copysetting.stop_balance
                                : formatPrice(copysetting.stop_balance)
                              : 0.0}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontSize: "13px",
                              lineHeight: "15px",
                              marginBottom: "0",
                            }}
                          >
                            {t("Max. amount for copy trading")}
                          </p>
                          <p style={{ fontSize: "15px" }}>
                            $
                            {copysetting?.max_copy_trade_value !== undefined &&
                            copysetting?.max_copy_trade_value !== null &&
                            copysetting?.max_copy_trade_value !== 0
                              ? copysetting?.checkmaxamount ||
                                Number(
                                  unformatPrice(copysetting?.max_totel_amount),
                                ) < 1
                                ? copysetting?.max_copy_trade_value
                                : copysetting?.max_totel_amount
                                  ? copysetting?.max_totel_amount
                                  : parseFloat(
                                      (Number(copysetting?.proportion) > 100
                                        ? 200
                                        : 100 *
                                          Number(
                                            copysetting?.max_copy_trade_value,
                                          )) / Number(copysetting?.proportion),
                                    ).toFixed(2)
                              : "unlimited"}
                            {/* {copysetting?.max_copy_trade_value !== undefined &&
                            copysetting?.max_copy_trade_value !== null &&
                            copysetting?.max_copy_trade_value !== 0
                              ? copysetting.max_copy_trade_value
                              : "unlimited"} */}
                          </p>
                        </div>
                      </div>
                      <div className="col-12">
                        <p className="text-white">
                          {t("Provider's trade less than")} $
                          {copysetting?.checkminamount ||
                          Number(unformatPrice(copysetting?.min_totel_amount)) <
                            1
                            ? copysetting?.min_trade_amount
                            : copysetting?.min_totel_amount
                              ? copysetting?.min_totel_amount
                              : parseFloat(
                                  (Number(copysetting?.proportion) > 100
                                    ? 200
                                    : 100 *
                                      Number(copysetting?.min_trade_amount)) /
                                    Number(copysetting?.proportion),
                                ).toFixed(2)}{" "}
                          {t("will not be copied.")}
                          <br />
                          {copysetting?.max_copy_trade_value !== undefined &&
                          copysetting?.max_copy_trade_value !== null &&
                          copysetting?.max_copy_trade_value !== 0
                            ? copysetting?.checkmaxamount ||
                              Number(
                                unformatPrice(copysetting?.max_totel_amount),
                              ) < 1
                              ? copysetting?.max_copy_trade_value
                              : copysetting?.max_totel_amount
                                ? `Providers trades above than $${copysetting?.max_totel_amount} will not be copied`
                                : `Providers trades above than $${parseFloat(
                                    (Number(copysetting?.proportion) > 100
                                      ? 200
                                      : 100 *
                                        Number(
                                          copysetting?.max_copy_trade_value,
                                        )) / Number(copysetting?.proportion),
                                  ).toFixed(2)} will not be copied`
                            : "Maximum trade is unlimited"}
                          {/* {copysetting?.max_copy_trade_value !== undefined &&
                          copysetting?.max_copy_trade_value !== null &&
                          copysetting?.max_copy_trade_value !== 0
                            ? copysetting.max_copy_trade_value
                            : "unlimited"} */}
                          .
                        </p>
                      </div>
                      <div className="col-12">
                        <div className="btnsGroupPop">
                          <button
                            onClick={() => copytrade(copysetting)}
                            type="button"
                            className={`btn btnBorder green-btn ${
                              copybuttion ? "active" : ""
                            }`}
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Loading...
                              </>
                            ) : (
                              <span>{t("Confirm")}</span>
                            )}
                          </button>
                          <button
                            type="button"
                            className="btn btnBorder"
                            onClick={() => setCheckcopy(false)}
                          >
                            <span>{t("Back")}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Join Us Modal end */}

      {/* Leader Board Start */}
      <div
        ref={collapseleaderboardRef}
        id="leaderBoardCollapse"
        onScroll={handleScroll}
        xample
        styles
        to
        make
        it
        scrollable
        className={`collapsePop collapse  ${collapseOpen ? "show" : ""}  ${
          isOnScroll ? "onscroll" : ""
        }
              ${isHovering ? "active" : ""}`}
      >
        <div
          className="leaderBoardHover"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <div className="popheader">
            <button
              className="btn closebtn"
              data-bs-toggle="collapse"
              // href="#leaderBoardCollapse"
              aria-expanded="false"
              aria-controls="leaderBoardCollapse"
              // onClick={() => {
              //   handleToggleCollapse("leaderBoardCollapse");

              // }}
            >
              <svg
                onClick={() => setCollapseOpen(false)}
                width="45"
                height="46"
                viewBox="0 0 45 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.9697 28.6569L28.2834 17.3432"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.2834 28.6568L16.9697 17.3431"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <h5 className="collapseTitle position-relative">
              <label>
                {t("Leaderboard")}
                <br />
                <span>{t("Of the Day")}</span>
              </label>
            </h5>
            {/* <!-- <h5 className="collapseTitle">Profit & Loss</h5> --> */}
          </div>
          {checkleaderboaed?.hide_leaderboaed ? (
            <>
              <div className="topranking">
                {gettopperdata?.length
                  ? gettopperdata.map((result, key) => {
                      return (
                        <div
                          className={`toprankUser ${
                            result?.rank === 2
                              ? "rank02"
                              : result?.rank === 1
                                ? "rank01 topPos"
                                : result?.rank === 3
                                  ? "rank03"
                                  : ""
                          }`}
                        >
                          <div className="topranking-icon">
                            <img
                              style={{
                                borderRadius: "32px",
                              }}
                              src={
                                result?.user?.profile
                                  ? process.env.REACT_APP_IMAGE_URL +
                                    result?.user?.profile
                                  : user
                              }
                              alt=""
                            />
                          </div>
                          <h5>
                            #{result?.user_id}{" "}
                            <span>
                              <img src={ninjacoin} alt="" /> $
                              {formatPrice(result?.profit_loss, 2)}
                            </span>
                          </h5>
                        </div>
                      );
                    })
                  : ""}
              </div>
              <div class="leaderBoardTopbar">
                <div className="ranking-user-profile">
                  <div className="ranking-user-profile-inner">
                    <div className="user-ranking">
                      <img
                        src={
                          currentuser?.user?.profile
                            ? process.env.REACT_APP_IMAGE_URL +
                              currentuser?.user?.profile
                            : user
                        }
                        className="ranking-user"
                        alt=""
                      />
                      <div className="ranking-user-name">
                        {formatName(currentuser?.user?.name)}
                        <br />$
                        {currentuser?.profit_loss
                          ? formatPrice(currentuser?.profit_loss, 2)
                          : 0}
                      </div>
                    </div>
                    <div className="ranking-price">
                      {t("Position")}:{" "}
                      <strong>
                        {checkleaderboaed?.rank
                          ? currentuser?.rank > 20 || !currentuser?.rank
                            ? "..."
                            : currentuser?.rank
                          : currentuser?.rank
                            ? currentuser?.rank
                            : 0}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="leaderBoardBg">
                <div class="rankingSecScroll">
                  <div className="ranking-table">
                    <ul className="ranking-items">
                      <li className="ranking-titleLi">
                        <h6 className="title">{t("Ranking")}</h6>
                        <h6 className="title">{t("PNL")}</h6>
                      </li>
                      {leaderboarddata?.length ? (
                        leaderboarddata.map((result, key) => {
                          return (
                            <li
                              onClick={() => {
                                openModal("socialTradingview_popup");
                                setShowcopydeleteicon(false);
                                setModelloading(true);
                                userdetailsfromid(
                                  result?.user_id,
                                  result?.rank,
                                  "today",
                                  false,
                                );
                              }}
                              className={`ranking-list ${
                                result?.rank === 1
                                  ? "ranking01-list"
                                  : result?.rank === 2
                                    ? "ranking02-list"
                                    : result?.rank === 3
                                      ? "ranking03-list"
                                      : ""
                              }  ${
                                isHovered?.[result?.user_id] ? "active" : ""
                              }`}
                              // data-bs-toggle="modal"
                              // data-bs-target="#socialTradingview_popup"
                              onMouseEnter={() =>
                                handleMouseEnter(result?.user_id)
                              }
                              onMouseLeave={() =>
                                handleMouseLeave(result?.user_id)
                              }
                            >
                              <div className="hover_tooltip">
                                <div className="hover_tooltip_inner">
                                  <div className="ranking-list">
                                    <div className="ranking-list_inner">
                                      <div className="user-ranking">
                                        <img
                                          src={
                                            result?.user?.profile
                                              ? process.env
                                                  .REACT_APP_IMAGE_URL +
                                                result?.user?.profile
                                              : user
                                          }
                                          className="ranking-user"
                                          alt=""
                                        />
                                        <div className="ranking-user-name">
                                          <small>
                                            {formatName(userdata?.user_name)}
                                          </small>
                                          <br />
                                          {/* @{userdata?.user_name} */}
                                        </div>
                                      </div>
                                      {result?.rank === 1 ? (
                                        <img
                                          src={rankingstaricon01}
                                          className="user-star-icon"
                                          alt=""
                                        />
                                      ) : result?.rank === 2 ? (
                                        <img
                                          src={rankingstaricon02}
                                          className="user-star-icon"
                                          alt=""
                                        />
                                      ) : result?.rank === 3 ? (
                                        <img
                                          src={rankingstaricon03}
                                          className="user-star-icon"
                                          alt=""
                                        />
                                      ) : (
                                        ""
                                      )}
                                      {/* <img
                                      src={
                                        result?.rank === 1
                                          ? rankingstaricon01
                                          : result?.rank === 2
                                          ? rankingstaricon02
                                          : result?.rank === 3
                                          ? rankingstaricon03
                                          : ""
                                      }
                                      className="user-star-icon"
                                      alt=""
                                    /> */}
                                    </div>
                                  </div>
                                  <div className="ranking-list bottomList">
                                    <div className="ranking-list_inner">
                                      <div className="user-ranking">
                                        <div className="ranking-user-name">
                                          {userdata?.trades_count}
                                          <br />
                                          <small>{t("Trades Count")}</small>
                                        </div>
                                        <div className="ranking-user-name">
                                          {userdata?.profitable_trades}
                                          <br />
                                          <small>
                                            {t("Profitable Trades")}
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="ranking-list bottomList">
                                    <div className="ranking-list_inner">
                                      <div className="user-ranking">
                                        <div className="ranking-user-name">
                                          ${userdata?.trades_profit}
                                          <br />
                                          <small>{t("Trades Profit")}</small>
                                        </div>
                                        <div className="ranking-user-name">
                                          ${userdata?.average_profit}
                                          <br />
                                          <small>{t("Average Profit")}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="ranking-list bottomList">
                                    <div className="ranking-list_inner">
                                      <div className="user-ranking">
                                        <div className="ranking-user-name">
                                          ${userdata?.min_trade_amount}
                                          <br />
                                          <small>{t("Min Trade Amount")}</small>
                                        </div>
                                        <div className="ranking-user-name">
                                          ${userdata?.max_trade_amount}
                                          <br />
                                          <small>{t("Max Trade Amount")}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="ranking-list_inner">
                                <div className="user-ranking">
                                  {result?.rank === 1 ||
                                  result?.rank === 2 ||
                                  result?.rank === 3 ? (
                                    <div className="ranking-animationimg">
                                      {result?.rank === 1 ? (
                                        <img
                                          src={rankingstaricon01}
                                          className="user-star-icon"
                                          alt=""
                                        />
                                      ) : result?.rank === 2 ? (
                                        <img
                                          src={rankingstaricon02}
                                          className="user-star-icon"
                                          alt=""
                                        />
                                      ) : result?.rank === 3 ? (
                                        <img
                                          src={rankingstaricon03}
                                          className="user-star-icon"
                                          alt=""
                                        />
                                      ) : (
                                        ""
                                      )}

                                      {/* <!-- <img src="images/animation-img01.gif" className="animation-img"> --> */}
                                    </div>
                                  ) : (
                                    <span className="user-ranking-number">
                                      {result?.rank}
                                    </span>
                                  )}
                                  {/* <!-- <img src={rankingstaricon01} className="user-star-icon"> --> */}

                                  <img
                                    src={
                                      result?.user?.profile
                                        ? process.env.REACT_APP_IMAGE_URL +
                                          result?.user?.profile
                                        : user
                                    }
                                    className="ranking-user"
                                    alt=""
                                  />
                                  <div className="ranking-user-name">
                                    {result?.user?.name
                                      ? formatName(result?.user?.name)
                                      : ""}
                                  </div>
                                </div>

                                <div className="ranking-price">
                                  {result?.user?.id ===
                                  currentuser?.user?.id ? (
                                    <>
                                      <span
                                        className=""
                                        style={{
                                          display: "flex",
                                          gap: "5px",
                                          alignItems: "center",
                                        }}
                                      >
                                        {currentuser?.previous_rank === 0
                                          ? currentuser?.rank
                                          : currentuser?.previous_rank -
                                            currentuser?.rank}
                                        {currentuser?.previous_rank === 0 ? (
                                          ""
                                        ) : currentuser?.previous_rank -
                                            currentuser?.rank >
                                          0 ? (
                                          <i className="fa-solid fa-caret-up text_green"></i>
                                        ) : currentuser?.previous_rank -
                                            currentuser?.rank !==
                                          0 ? (
                                          <i
                                            className="fa-solid fa-caret-down"
                                            style={{ color: "red" }}
                                          ></i>
                                        ) : (
                                          ""
                                        )}
                                        <span className="badge me-1">
                                          {t("You")}
                                        </span>{" "}
                                      </span>{" "}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  $
                                  {result?.profit_loss
                                    ? formatPrice(result?.profit_loss, 2)
                                    : ""}
                                </div>
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <p className="text-danger text-center">
                          Data Not Found
                        </p>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p className="text-danger text-center">
              {t("Currently not available")}
            </p>
          )}
        </div>
      </div>
      {/* Leader Board End */}

      {/* Hotkeys Modal start */}
      <div
        ref={(el) => (modalRefs.current["hotkeysModal"] = el)}
        className="modal fade"
        id="hotkeysModal"
        tabindex="-1"
        aria-labelledby="joinUsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title mb-3">
                {t("Hotkeys")} {activekeys ? t("[Active]") : t("[Inactive]")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <img src={hotkeys} className="hot-keys-img" alt="" />
                </div>
                <div className="col-lg-7 col-md-12">
                  <h5 className="modal-title mb-3">{t("Configuration")}</h5>
                  <ul className="hotkeys_option">
                    <li>
                      <h4 className="m-0">Shift + W</h4>
                      <p className="m-0">buy (New trade)</p>
                    </li>
                    <li>
                      <h4 className="m-0">Shift + S</h4>
                      <p className="m-0">sell (New trade)</p>
                    </li>
                    <li>
                      <h4 className="m-0">Shift + A</h4>
                      <p className="m-0">{t("Decrease trade amount")}</p>
                    </li>
                    <li>
                      <h4 className="m-0">Shift + D</h4>
                      <p className="m-0">{t("Increase trade amount")}</p>
                    </li>
                    <li>
                      <h4 className="m-0">Shift + TAB</h4>
                      <p className="m-0">{t("Next favorite asset")}</p>
                    </li>
                  </ul>
                  <div className="btnsGroup hotkeysactive mt-3">
                    {activekeys ? (
                      <Link
                        className="btn green_btn"
                        to=""
                        style={{
                          border: "1px solid #840808",
                          color: "#e52222",
                          fontWeight: 400,
                          width: "fit-content",
                          boxShadow: "0 0 14px inset #e52222",
                        }}
                        onClick={(e) => {
                          hotkeysset(0);
                          e.preventDefault();
                        }}
                      >
                        {t("Deactivate hotkeys")}
                      </Link>
                    ) : (
                      <Link
                        className="btn green_btn"
                        to=""
                        onClick={(e) => {
                          hotkeysset(1);
                          e.preventDefault();
                        }}
                      >
                        {t("Activate hotkeys")}
                      </Link>
                    )}
                  </div>

                  <div className="search_options_Enable">
                    <div className="form-check form-switch form-switch-left pb-0 mb-0 mt-3">
                      <div className="check-input-div">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={searchpopup}
                          onChange={(e) => searchprefrence(e.target.checked)}
                        />
                      </div>
                      <label className="form-check-label">
                        {t("Type to search")}{" "}
                      </label>
                      {/* <img src={info}/> */}

                      <span className="btn p-0">
                        <span className="toolTip01">
                          Select trading pairs by just directly typing on
                          keyboard
                        </span>
                        <img src={info} alt="Information" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboardrightsidemenus;
